import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'; // Adiciona useRef, useMemo e useCallback
import { Button, Table, Tab, Tabs, Form, ListGroup, Spinner, Modal, Dropdown, Row, Col, Alert, InputGroup, Accordion, Badge, Toast, ToastContainer, OverlayTrigger, Tooltip, Card, ButtonGroup, Popover } from 'react-bootstrap'; // Adicionado Toast e ToastContainer
import { useNavigate } from 'react-router-dom'; // Adicionado para navegação
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck, faCalendarAlt, faUserMd, faDollarSign, faBan, faMoneyBillWave, faBullhorn, faStethoscope, faExpand, faCheckCircle, faArrowLeft, faPhone, faEnvelope, faIdCard, faClock, faBars } from '@fortawesome/free-solid-svg-icons';

import { useUserContext } from '../../UserContext';
import { useAuthContext } from '../../context/AuthContext';
import { useEntidadeContext } from '../../EntidadeContext';
import { usePacienteContext } from '../../PacienteContext';
import { useAlertModal } from '../../AlertModalContext';

import PaymentModal from '../../pages/PaymentModal';
import CommunicationModal from './CommunicationModal';
import ProntuarioVisualizacaoModal from './ProntuarioVisualizacaoModal';

import addPatientIcon from '../../img/icoPlusPaciente.jpg';
import '../../Agendas.css';

// Função para normalizar strings (remover acentos e converter para minúsculas) para a busca
function normalizeString(str) {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

const formatCurrency = (value) => {
  // Garante que o valor seja um número antes de formatar
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value) || 0);
};

// Helper function to determine the current period of the day
const getCurrentPeriod = () => {
  const currentHour = new Date().getHours();
  if (currentHour <= 12) {
    return 'Manhã';
  } else if (currentHour <= 17) {
    return 'Tarde';
  } else {
    return 'Noite';
  }
};

// Função auxiliar para definir a cor do badge com base no status do agendamento
const getStatusColors = (status) => {
  // Normaliza o status removendo espaços em branco nas extremidades e garantindo que seja string
  const normalizedStatus = status ? String(status).trim() : '';

  switch (normalizedStatus) {
    case 'Realizada':
      return { bg: '#5ab46f', text: '#fff' }; // Verde vibrante
    case 'Em andamento':
      return { bg: '#ffc107', text: '#000' }; // Amarelo vibrante
    case 'Agendada':
      return { bg: '#609df8', text: '#fff' }; // Azul vibrante
    case 'Cancelada':
      return { bg: '#ee969f', text: '#fff' }; // Vermelho vibrante
    case 'Faltou':
      return { bg: '#343a40', text: '#fff' }; // Escuro
    case 'Desmarcada':
      return { bg: '#6c757d', text: '#fff' }; // Cinza
    case 'Aguardando Pagamento':
      return { bg: '#0dcaf0', text: '#000' }; // Ciano vibrante
    default:
      // Log para identificar o que está chegando errado (verifique o console do navegador)
      console.warn(`[getStatusColors] Caiu no default. Valor recebido: "${status}" | Tipo: ${typeof status}`);
      return { bg: '#f8f9fa', text: '#000' }; // Claro
  }
};

const SidebarActionButton = ({ onClick, disabled, loading, icon, label, color, bg, border }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        style={{
            width: '100%', padding: '9px 12px', borderRadius: '8px',
            backgroundColor: disabled ? '#f9fafb' : bg,
            border: `1px solid ${disabled ? '#e5e7eb' : border}`,
            color: disabled ? '#9ca3af' : color,
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
            display: 'flex', alignItems: 'center', gap: '8px',
            transition: 'all 0.15s',
            opacity: disabled ? 0.6 : 1,
        }}
        onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.85'; }}
        onMouseLeave={e => { if (!disabled) e.currentTarget.style.opacity = '1'; }}
    >
        {loading ? (
            <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
        ) : (
            <FontAwesomeIcon icon={icon} style={{ fontSize: `calc(11px * var(--font-scale))`, width: '14px' }} />
        )}
        {label}
    </button>
);

const AgendasCardTab = ({
  isActive,
  especialidades,
  todosMedicos,
  allFuncionarios, // Adiciona a nova prop aqui
  servicos,
  pacientesList, // Recebe a lista de pacientes do pai
  selectedEspecialidade, // Recebe o estado do pai
  setSelectedEspecialidade, // Recebe o setter do pai
  selectedMedico, // Recebe o estado do pai
  setSelectedMedico, // Recebe o setter do pai
  selectedDate, // Recebe o estado do pai
  setSelectedDate, // Recebe o setter do pai
  calendarAppointments, // Recebe os agendamentos do dia do pai
  isLoadingCalendarData, // Recebe o loading do pai
  onAppointmentCreated, // Callback para o pai
  onAppointmentStatusChange, // Callback para o pai
  onAppointmentFinalized, // Callback para o pai 
  onPatientCreated, // NOVO: Callback para notificar a criação de um novo paciente
  refreshKey, // NOVO: Recebe a chave de atualização do pai
  isCurrentUserCorpoClinico, // Recebe a flag do pai
  ordemDeChegada, // Prop para a nova aba
  isLoadingOrdemDeChegada, // Prop para a nova aba
  // All other props remain the same
  horariosAtendimento, // Recebe do pai
  totalSlotsDisponiveis, // Recebe do pai,
  onPatientInterestsUpdate, 
  feriadosNacionais, // Recebe do pai
  getFeriadoNome, // Recebe do pai (agora dinâmico)
  isDiaBloqueado, // NOVO: Recebe do pai
  agendaHorariosGerados, // NOVO: Recebe do pai
}) => {
  const { showAlertModal } = useAlertModal();

  const { currentEntidade } = useEntidadeContext(); // Usar contexto
  const { currentUserRole, getPermittedInternalTabs } = useUserContext(); // Mantém para a role, se ainda for útil separadamente
  const navigate = useNavigate(); // Adicionado para navegação
  const { loggedInUser: currentUser } = useAuthContext(); // Obter o usuário completo do AuthContext
  const { setPacienteSelecionado } = usePacienteContext(); // Importe o hook

  // useMemo to determine the default active accordion key based on the current time
  const defaultActiveAccordionKey = useMemo(() => getCurrentPeriod(), []);

  // Obter permissões do módulo Consultório para controlar botões
  const consultorioPermissions = useMemo(() =>
      getPermittedInternalTabs('consultorio', currentUserRole),
    [getPermittedInternalTabs, currentUserRole]
  );

  const canShowPayButton = useMemo(() => 
    consultorioPermissions.some(p => p.key === 'show_botao_pagar'), 
  [consultorioPermissions]);

  const canShowCancelPayButton = useMemo(() => 
    consultorioPermissions.some(p => p.key === 'show_botao_cancelar_pagamento'), 
  [consultorioPermissions]);

  // Estados locais do componente
  const [showCalendarModal, setShowCalendarModal] = useState(false); // Estado para o modal do calendário
  const [loadingIniciarConsulta, setLoadingIniciarConsulta] = useState({});
  const [loadingCheckIn, setLoadingCheckIn] = useState({}); // Novo estado para o loading do check-in
  const [showCreatePatientModal, setShowCreatePatientModal] = useState(false);
  const [isCreatingPatient, setIsCreatingPatient] = useState(false); // NOVO: Estado para o loading do cadastro de paciente
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedAppointmentForPayment, setSelectedAppointmentForPayment] = useState(null);

  const [selectedServicos, setSelectedServicos] = useState([]); // Add state to hold selected service IDs
  const [allInteresses, setAllInteresses] = useState([]); // Estado para todos os interesses

  // Estados para o modal de reagendamento
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [appointmentToReschedule, setAppointmentToReschedule] = useState(null);
  const [newScheduleDate, setNewScheduleDate] = useState(new Date());
  const [newAvailableSlots, setNewAvailableSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [selectedNewTime, setSelectedNewTime] = useState(null);
  const [isLoadingReschedule, setIsLoadingReschedule] = useState(false);

  const [localHorariosAtendimento, setLocalHorariosAtendimento] = useState(horariosAtendimento);
    const [isLoadingBulkWhatsApp, setIsLoadingBulkWhatsApp] = useState(false); // NOVO: Estado de loading para envio em massa

  // Estados locais para a aba "Todos os Médicos" (movidos do Consultorio.js)
  const [allAppointmentsForDay, setAllAppointmentsForDay] = useState([]);
  const [isLoadingAllAppointments, setIsLoadingAllAppointments] = useState(false);
  const [allAppointmentsError, setAllAppointmentsError] = useState(null);

  const [pacienteFilterSearch, setPacienteFilterSearch] = useState('');
  // --- NEW: View Logic (Day, 5-Day, Week, Month) ---
  const [fiveDayAppointments, setFiveDayAppointments] = useState([]);
  const [loadingFiveDays, setLoadingFiveDays] = useState(false);
  const [redLineTop, setRedLineTop] = useState(-1);
  const [activeStartDate, setActiveStartDate] = useState(new Date(selectedDate)); // Estado local para o mês do calendário
  const [availabilityData, setAvailabilityData] = useState({}); // Estado local para disponibilidade
  const [nextAvailableDate, setNextAvailableDate] = useState(null); // Estado local para próxima data
  const [calendarStatus, setCalendarStatus] = useState(null); // Estado local para status do dia
  
  // --- RESPONSIVIDADE ---
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isMobile = windowWidth < 576;
  const isTablet = windowWidth >= 576 && windowWidth < 992;
  const isDesktop = windowWidth >= 992;

  const [viewMode, setViewMode] = useState(isDesktop ? 'week' : 'day'); // 'day', 'week', 'month'
  const scrollRef = useRef(null); // Ref para o container de scroll

  const [activeTab, setActiveTab] = useState('agenda');
  const [showOnlyPendingPayment, setShowOnlyPendingPayment] = useState(false); // NOVO: Estado para o filtro de pagamento
  const [showActionsModal, setShowActionsModal] = useState(false);
  const [selectedAppointmentForActions, setSelectedAppointmentForActions] = useState(null);
  const [resizeState, setResizeState] = useState(null); // NOVO: Estado para redimensionamento
  const [draggedAppointment, setDraggedAppointment] = useState(null); // NOVO: Estado para drag and drop
  const [hoveredAppointmentId, setHoveredAppointmentId] = useState(null); // NOVO: Estado para hover do card
  const [contextMenu, setContextMenu] = useState(null); // NOVO: Estado para o menu de contexto
  const [showProntuarioModal, setShowProntuarioModal] = useState(false); // NOVO: Estado para o modal de prontuário
  const [patientForModal, setPatientForModal] = useState(null); // NOVO: Paciente selecionado para o modal
  const [selectedSidebarAppointment, setSelectedSidebarAppointment] = useState(null); // NOVO: Estado para controlar a visualização da sidebar
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // NOVO: controla o drawer
  const [showPackageHistoryModal, setShowPackageHistoryModal] = useState(false); // NOVO: Modal de histórico de pacotes
  const [packageHistoryData, setPackageHistoryData] = useState([]); // NOVO: Dados do histórico
  const [isLoadingPackageHistory, setIsLoadingPackageHistory] = useState(false); // NOVO: Loading do histórico
  const [sidebarDetails, setSidebarDetails] = useState({ services: [], total: 0, loading: false, valorAdicional: 0, valorDesconto: 0, valorJaPago: 0 }); // NOVO: Detalhes financeiros da sidebar

  // --- NOVOS ESTADOS PARA ADICIONAR COMISSÃO ---
  const [editingCommission, setEditingCommission] = useState({ paymentId: null, serviceId: null });
  const [selectedProfessionalForCommission, setSelectedProfessionalForCommission] = useState('');
  const [commissionPercentage, setCommissionPercentage] = useState('');
  const [isAddingCommission, setIsAddingCommission] = useState(false);
  const [commissionableEmployees, setCommissionableEmployees] = useState([]);

  // Garante que a visualização de mês não fique ativa em mobile/tablet
  useEffect(() => {
    if (!isDesktop && viewMode === 'month') {
        setViewMode('day');
    }
  }, [isDesktop, viewMode]);

  // --- NOVO: Configuração dinâmica do intervalo de horas baseada na entidade ---
  const { startHour, endHour } = useMemo(() => {
    if (!currentEntidade?.horarios || currentEntidade.horarios.length === 0) {
        return { startHour: 7, endHour: 23 }; // Fallback padrão
    }

    let min = 24;
    let max = 0;

    currentEntidade.horarios.forEach(h => {
        if (h.ativo) {
            // Verifica todos os horários de início e fim configurados
            const times = [
                h.manha_inicio, h.manha_fim,
                h.tarde_inicio, h.tarde_fim,
                h.noite_inicio, h.noite_fim
            ];
            
            times.forEach(t => {
                if (t) {
                    const hour = parseInt(t.split(':')[0], 10);
                    if (hour < min) min = hour;
                    if (hour > max) max = hour;
                }
            });
        }
    });

    // Se não encontrou horários válidos (ex: tudo inativo), usa o padrão
    if (min === 24) min = 7;
    if (max === 0) max = 23;

    return { startHour: min, endHour: max };
  }, [currentEntidade]);

  // --- NOVO: Intervalo de visualização da agenda (slots) ---
  const slotInterval = useMemo(() => {
    return currentEntidade?.intervalo_agenda || currentEntidade?.duracao_padrao_consulta || 60;
  }, [currentEntidade]);

  // Busca funcionários comissionáveis para o dropdown
  useEffect(() => {
    if (currentEntidade?.id) {
        axios.get(`/api/relatorios/funcionarios-comissionaveis`, { params: { entidade_id: currentEntidade.id } })
            .then(res => setCommissionableEmployees(res.data.funcionarios || []))
            .catch(console.error);
    }
  }, [currentEntidade]);

  //Cadastro novo agendamento
  const [newAppointment, setNewAppointment] = useState({ // Local state for the form
    entidade_id: currentEntidade ? currentEntidade.id : null, // Usa do contexto (ainda local para o formulário)
    filial_id: '', // Usar string vazia
    especialidade_id: selectedEspecialidade || '', // Usar string vazia se não selecionado
    medico_id: selectedMedico || '', // Usar string vazia se não selecionado
    paciente_id: '', // Usar string vazia
    data_agendamento: null,
    hora_marcada: '', // Usar string vazia
    tipo: 'Consulta', // Valor padrão, altere se necessário
    status: 'Agendada', // Valor padrão, altere se necessário
    interesses: [], // Adicionar campo de interesses
  });

  const [newPatient, setNewPatient] = useState({ // Este estado é local para o formulário de criação
    nome: '',
    cpf: '',
    data_nascimento: '',
    sexo: '',
    email: '',
    dddcelular: '',
    celular: '',
    endereco: '',
    op_convenio: ''
    // ... outros campos do paciente
  });

  // Estados para o campo de busca de paciente customizado
  const [pacienteSearch, setPacienteSearch] = useState('');
  const [showPacientesDropdown, setShowPacientesDropdown] = useState(false);
  const pacienteDropdownRef = useRef(null);

  // Novos estados para pacotes de sessões do paciente
  const [pacientePacotesAtivos, setPacientePacotesAtivos] = useState([]);
  const [isLoadingPacotes, setIsLoadingPacotes] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);

  // Handler genérico para campos de input do formulário de novo paciente
  const handleNewPatientInputChange = (e) => {
    const { name, value } = e.target;
    setNewPatient(prev => ({ ...prev, [name]: value }));
  };

  // Handler específico para o campo de telefone com máscara
  const handleNewPatientPhoneChange = (e) => {
    const value = e.target.value;
    // Remove todos os caracteres não numéricos para obter apenas os dígitos
    const justNumbers = value.replace(/\D/g, '');
    const ddd = justNumbers.substring(0, 2);
    const number = justNumbers.substring(2);
    setNewPatient(prev => ({ ...prev, dddcelular: ddd, celular: number }));
  };

  // Local states for search and filtering
  const [searchInput, setSearchInput] = useState(''); // ADDED
  const [filteredEspecialidades, setFilteredEspecialidades] = useState([]); // ADDED
  const [filteredMedicos, setFilteredMedicos] = useState([]); // ADDED
  const [localMedicos, setLocalMedicos] = useState([]); // ADDED (to hold filtered doctors for local search)

  const [showCalendarPopover, setShowCalendarPopover] = useState(false);
  const calendarPopoverRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarPopoverRef.current && !calendarPopoverRef.current.contains(event.target)) {
                setShowCalendarPopover(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  // Efeito para fechar o dropdown de pacientes ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pacienteDropdownRef.current && !pacienteDropdownRef.current.contains(event.target)) {
        setShowPacientesDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
 }, []);

    const [showModal, setShowModal] = useState(false); // ADDED

  // Efeito para buscar os pacotes ativos do paciente selecionado no modal
  useEffect(() => {
    const fetchPacotes = async () => {
      // Verifica se há um paciente selecionado no modal de novo agendamento
      if (showModal && newAppointment.paciente_id) {
        setIsLoadingPacotes(true);
        setPacientePacotesAtivos([]); // Limpa pacotes anteriores para evitar que serviços inativos persistam
        setSelectedServicos([]); // Limpa serviços selecionados ao trocar de paciente
        setSelectedPackageId(null);
        try {
          const response = await axios.get(`/api/pacientes/${newAppointment.paciente_id}/pacotes-ativos`);
          setPacientePacotesAtivos(response.data.pacotes_ativos || []);
        } catch (error) {
          console.error("Erro ao buscar pacotes do paciente:", error);
          setPacientePacotesAtivos([]); // Limpa em caso de erro
        } finally {
          setIsLoadingPacotes(false);
        }
      } else {
        // Limpa a lista de pacotes se não houver paciente selecionado ou se o modal fechar
        setPacientePacotesAtivos([]);
        setSelectedPackageId(null); // Limpa o pacote selecionado também
      }
    };

    fetchPacotes();
  }, [newAppointment.paciente_id, showModal]);

  // Efeito para buscar os interesses disponíveis
  useEffect(() => {
    const fetchInteresses = async () => {
      if (!currentEntidade || !showModal) return; // Só busca se o modal estiver aberto e a entidade carregada
      try {
        const response = await axios.get(`/api/interesses`); // A API já filtra pela entidade
        const formattedInteresses = (response.data.interesses || []).map(interesse => ({
          value: interesse.id,
          label: interesse.nome
        }));
        setAllInteresses(formattedInteresses);
      } catch (error) {
        console.error("Erro ao buscar tags de interesse:", error);
        setAllInteresses([]);
      }
    };
    fetchInteresses();
  }, [showModal, currentEntidade]);

  // Local states for new appointment modal
  const [isLoadingCreate, setIsLoadingCreate] = useState(false); // ADDED

  // NOVO: Estado para controlar se o modal foi aberto a partir de "Reutilizar Horário"
  const [isReusingSlot, setIsReusingSlot] = useState(false);

  // Função para navegar entre os meses e atualizar a data selecionada
  const handleMonthNavigation = (direction) => {
    // Baseia a navegação no mês atualmente visível no calendário (activeStartDate)
    const newActiveDate = new Date(activeStartDate);
    newActiveDate.setDate(1); // Define para o dia 1 para evitar problemas com meses de diferentes durações
    newActiveDate.setMonth(newActiveDate.getMonth() + direction);

    // Atualiza o mês de visualização do calendário E a data selecionada (para atualizar a lista de agendamentos)
    setActiveStartDate(newActiveDate);
    setSelectedDate(newActiveDate);
  };

  const handleGoToToday = () => {
    const today = new Date();
    setSelectedDate(today);
    setActiveStartDate(today);
  };

  const handleCheckIn = async (agendamentoId) => {
    setLoadingCheckIn(prev => ({ ...prev, [agendamentoId]: true }));
    try {
      const response = await axios.post(`/api/agendamentos/${agendamentoId}/check-in`);
      // Otimização: Passa o agendamento atualizado (com a hora_chegada) para o pai.
      // O pai (Consultorio.js) atualizará o estado localmente, evitando um re-fetch completo.
      onAppointmentStatusChange(response.data.agendamento);
      // showAlertModal('Sucesso', 'Check-in do paciente registrado!', 'success');
    } catch (error) {
      showAlertModal('Erro', `Falha ao registrar check-in: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setLoadingCheckIn(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };

  // Efeito para buscar TODOS os agendamentos do dia quando a aba "Todos os Médicos" estiver ativa
  useEffect(() => {
    const fetchAllAppointments = async () => {
        if (activeTab !== 'todos' || !currentEntidade) return;
        
        setIsLoadingAllAppointments(true);
        setAllAppointmentsError(null);
        try {
            const formattedDate = selectedDate.toISOString().split('T')[0];
            const response = await axios.get(`/api/agendamentos/entidade/${currentEntidade.id}/data/${formattedDate}`);
            setAllAppointmentsForDay(response.data.agendamentos || []);
        } catch (error) {
            console.error("Erro ao buscar todos os agendamentos:", error);
            setAllAppointmentsError("Erro ao carregar agendamentos.");
        } finally {
            setIsLoadingAllAppointments(false);
        }
    };
    fetchAllAppointments();
  }, [activeTab, selectedDate, currentEntidade, refreshKey]); // Adicionado refreshKey

  // Função auxiliar para encontrar a próxima data disponível (movida do Consultorio.js)
  const findNextAvailableDate = useCallback((startDate, endDate, currentAvailabilityData) => {
    let foundNextAvailable = null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let currentDate = new Date(Math.max(startDate.getTime(), today.getTime()));

    while (currentDate <= endDate) {
      const dateString = currentDate.toISOString().split('T')[0];
      const dayOfWeek = currentDate.getDay();
      const isHoliday = getFeriadoNome(currentDate);
      const count = currentAvailabilityData[dateString] || 0;
      if (dayOfWeek !== 0 && !isHoliday && count < totalSlotsDisponiveis) {
        foundNextAvailable = new Date(currentDate);
        break;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return foundNextAvailable;
  }, [getFeriadoNome, totalSlotsDisponiveis]);

  // Efeito para buscar a disponibilidade do MÊS INTEIRO (availabilityData)
  useEffect(() => {
    const fetchMonthAvailability = async () => {
      if (!selectedMedico || !activeStartDate || !currentEntidade) {
        setAvailabilityData({});
        setNextAvailableDate(null);
        return;
      }

      const year = activeStartDate.getFullYear();
      const month = activeStartDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);

      const startDateString = firstDayOfMonth.toISOString().split('T')[0];
      const endDateString = lastDayOfMonth.toISOString().split('T')[0];

      try {
        // Usa a rota unificada que já existe no backend
        const endpoint = `/api/agendamentos/entidade/${currentEntidade.id}/medico/${selectedMedico}/periodo?inicio=${startDateString}&fim=${endDateString}`;
        const response = await axios.get(endpoint);
        const monthAppointments = response.data.agendamentos || [];

        const dailyCounts = monthAppointments.reduce((acc, appointment) => {
          const date = appointment.data_agendamento;
          acc[date] = (acc[date] || 0) + 1;
          return acc;
        }, {});

        setAvailabilityData(dailyCounts);
        const newNextAvailable = findNextAvailableDate(firstDayOfMonth, lastDayOfMonth, dailyCounts);
        setNextAvailableDate(newNextAvailable);
      } catch (error) {
        console.error('Erro ao buscar disponibilidade do mês:', error);
      }
    };
    fetchMonthAvailability();
  }, [selectedMedico, activeStartDate, currentEntidade, findNextAvailableDate, refreshKey]); // Adicionado refreshKey para atualizar ao criar/editar

  // Agrupa os agendamentos da nova aba por médico
  const appointmentsByMedico = useMemo(() => {
    if (!allAppointmentsForDay) return {};
    return allAppointmentsForDay.reduce((acc, appointment) => {
      const medicoId = appointment.medico_id;
      if (!acc[medicoId]) {
        acc[medicoId] = [];
      }
      acc[medicoId].push(appointment);
      return acc;
    }, {});
  }, [allAppointmentsForDay]);

  // ── NOVO: filtra fiveDayAppointments pelo nome do paciente digitado na sidebar ──
    const pacienteFilteredAppointmentIds = useMemo(() => {
        if (!pacienteFilterSearch.trim()) return null; // null = sem filtro ativo
        const termo = normalizeString(pacienteFilterSearch);
        return new Set(
            fiveDayAppointments
                .filter(app => normalizeString(app.paciente?.nome || '').includes(termo))
                .map(app => app.id)
        );
    }, [pacienteFilterSearch, fiveDayAppointments]);


  // Efeito para definir o status do calendário (Feriado, Bloqueado, etc.)
  useEffect(() => {
    const feriadoNome = getFeriadoNome(selectedDate);
    const bloqueado = isDiaBloqueado(selectedDate);

    if (feriadoNome) {
      setCalendarStatus('Feriado');
    } else if (bloqueado) {
      setCalendarStatus('Bloqueado');
    } else {
      const dateString = selectedDate.toISOString().split('T')[0];
      if (availabilityData[dateString] >= totalSlotsDisponiveis) {
        setCalendarStatus('Sem vagas');
      } else {
        setCalendarStatus(null);
      }
    }
  }, [selectedDate, getFeriadoNome, isDiaBloqueado, availabilityData, totalSlotsDisponiveis]);

  // Estados para o novo modal unificado de comunicação
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  
  // NOVO: Estados para o modal de cancelamento de pagamento
  const [showCancelPaymentModal, setShowCancelPaymentModal] = useState(false);
  const [appointmentToCancelPayment, setAppointmentToCancelPayment] = useState(null);
  const [isCancelingPayment, setIsCancelingPayment] = useState(false);

  // NOVO: Estados para o modal de detalhes do pagamento
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);
  const [selectedPaymentDetails, setSelectedPaymentDetails] = useState(null);
  const [selectedAppointmentForDetails, setSelectedAppointmentForDetails] = useState(null);

  const handleServicoChange = (servicoId, pacoteId = null) => { // Este é um handler local para o modal de agendamento
    const isCurrentlySelected = selectedServicos.includes(servicoId);

    // Caso 1: Um serviço de pacote está sendo selecionado/desmarcado
    if (pacoteId) {
      if (isCurrentlySelected) {
        // Desmarcando o serviço do pacote
        setSelectedServicos([]);
        setSelectedPackageId(null);
      } else {
        // Marcando o serviço do pacote. Desmarca todos os outros.
        setSelectedServicos([servicoId]);
        setSelectedPackageId(pacoteId);
      }
    }
    // Caso 2: Um serviço normal está sendo selecionado/desmarcado
    else {
      // Se um pacote já estiver ativo, não permite adicionar serviços normais
      if (selectedPackageId) {
        return;
      }
      // Caso contrário, apenas alterna o serviço normal na lista
      setSelectedServicos(prev =>
        isCurrentlySelected ? prev.filter(id => id !== servicoId) : [...prev, servicoId]
      );
    }
  };

  // Função para abrir o modal de cadastro de paciente
  const handleOpenRescheduleModal = (appointment) => {
    setAppointmentToReschedule(appointment);
    // Inicializa o DatePicker com a data atual do agendamento, evitando problemas de fuso horário
    const [year, month, day] = appointment.data_agendamento.split('-').map(Number);
    setNewScheduleDate(new Date(year, month - 1, day));
    setSelectedNewTime(null);
    setShowRescheduleModal(true);
  };

  const handleCloseRescheduleModal = () => {
    setShowRescheduleModal(false);
    setAppointmentToReschedule(null);
    setSelectedNewTime(null);
    setNewAvailableSlots([]);
  };

  const handleOpenCreatePatientModal = () => {
    setShowCreatePatientModal(true);
  };

  // Função para fechar o modal de cadastro de paciente
  const handleCloseCreatePatientModal = () => {
    setShowCreatePatientModal(false);
    setNewPatient({
      nome: '',
      // ... outros campos do paciente
    });
  };

  // Função para lidar com a criação do paciente
  const handleCreatePatient = async () => {
    if (!currentEntidade) {
      showAlertModal('Erro', 'Nenhuma entidade selecionada. Não é possível criar o paciente.', 'danger');
      return;
    }
    try {
      setIsCreatingPatient(true); // Ativa o loading
      if (!newPatient.nome || !newPatient.cpf || !newPatient.email) {
        showAlertModal('Validação', 'Nome, CPF e Email são obrigatórios.', 'warning');
        // CORREÇÃO: Desativa o loading se a validação falhar.
        setIsCreatingPatient(false);
        return;
      }
      const patientDataWithEntity = { ...newPatient, entidade_id: currentEntidade.id };
      const response = await axios.post('/api/pacientes', patientDataWithEntity);
      const createdPaciente = response.data.paciente; // Define createdPaciente aqui
      handleCloseCreatePatientModal();

      // Notifica o componente pai (Consultorio.js) que um novo paciente foi criado.
      // O pai (Consultorio) chamará a função do EntidadeContext para atualizar a lista globalmente.
      if (onPatientCreated) {
        onPatientCreated(createdPaciente);
      }

      // Pré-seleciona o paciente recém-criado no modal de agendamento
      setNewAppointment(prevAppointment => ({ // Este setNewAppointment é para o modal de NOVO AGENDAMENTO
        ...prevAppointment,
        paciente_id: createdPaciente.id
      }));
    } catch (error) {
      console.error('Erro ao criar paciente:', error);
      showAlertModal('Erro de Conexão', `Erro ao criar paciente: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsCreatingPatient(false); // Desativa o loading
    }
  };

  const getTileClass = ({ date, view, getFeriadoNome, availabilityData, totalSlotsDisponiveis, nextAvailableDate }) => {
    // Ignora a aplicação de classes em visualizações diferentes de 'month'
    if (view !== 'month') {
      return '';
    }
    const validDate = date; // A data já é um objeto Date válido aqui

    // 1. Verifica se é feriado
    if (getFeriadoNome(validDate)) {
      return 'feriado';
    }

    // 2. Verifica se é um dia bloqueado especificamente
    if (isDiaBloqueado(validDate)) {
      return 'bloqueado';
    }

    // 3. Verifica se é um dia da semana inativo (sem horários)
    const diaDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][validDate.getDay()];
    const configDia = agendaHorariosGerados ? agendaHorariosGerados[diaDaSemana] : null;
    if (!configDia || (configDia['Manhã'].length === 0 && configDia['Tarde'].length === 0 && configDia['Noite'].length === 0)) {
      return 'bloqueado';
    }

    const formattedDateStringForAvailability = validDate.toISOString().split('T')[0];
    // Verifica a disponibilidade dinâmica (calculada para o mês) PRIMEIRO
    const appointmentCount = availabilityData[formattedDateStringForAvailability];
    if (appointmentCount !== undefined && appointmentCount >= totalSlotsDisponiveis) {
      return 'sem-vagas'; // Marca como sem vagas se estiver cheio dinamicamente
    }

    // Verifica se é o dia da próxima vaga encontrada
    const formattedNextAvailableDate = nextAvailableDate ? nextAvailableDate.toISOString().split('T')[0] : null;
    if (formattedNextAvailableDate && formattedDateStringForAvailability === formattedNextAvailableDate) {
      return 'vaga-proxima';
    }

    return ''; // Retorna uma string vazia por padrão se nenhuma outra condição for atendida
  };

  // Função para filtrar as datas no DatePicker do modal de reagendamento, agora com useCallback
  const filterRescheduleDates = useCallback((date) => {
    // Não permitir domingos
    if (date.getDay() === 0) {
      return false;
    }
    // Não permitir feriados
    if (getFeriadoNome(date)) {
      return false;
    }
    const dateString = date.toISOString().split('T')[0];

    // Não permitir dias sem vagas (baseado nos dados já carregados para o mês)
    const appointmentCount = availabilityData[dateString] || 0;
    if (appointmentCount >= totalSlotsDisponiveis) {
      return false;
    }

    // Se passar por todas as validações, a data é permitida
    return true;
  }, [getFeriadoNome, availabilityData, totalSlotsDisponiveis]);

  // Função para desabilitar datas no calendário principal (domingos e feriados)
  const isTileDisabled = useCallback(({ date, view }) => {
    if (view === 'month') {
      // 1. Desabilita feriados
      if (getFeriadoNome(date)) {
        return true;
      }
      // 2. Desabilita dias bloqueados
      if (isDiaBloqueado(date)) {
        return true;
      }
      // 3. Desabilita dias da semana inativos
      if (agendaHorariosGerados) {
        const diaDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][date.getDay()];
        const configDia = agendaHorariosGerados[diaDaSemana];
        if (!configDia || (configDia['Manhã'].length === 0 && configDia['Tarde'].length === 0 && configDia['Noite'].length === 0)) {
          return true;
        }
      }
    }
    return false;
  }, [getFeriadoNome, isDiaBloqueado, agendaHorariosGerados]);

  // useEffect para buscar horários disponíveis no modal de reagendamento
  useEffect(() => {
    if (!showRescheduleModal || !appointmentToReschedule || !currentEntidade) return;

    // Valida a data selecionada ANTES de buscar os horários.
    // Se a data não for válida (feriado, sem vagas, etc.), limpa os slots e interrompe.
    const isDateValid = filterRescheduleDates(newScheduleDate);
    if (!isDateValid) {
      setNewAvailableSlots([]); // Limpa os horários disponíveis
      setSelectedNewTime(null); // Reseta o horário selecionado
      return; // Interrompe a execução do useEffect
    }

    const fetchSlots = async () => {
      setIsLoadingSlots(true);
      try {
        const day = newScheduleDate.getDate().toString().padStart(2, '0');
        const month = (newScheduleDate.getMonth() + 1).toString().padStart(2, '0');
        const year = newScheduleDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        const response = await axios.get(`/api/agendamentos/entidade/${currentEntidade.id}/medico/${appointmentToReschedule.medico_id}/data/${formattedDate}`);

        const existingAppointments = response.data.agendamentos || [];
        const bookedTimes = existingAppointments.map(app => app.hora_marcada.slice(0, 5));

        let allSlots = Object.values(horariosAtendimento).flat();
        let availableSlots = allSlots.filter(slot => !bookedTimes.includes(slot));

        // Filtra horários que já passaram se a data selecionada for hoje
        const today = new Date();
        if (
          newScheduleDate.getDate() === today.getDate() &&
          newScheduleDate.getMonth() === today.getMonth() &&
          newScheduleDate.getFullYear() === today.getFullYear()
        ) {
          const now = new Date();
          const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
          availableSlots = availableSlots.filter(slot => slot > currentTime);
        }


        setNewAvailableSlots(availableSlots);
        setSelectedNewTime(null); // Reseta o horário selecionado quando a data muda
      } catch (error) {
        console.error("Erro ao buscar horários disponíveis para reagendamento:", error);
        setNewAvailableSlots([]);
      } finally {
        setIsLoadingSlots(false);
      }
    };

    fetchSlots();
  }, [newScheduleDate, showRescheduleModal, appointmentToReschedule, currentEntidade, horariosAtendimento, filterRescheduleDates]);

  const handleConfirmReschedule = async () => {
    if (!appointmentToReschedule || !newScheduleDate || !selectedNewTime) {
      showAlertModal('Erro', 'Selecione uma nova data e horário para reagendar.', 'warning');
      return;
    }

    setIsLoadingReschedule(true);
    try {
      const newDateFormatted = newScheduleDate.toISOString().split('T')[0];

      await axios.put(`/api/agendamentos/${appointmentToReschedule.id}`, {
        data_agendamento: newDateFormatted,
        hora_marcada: selectedNewTime,
      });

      showAlertModal('Sucesso', 'Agendamento remarcado com sucesso!', 'success');

      if (onAppointmentStatusChange) { onAppointmentStatusChange(); }
      handleCloseRescheduleModal();
    } catch (error) {
      showAlertModal('Erro', `Falha ao reagendar: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsLoadingReschedule(false);
    }
  };

  // Efeito para filtrar médicos por especialidade (local)
  useEffect(() => {
    setLocalMedicos(todosMedicos); // sempre todos os médicos disponíveis
    if (!isCurrentUserCorpoClinico) {
      setSelectedMedico('');
    }
}, [todosMedicos, isCurrentUserCorpoClinico, setSelectedMedico]);

  // Função para atualizar o estado quando o mês ativo do calendário muda
  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const newDate = activeStartDate;
    setActiveStartDate(currentActiveStateDate => {
      if (newDate.getFullYear() !== currentActiveStateDate.getFullYear() ||
        newDate.getMonth() !== currentActiveStateDate.getMonth()) {
        return newDate;
      }
      return currentActiveStateDate;
    });
  };

  // handleDateChange agora apenas atualiza a data selecionada
  const handleDateChange = (date) => { // Este setter agora é passado via props
    setSelectedDate(date); // Este setter agora é passado via props
  };

  const handleSearchInputChange = (event) => {
    setSelectedEspecialidade('');
    setSelectedMedico('');
    setSearchInput(event.target.value);
  };

  const handleEspecialidadeChange = (event) => { // Este setter agora é passado via props
    // setIsLoadingCalendar(true); // Loading é gerenciado pelo pai 
    setSelectedEspecialidade(event.target.value); // Este setter agora é passado via props
    setSelectedMedico(''); // Este setter agora é passado via props
    setSearchInput('');
  };

  const handleMedicoChange = (event) => { // Este setter agora é passado via props
    setSelectedMedico(event.target.value); // Este setter agora é passado via props
    setNextAvailableDate(null); // Limpa a próxima data ao trocar de médico
    setSearchInput('');
  };

  const handleProfissionalUnificadoChange = (opt) => {
        if (!opt) {
            // Limpou a seleção
            setSelectedMedico('');
            setSelectedEspecialidade('');
            setNextAvailableDate(null);
            return;
        }
        const medicoId   = opt.value;
        const medico     = todosMedicos.find(m => m.id === medicoId);
        const espId      = medico?.especialidade_id ? String(medico.especialidade_id) : '';
        setSelectedMedico(String(medicoId));
        setSelectedEspecialidade(espId);
        setNextAvailableDate(null);
    };

  useEffect(() => { // Uses local states: searchInput, filteredEspecialidades, filteredMedicos, localMedicos
    if (searchInput.length > 2) {
      const searchTerm = searchInput.toLowerCase();
      setFilteredEspecialidades(especialidades.filter(especialidade =>
        especialidade.nome.toLowerCase().includes(searchTerm)
      ));
      setFilteredMedicos(localMedicos.filter(medico => // Use localMedicos here
        medico.nome.toLowerCase().includes(searchTerm)
      ));
    } else {
      setFilteredEspecialidades([]);
      setFilteredMedicos([]);
    }
  }, [searchInput, especialidades, localMedicos]); // Dependency on localMedicos

  const getRowStyle = (appointment) => {
    if (!appointment) return {};

    switch (appointment.status) {
      case 'Faltou':
      case 'Cancelada':
      case 'Desmarcada':
        return { background: '#fd7e14' };
      case 'Realizada':
        return { background: '#6fa48b' };
      case 'Em andamento':
        return { background: '#bbdfa6' };
      default:
        return {};
    }
  };

  // //Cadastro novo agendamento
  // const [newAppointment, setNewAppointment] = useState({ // Local state for the form
  //   entidade_id: currentEntidade ? currentEntidade.id : null, // Usa do contexto (ainda local para o formulário)
  //   filial_id: '', // Usar string vazia
  //   especialidade_id: selectedEspecialidade || '', // Usar string vazia se não selecionado
  //   medico_id: selectedMedico || '', // Usar string vazia se não selecionado
  //   paciente_id: '', // Usar string vazia
  //   data_agendamento: null,
  //   hora_marcada: '', // Usar string vazia
  //   tipo: 'Consulta', // Valor padrão, altere se necessário
  //   status: 'Agendada', // Valor padrão, altere se necessário
  //   interesses: [], // Adicionar campo de interesses
  // });

  // Local states for new appointment modal
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null); // ADDED

  // Atualiza entidade_id no newAppointment quando currentEntidade mudar
  useEffect(() => {
    if (currentEntidade) {
      setNewAppointment(prev => ({ ...prev, entidade_id: currentEntidade.id }));
    }
  }, [currentEntidade]);

  // NOVO: Handler para os dropdowns de especialidade/médico dentro do modal
  const handleModalFormChange = (e) => {
    const { name, value } = e.target;
    setNewAppointment(prev => {
      const newState = { ...prev, [name]: value };
      // Se a especialidade mudou, reseta o médico
      if (name === 'especialidade_id') {
        newState.medico_id = '';
      }
      return newState;
    });
  };

  // Função para lidar com o clique em um horário vazio
  const handleTimeSlotClick = (horario, date, preSelectedMedicoId = null, preSelectedEspecialidadeId = null, isReusing = false) => {
    setIsReusingSlot(isReusing); // Define se é uma reutilização

    const targetMedico = preSelectedMedicoId || selectedMedico;
    const targetEspecialidade = preSelectedEspecialidadeId || selectedEspecialidade;

    // Se não for uma reutilização, mantém a validação original
    if (!isReusing) {
      if (!targetEspecialidade) {
        showAlertModal('Atenção', 'Por favor, selecione uma especialidade antes de agendar.', 'warning'); // selectedEspecialidade é prop
        return; // Impede a abertura do modal
      }
      if (!targetMedico) {
        showAlertModal('Atenção', 'Por favor, selecione um Médico antes de agendar.', 'warning');
        return; // Impede a abertura do modal
      }
    }

    // Validação para não agendar em dias passados, mas permitir no dia atual.
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Zera a hora para comparar apenas o dia

    const selectedDay = new Date(date || selectedDate);
    selectedDay.setHours(0, 0, 0, 0); // Zera a hora para comparar apenas o dia

    if (selectedDay < today) {
      showAlertModal('Horário Inválido', 'Não é possível agendar em um dia que já passou.', 'warning');
      return; // Impede a abertura do modal
    }

    const appointmentExists = calendarAppointments.some(a => 
      a.hora_marcada.slice(0, 5) === horario && 
      !['Cancelada', 'Faltou', 'Desmarcada'].includes(a.status)
    );
    if (!appointmentExists) {
      setSelectedTimeSlot(horario);
      setShowModal(true);
      setSelectedServicos([]); // Limpa os serviços selecionados ao abrir o modal

      // Preenche a data e hora no estado do novo agendamento
      setNewAppointment(prevAppointment => ({
        ...prevAppointment,
        especialidade_id: isReusing ? '' : (targetEspecialidade || ''),
        medico_id: isReusing ? '' : (targetMedico || ''),
        // --- CORREÇÃO: Formata a data manualmente para evitar problemas de fuso horário ---
        data_agendamento: [
          selectedDay.getFullYear(),
          (selectedDay.getMonth() + 1).toString().padStart(2, '0'),
          selectedDay.getDate().toString().padStart(2, '0')
        ].join('-'),
        // --- FIM DA CORREÇÃO ---
        hora_marcada: horario,
        paciente_id: '', // Reseta o paciente_id para string vazia
        interesses: [], // Reseta os interesses
      }));
    }
  };

  const handleFabClick = () => {
    const now = new Date();
    let targetDate = new Date(selectedDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (targetDate < today) {
        targetDate = today;
    }

    let defaultHour = now.getHours() + 1;
    if (targetDate > today) {
        defaultHour = 8;
    }
    
    if (defaultHour < startHour) defaultHour = startHour;
    if (defaultHour > endHour) defaultHour = endHour;

    const formattedTime = `${defaultHour.toString().padStart(2, '0')}:00`;
    handleTimeSlotClick(formattedTime, targetDate);
  };

  // Memo para obter o nome do paciente selecionado
  const selectedPacienteName = useMemo(() => {
    if (newAppointment.paciente_id) {
      const paciente = pacientesList.find(p => p.id === newAppointment.paciente_id);
      return paciente ? paciente.nome : '';
    }
    return '';
  }, [newAppointment.paciente_id, pacientesList]);

  // Efeito para preencher o campo de busca quando um paciente é selecionado (ou o modal é aberto)
  useEffect(() => {
    setPacienteSearch(selectedPacienteName);
  }, [selectedPacienteName]);

  // Memo para filtrar a lista de pacientes com base na busca
  const filteredPacientes = useMemo(() => {
    if (!pacienteSearch) return pacientesList;
    const termoNormalizado = normalizeString(pacienteSearch);
    return pacientesList.filter(paciente => normalizeString(paciente.nome).includes(termoNormalizado));
  }, [pacienteSearch, pacientesList]);

  // Função para lidar com o fechamento do modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTimeSlot(null);
    setIsReusingSlot(false); // Reseta o estado de reutilização
    setSelectedPackageId(null); // Limpa o pacote selecionado ao fechar
  };

  // Memo para criar a lista de opções de interesses, filtrando os que o paciente já possui.
  const filteredInteresseOptions = useMemo(() => {
    // Se nenhum paciente estiver selecionado no modal, não mostra nenhuma opção.
    if (!newAppointment.paciente_id) {
      return []; // Retorna array vazio para não mostrar opções antes de selecionar paciente.
    }
    // Encontra o paciente selecionado na lista completa de pacientes.
    const pacienteSelecionado = pacientesList.find(p => p.id === newAppointment.paciente_id);
  
    // Se o paciente não for encontrado ou não tiver interesses, retorna a lista completa de interesses disponíveis.
    if (!pacienteSelecionado || !pacienteSelecionado.interesses || pacienteSelecionado.interesses.length === 0) {
      return allInteresses;
    }
    const interessesAtuaisIds = new Set(pacienteSelecionado.interesses.map(i => i.id));
    // Filtra a lista de todas as opções, mantendo apenas aquelas cujo ID não está no Set.
    return allInteresses.filter(option => !interessesAtuaisIds.has(option.value));
  }, [allInteresses, newAppointment.paciente_id, pacientesList]);


  // Função para vincular interesses e notificar o pai para atualizar a lista de pacientes.
  const updatePatientInterests = async (pacienteId, novosInteresses) => {
    if (!novosInteresses || novosInteresses.length === 0) {
      return; // Não faz nada se não houver interesses a serem vinculados.
    }
    if (!pacienteId) {
      console.error("ID do paciente não fornecido para vincular interesses.");
      return;
    }

    // Extrai apenas os IDs dos interesses.
    const interessesIds = novosInteresses.map(tag => tag.value);

    try {
      // A nova rota dedicada espera apenas os IDs dos interesses.
      // O backend se encarregará de criar as entradas na tabela 'paciente_interesse'.
      await axios.post(`/api/pacientes/${pacienteId}/interesses`, {
        interesses: interessesIds, // Enviando um objeto JSON com a chave 'interesses'
      });


      // <<<<<<< NOVA LÓGICA >>>>>>>
      // Após o sucesso, chama o callback para atualizar o estado no componente pai.
      if (onPatientInterestsUpdate) {
        onPatientInterestsUpdate(pacienteId, novosInteresses);
      }
    } catch (error) {
      console.error(`Erro ao vincular interesses ao paciente ${pacienteId}:`, error);
      const errorMessage = error.response?.data?.message || 'Não foi possível vincular os interesses ao paciente.';
      showAlertModal('Erro', errorMessage, 'warning');
    }
  };

  // Função para lidar com a criação do agendamento
  const handleCreateAppointment = async () => {
    try {
      // Validação
      if (!newAppointment.paciente_id) {
        showAlertModal('Validação', 'Por favor, selecione um paciente.', 'warning');
        return;
      }
      // Validação de médico e especialidade movida para cá para funcionar com a reutilização
      if (!newAppointment.especialidade_id) {
        showAlertModal('Validação', 'Por favor, selecione uma especialidade.', 'warning');
        return;
      }
      if (!newAppointment.medico_id) {
        showAlertModal('Validação', 'Por favor, selecione um médico.', 'warning');
        return;
      }
      if (!currentEntidade) {
        showAlertModal('Erro', 'Entidade não carregada. Tente novamente.', 'danger');
        return;
      }

      setIsLoadingCreate(true);

      // Garant e que os IDs sejam números ou null antes de enviar para a API
      // CORREÇÃO: Usa os valores do estado newAppointment, que são definidos corretamente ao abrir o modal (inclusive na reutilização)
      const especialidadeIdParaApi = newAppointment.especialidade_id ? parseInt(newAppointment.especialidade_id, 10) : null;
      const medicoIdParaApi = newAppointment.medico_id ? parseInt(newAppointment.medico_id, 10) : null;

      const data = {
        ...newAppointment,
        entidade_id: currentEntidade.id, // Garante que o ID da entidade do contexto seja usado
        servicos: selectedServicos, // Add selected services to request body
        pacote_id: selectedPackageId, // Adiciona o ID do pacote, se houver
      }

      // Remove a chave 'interesses' para não enviar no payload do agendamento
      delete data.interesses;

      data.especialidade_id = especialidadeIdParaApi;
      data.medico_id = medicoIdParaApi;
      // Faz a requisição para a API para criar o agendamento
      const response = await axios.post('/api/agendamentos', data); //Include servicos data in the request

      // Update appointments state directly
      if (response.status === 201) {
        const createdAppointment = response.data.agendamento; // Assuming your API returns the created appointment

        // Após criar o agendamento, atualiza os interesses do paciente
        if (newAppointment.interesses && newAppointment.interesses.length > 0) {
          await updatePatientInterests(newAppointment.paciente_id, newAppointment.interesses);
        }

        // Notifica o pai para atualizar a lista e a disponibilidade
        // O pai será responsável por re-buscar todos os dados (agendamentos do dia, disponibilidade, etc.)
        onAppointmentCreated(createdAppointment);
      }

      // Fecha o modal
      handleCloseModal();

      // fetchAppointments(); 
    } catch (error) {
      // Verifica se o erro é de limite de agendamentos atingido
      if (error.response && error.response.data && error.response.data.action === 'buy_more') {
        const { message } = error.response.data;
        handleCloseModal(); // Fecha o modal de agendamento

        if (currentUserRole === 'Representante Legal') {
          showAlertModal(
            'Limite Atingido',
            message,
            'warning',
            () => navigate('/comprar-creditos') // Redireciona após o usuário fechar o alerta
          );
        } else {
          showAlertModal('Limite Atingido', message, 'warning');
        }
      } else {
        const errorMessage = error.response?.data?.message || 'Erro ao criar agendamento.';
        showAlertModal('Erro', errorMessage, 'danger');
      }
    } finally {
      setIsLoadingCreate(false); // Desativa o indicador de carregamento, independentemente de sucesso ou falha
    }
  };

  // Local state for loading status of individual appointment changes
  const [loadingStatusChanges, setLoadingStatusChanges] = useState({}); // ADDED

  // NOVO: Estado de loading para o botão "Chamar"
  const [loadingChamar, setLoadingChamar] = useState({});

  // NOVO: Estado local para toasts
  const [localToasts, setLocalToasts] = useState([]);

  // NOVO: Função para adicionar um toast local
  const addLocalToast = (title, message, type = 'light') => {
    const id = Date.now();
    setLocalToasts(prev => [...prev, { id, title, message, type }]);
    // Remove o toast após 4 segundos
    setTimeout(() => setLocalToasts(prev => prev.filter(t => t.id !== id)), 4000);
  };

  // NOVO: Função para chamar o paciente no painel
  const handleChamarPaciente = async (agendamentoId) => {
    setLoadingChamar(prev => ({ ...prev, [agendamentoId]: true }));
    try {
      // A API não retorna dados, apenas uma mensagem de sucesso.
      await axios.post(`/api/agendamentos/${agendamentoId}/chamar`);
      addLocalToast('Sucesso', 'Paciente chamado no painel!', 'success');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao chamar o paciente.';
      showAlertModal('Erro', errorMessage, 'danger');
    } finally {
      setLoadingChamar(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };
  
  // NOVO: Componente para renderizar os toasts locais
  const LocalToastManager = () => (
    <ToastContainer
      position="top-end"
      className="p-3"
      style={{ zIndex: 9999 }}
    >
      {localToasts.map((toast) => (
        <Toast
          key={toast.id}
          onClose={() => setLocalToasts(prev => prev.filter(t => t.id !== toast.id))}
          show={true}
          delay={4000}
          autohide
          bg={toast.type.toLowerCase()}
          className="text-white"
        >
          <Toast.Header><strong className="me-auto">{toast.title}</strong></Toast.Header>
          <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );


  const handleStatusChange = async (agendamentoId, newStatus, consultaAtual = null, historicoConsultas = null) => {
    setLoadingStatusChanges(prevLoading => ({ ...prevLoading, [agendamentoId]: true })); // Ativa o loading para o agendamento específico

    try {
      const currentTimeISO = new Date().toISOString(); // Captura a hora atual para consistência
      const response = await axios.put(`/api/agendamentos/${agendamentoId}`, {
        status: newStatus,
      });

      if (response.status === 200) {
        // Notifica o pai para atualizar a lista e o paciente selecionado

        const appointment = fiveDayAppointments.find(a => a.id === agendamentoId);
        const paciente = pacientesList.find(p => p.id === appointment.paciente_id);

        // Se o status mudou para 'Em andamento', atualiza o pacienteSelecionado no contexto
        // Isso também definirá o agendamento_updated_at para o cronômetro
         if (newStatus === 'Em andamento' && paciente && appointment) {
          setPacienteSelecionado({
            ...paciente,
            agendamento_id: agendamentoId,
            agendamento_status: newStatus,
            agendamento_updated_at: currentTimeISO, // Usa a hora capturada
            data_agendamento: appointment.data_agendamento,
            hora_marcada: appointment.hora_marcada,
            servicosDoAgendamento: appointment.servicos || [], // NOVO: Injeta os serviços do agendamento no contexto
            consultaAtual: consultaAtual, // Injeta a consulta atual no contexto
            historico: historicoConsultas, // Injeta o histórico de consultas no contexto
          });
        }
        // Notifica o pai sobre a mudança de status para que ele possa re-buscar os dados.
        // Isso é feito para qualquer mudança de status, não apenas 'Em andamento'.
        onAppointmentStatusChange(response.data.agendamento); // Passa o agendamento atualizado

      } else {
        const errorMsg = response.data?.message || 'Erro ao atualizar o status do agendamento.'; // Usar 'response' aqui
        showAlertModal('Erro de Conexão', errorMsg, 'danger');
      }
    } catch (error) {
      console.error('Erro ao atualizar o status do agendamento:', error);
    } finally {
      setLoadingStatusChanges(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // Desativa o loading para o agendamento específico
    }
  };

  // --- NOVOS ESTADOS PARA O MODAL DE ALTERAÇÃO DE PROFISSIONAL ---
  const [showChangeProfModal, setShowChangeProfModal] = useState(false);
  const [appointmentToChangeProf, setAppointmentToChangeProf] = useState(null);
  const [newProfessionalId, setNewProfessionalId] = useState('');
  const [isUpdatingProfessional, setIsUpdatingProfessional] = useState(false);

  const [changeProfError, setChangeProfError] = useState(null); // Para a mensagem de erro
  const [availableDoctors, setAvailableDoctors] = useState([]); // Para a lista de médicos disponíveis
  // Função auxiliar para calcular a duração da consulta no formato 'HH:mm:ss'
  function calcularDuracao(startTime, endTime) {
    if (!startTime || !endTime) return '00:00:00';
    const diffMs = endTime - startTime;
    if (diffMs < 0) return '00:00:00'; // Evita duração negativa
    const diffSecs = Math.round(diffMs / 1000);
    const hours = Math.floor(diffSecs / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((diffSecs % 3600) / 60).toString().padStart(2, '0');
    const seconds = Math.floor((diffSecs % 60)).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  // Local state for loading status of individual appointment finalization
  const [loadingFinalizarAgenda, setLoadingFinalizarAgenda] = useState({}); // ADDED

  // Função para finalizar consulta diretamente da tela de Agendas
  const handleFinalizarConsultaAgenda = async (agendamentoId) => {
    const appointment = calendarAppointments.find(a => a.id === agendamentoId); // calendarAppointments
    if (!currentEntidade) {
      showAlertModal('Erro', 'Entidade não carregada.', 'danger');
      return;
    }
    if (!appointment || !appointment.updated_at) {
      showAlertModal('Erro Interno', 'Agendamento ou hora de início não encontrados para finalizar.', 'danger');
      return;
    }

    setLoadingFinalizarAgenda(prevLoading => ({ ...prevLoading, [agendamentoId]: true }));
    let duration; // Declare duration here, outside the try block

    try {
      const startTime = new Date(appointment.updated_at); // Usa o updated_at que foi setado ao iniciar
      const endTime = new Date();
      duration = calcularDuracao(startTime, endTime); // Assign value to the already declared variable

      const response = await axios.put(
        `/api/agendamentos/${agendamentoId}`,
        { status: 'Realizada', duracao_atendimento: duration }
      );

      if (response.status === 200) {
        console.log('Agendamento finalizado com sucesso pela Agenda!');
      } else {
        showAlertModal('Erro', `Erro ao finalizar o agendamento: ${response.data?.message || 'Resposta inesperada.'}`, 'danger');

      }
    } catch (error) {
      showAlertModal('Erro de Conexão', `Erro ao finalizar o agendamento: ${error.response?.data?.message || error.message}`, 'danger');

      onAppointmentFinalized(agendamentoId, 'Realizada', duration); // Notifica o pai para re-fetch
    } finally {
      setLoadingFinalizarAgenda(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
    }
  };

  // Função auxiliar para navegar para o prontuário (extraída do antigo handleRowClick)
  const handleGoToProntuario = (appointment) => {
    if (appointment && appointment.status === 'Em andamento') {
      // Busca dados do paciente (pacientesList)
      const pacienteParaContexto = pacientesList.find(p => p.id === appointment.paciente_id);
      if (pacienteParaContexto) {
        // Adiciona informações do agendamento ao paciente antes de enviar para o contexto
        pacienteParaContexto.agendamento_id = appointment.id;
        pacienteParaContexto.agendamento_status = appointment.status;
        pacienteParaContexto.agendamento_updated_at = appointment.updated_at; // This is used by the timer in Consultorio.js
        pacienteParaContexto.data_agendamento = appointment.data_agendamento; // Adiciona data
        pacienteParaContexto.hora_marcada = appointment.hora_marcada; // Adiciona hora

        // Cria um NOVO objeto usando spread syntax para garantir que a referência mude
        // Isso força o useEffect no Consultorio a rodar novamente
        setPacienteSelecionado({ ...pacienteParaContexto });
      }
    }
  };

    const handleRowClick = (appointment) => {
        setSelectedSidebarAppointment(appointment);
        setIsDrawerOpen(true);
    };  
  // Função para buscar e abrir o histórico de pacotes
  const handleOpenPackageHistory = async () => {
    if (!selectedSidebarAppointment?.paciente_id) return;
    
    setIsLoadingPackageHistory(true);
    setShowPackageHistoryModal(true);
    try {
        const response = await axios.get(`/api/pacientes/${selectedSidebarAppointment.paciente_id}/pacotes-com-historico`);
        setPackageHistoryData(response.data.pacotes_historico || []);
    } catch (error) {
        console.error("Erro ao buscar histórico de pacotes:", error);
        setPackageHistoryData([]);
    } finally {
        setIsLoadingPackageHistory(false);
    }
  };

  // Função para retomar um atendimento já realizado ou em pagamento
  const handleRetomarAtendimento = async (agendamentoId) => {
    setLoadingStatusChanges(prev => ({ ...prev, [agendamentoId]: true }));
    try {
        // 1. Busca a consulta vinculada ao agendamento para preencher o prontuário
        const { data } = await axios.get(`/api/consultas/agendamento/${agendamentoId}`);
        const consultaAtual = data.consulta;

        // 2. Busca o histórico do paciente (para manter consistência com o fluxo de iniciar consulta)
        const agendamento = fiveDayAppointments.find(a => a.id === agendamentoId);
        let historicoConsultas = [];
        if (agendamento?.paciente_id) {
            const histRes = await axios.get(`/api/pacientes/${agendamento.paciente_id}/consultas`);
            historicoConsultas = histRes.data.paciente?.consultas || [];
        }

        // 3. Chama a mudança de status passando a consulta recuperada
        // Isso garante que o Prontuario.js receba os dados preenchidos imediatamente
        await handleStatusChange(agendamentoId, 'Em andamento', consultaAtual, historicoConsultas);

    } catch (error) {
        console.error("Erro ao retomar atendimento:", error);
        showAlertModal('Erro', 'Falha ao carregar dados do atendimento anterior. Verifique se a consulta foi criada corretamente.', 'danger');
        setLoadingStatusChanges(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };

  const handleIniciarConsulta = async (agendamentoId) => {
    setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: true }));
    if (!currentEntidade) {
      showAlertModal('Erro', 'Entidade não carregada.', 'danger');
      setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
      return;
    }
    try {
      const agendamento = fiveDayAppointments.find(a => a.id === agendamentoId);

      if (!agendamento) {
        console.error('Agendamento não encontrado!'); // calendarAppointments is a prop
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
        return;
      }

      // *** NOVA VERIFICAÇÃO GLOBAL VIA API ***
      // Verifica se o médico LOGADO (currentUser.id) já tem consulta em andamento
      if (!currentUser || !currentUser.id) {
        showAlertModal('Erro', 'ID do funcionário logado não disponível.', 'danger');
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
        return;
      }
      const checkResponse = await axios.get(`/api/medicos/${currentUser.id}/consulta-em-andamento`);


      if (checkResponse.data.inProgress && checkResponse.data.dataAgendamento) {
        showAlertModal('Consulta em Andamento', 'Você já possui uma consulta em andamento. A agenda será direcionada para o dia da consulta ativa.', 'info'); // calendarAppointments
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // Reseta o loading // calendarAppointments

        // Converte a data YYYY-MM-DD para um objeto Date e define no calendário
        const ongoingDate = new Date(checkResponse.data.dataAgendamento + 'T00:00:00'); // Adiciona T00:00:00 para evitar problemas de timezone
        setSelectedDate(ongoingDate); // Navega o calendário para a data

        return; // Impede o início da nova consulta
      }

      // Criar objeto de dados da consulta
      const consultaData = { 
        paciente_id: agendamento.paciente_id, 
        agendamento_id: agendamento.id, 
        data_consulta: agendamento.data_agendamento, 
        entidade_id: currentEntidade.id,
        prontuario_id: agendamento.paciente?.prontuario_id // Envia o prontuario_id se disponível
      };

      // >>> INÍCIO DA ALTERAÇÃO <<<
      // Garante que temos os dados completos do agendamento, incluindo os serviços.
      let agendamentoCompleto = agendamento;
      if (typeof agendamento.servicos === 'undefined') {
        try {
          const agendamentoResponse = await axios.get(`/api/agendamentos/${agendamento.id}`);
          agendamentoCompleto = agendamentoResponse.data; // Sobrescreve com os dados completos
        } catch (fetchError) {
          console.error("Falha ao buscar detalhes do agendamento:", fetchError);
          showAlertModal('Erro', 'Não foi possível carregar os detalhes dos serviços do agendamento.', 'danger');
          return; // Interrompe a execução se não conseguir buscar os serviços
        }
      }



      // 1. Fazer a requisição para criar a consulta
      const consultaResponse = await axios.post('/api/consultas', consultaData);

      if (consultaResponse.status === 201 && agendamentoCompleto) {
        // Otimização: Busca o histórico do paciente aqui para injetar no contexto
        const historicoResponse = await axios.get(`/api/pacientes/${agendamentoCompleto.paciente_id}/consultas`);
        const historicoConsultas = historicoResponse.data.paciente?.consultas || [];

        // >>> INÍCIO DA ALTERAÇÃO <<<
        // Injeta os serviços do agendamento original na consulta recém-criada

        const consultaComServicos = {
          ...consultaResponse.data.consulta,
          agendamento: { servicos: agendamentoCompleto.servicos || [] }
        };

        // 2. Chamar handleStatusChange para atualizar o status do agendamento para 'Em andamento'
        await handleStatusChange(agendamentoId, 'Em andamento', consultaComServicos, historicoConsultas);


      } else {
        var _consultaResponse$dat;
        showAlertModal('Erro', `Erro ao criar a consulta: ${((_consultaResponse$dat = consultaResponse.data) === null || _consultaResponse$dat === void 0 ? void 0 : _consultaResponse$dat.message) || 'Resposta inesperada.'}`, 'danger');

      }

    } catch (error) {
      showAlertModal('Erro de Conexão', `Erro ao iniciar a consulta: ${error.response?.data?.message || error.message}`, 'danger');

      // Lidar com o erro (exibir mensagem para o usuário, etc.)
    } finally {
      setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // calendarAppointments
    } // calendarAppointments is a prop
  };

  const handleOpenPaymentModal = (appointment) => {
    setSelectedAppointmentForPayment(appointment);
    setShowPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedAppointmentForPayment(null);
  };

  const handlePaymentConfirmation = (agendamentoAtualizado) => {
    // CORREÇÃO: Recebe o objeto `agendamento` completo e atualizado do PaymentModal
    // e o repassa para o callback do componente pai (`Consultorio.js`).
    onAppointmentStatusChange(agendamentoAtualizado);
  };

  // Função para abrir o modal de comunicação, com validação prévia
  const handleOpenCommunicationModal = () => {
    if (currentEntidade && currentEntidade.email_config_complete) {
      setShowCommunicationModal(true);
    } else {
        showAlertModal(
            'Configuração de E-mail Pendente',
            'As configurações de envio de e-mail (SMTP) não foram realizadas. Isso é necessário para enviar comunicados. Clique em OK para configurar agora.',
            'warning',
            () => navigate('/configuracoes') // Redireciona para a página de configurações
        );
    }
  };

    // NOVO: Handler para abrir o modal de cancelamento de pagamento
  const handleOpenCancelPaymentModal = (appointment) => {
    setAppointmentToCancelPayment(appointment);
    setShowCancelPaymentModal(true);
  };

  // NOVO: Handler para confirmar e executar o cancelamento do pagamento
  const handleConfirmCancelPayment = async () => {
    if (!appointmentToCancelPayment) return;

    setIsCancelingPayment(true);
    try {
      // NOVA LÓGICA: Chama o endpoint de cancelamento do agendamento, que cancelará todos os pagamentos associados.
      await axios.post(`/api/agendamentos/${appointmentToCancelPayment.id}/cancel-payments`);
      showAlertModal('Sucesso', 'Pagamento cancelado e estornado com sucesso!', 'success');
      onAppointmentStatusChange(); // Força o refresh da lista de agendamentos
      setShowCancelPaymentModal(false);
    } catch (error) {
      showAlertModal('Erro', `Falha ao cancelar pagamento: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsCancelingPayment(false);
    }
  };

  // NOVO: Handlers para o modal de detalhes do pagamento
  const handleOpenPaymentDetailsModal = (appointment) => {
    // Garante que paymentData seja sempre um array com todos os pagamentos
    let paymentData = appointment.pagamento;
    if (!Array.isArray(paymentData)) {
        paymentData = paymentData ? [paymentData] : [];
    }
    
    setSelectedPaymentDetails(paymentData);
    setSelectedAppointmentForDetails(appointment);
    setShowPaymentDetailsModal(true);
  };

  const handleClosePaymentDetailsModal = () => {
    setShowPaymentDetailsModal(false);
    setSelectedPaymentDetails(null);
    setSelectedAppointmentForDetails(null);
  };
  
  // --- NOVOS HANDLERS PARA ADICIONAR COMISSÃO ---
  const handleStartAddCommission = (paymentId, serviceId) => {
      setEditingCommission({ paymentId, serviceId });
      setSelectedProfessionalForCommission('');
      
      // Define o percentual padrão com base no serviço
      const serviceDef = servicos.find(s => s.id === serviceId);
      if (serviceDef) {
          setCommissionPercentage(serviceDef.percentual_comissao || 0);
      } else {
          setCommissionPercentage(0);
      }
  };

  const handleCancelAddCommission = () => {
      setEditingCommission({ paymentId: null, serviceId: null });
      setSelectedProfessionalForCommission('');
      setCommissionPercentage('');
  };

  const handleSaveCommission = async (paymentId, serviceId) => {
      if (!selectedProfessionalForCommission) {
           showAlertModal('Atenção', 'Selecione um profissional.', 'warning');
           return;
      }
      
      setIsAddingCommission(true);
      try {
          await axios.post(`/api/pagamentos/${paymentId}/servicos/${serviceId}/comissao`, {
              funcionario_id: selectedProfessionalForCommission,
              percentual_comissao: commissionPercentage
          });
          
          showAlertModal('Sucesso', 'Comissão atribuída com sucesso!', 'success');
          handleCancelAddCommission();
          handleClosePaymentDetailsModal();
          if (onAppointmentStatusChange) onAppointmentStatusChange(); // Atualiza a agenda
  
      } catch (error) {
          console.error("Erro ao adicionar comissão:", error);
          showAlertModal('Erro', `Falha ao adicionar comissão: ${error.response?.data?.message || error.message}`, 'danger');
      } finally {
          setIsAddingCommission(false);
      }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  // Rola automaticamente para as 08:00 ao abrir a agenda
  useEffect(() => {
    if (scrollRef.current) {
        const hourToScroll = 8; // Horário foco inicial
        if (hourToScroll > startHour) {
            // 120px é a altura do slot que configuramos anteriormente
            scrollRef.current.scrollTop = (hourToScroll - startHour) * 120;
        }
    }
  }, [startHour]); // Adicionado dependência

  // Fecha o menu de contexto ao clicar fora
  useEffect(() => {
    const handleClick = () => setContextMenu(null);
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  const handleContextMenu = (e, appointment) => {
    e.preventDefault();
    e.stopPropagation(); // Impede que o evento suba
    setContextMenu({
        x: e.clientX,
        y: e.clientY,
        appointment
    });
  };

  // Helper to generate dates for header/grid based on viewMode
  const getVisibleDays = useCallback(() => {
    const days = [];
    const current = new Date(selectedDate);
    current.setHours(0, 0, 0, 0);

    if (viewMode === 'day') {
        days.push(new Date(current));
    } else if (viewMode === 'week') {
        const day = current.getDay(); // 0 (Sun) to 6 (Sat)
        const diff = current.getDate() - day; // Adjust to Sunday
        const start = new Date(current);
        start.setDate(diff);
        for (let i = 0; i < 7; i++) {
            const d = new Date(start);
            d.setDate(d.getDate() + i);
            days.push(d);
        }
    } else if (viewMode === 'month') {
        const year = current.getFullYear();
        const month = current.getMonth();
        const startMonth = new Date(year, month, 1);
        const endMonth = new Date(year, month + 1, 0);
        
        const iter = new Date(startMonth);
        while (iter <= endMonth) {
            days.push(new Date(iter));
            iter.setDate(iter.getDate() + 1);
        }
    }
    return days;
  }, [selectedDate, viewMode]);

  // Fetch appointments based on visible days
  useEffect(() => {
    const fetchAppointmentsForView = async () => {
        if (!currentEntidade) return;
        setLoadingFiveDays(true);
        try {
            const days = getVisibleDays();
            if (days.length === 0) return;
            
            const start = days[0];
            const end = days[days.length - 1];
            
            const startStr = start.toISOString().split('T')[0];
            const endStr = end.toISOString().split('T')[0];

            let url = `/api/agendamentos/entidade/${currentEntidade.id}`;
            if (selectedMedico) {
                url += `/medico/${selectedMedico}`;
            }
            url += `/periodo?inicio=${startStr}&fim=${endStr}`;

            const response = await axios.get(url);
            setFiveDayAppointments(response.data.agendamentos || []);
            // --- NOVO: Converte a duração de HH:mm:ss para minutos ---
            const appointmentsWithDuration = (response.data.agendamentos || []).map(app => {
                let durationInMinutes = 30; // Duração padrão de 30 minutos
                const duracao = app.duracao_agendamento || app.duracao_atendimento;
                if (duracao) {
                    const [h, m] = duracao.split(':').map(Number);
                    durationInMinutes = (h * 60) + m;
                }
                return { ...app, duration: durationInMinutes };
            });

            setFiveDayAppointments(appointmentsWithDuration);
        } catch (e) {
            console.error("Erro ao buscar agendamentos:", e);
        } finally {
            setLoadingFiveDays(false);
        }
    };
    fetchAppointmentsForView();
  }, [selectedDate, selectedMedico, currentEntidade, onAppointmentStatusChange, getVisibleDays, refreshKey]); // Adicionado refreshKey

// Update red line position
  useEffect(() => {
    const updateRedLine = () => {
        const now = new Date();
        // const startHour = 2; // Usando a constante definida no escopo do componente
        const hours = now.getHours();
        const minutes = now.getMinutes();
        if (hours >= startHour && hours <= endHour) {
            const top = ((hours - startHour) * 120) + (minutes * 2); // 120px per hour
            setRedLineTop(top);
        } else {
            setRedLineTop(-1); // Hide
        }
    };
    updateRedLine();
    const interval = setInterval(updateRedLine, 60000);
    return () => clearInterval(interval);
  }, [startHour, endHour]); // Adicionado dependências

  // NOVO: Efeito para gerenciar o redimensionamento (mousemove/mouseup globais)
  useEffect(() => {
    const handleMouseMove = (e) => {
        if (!resizeState) return;
        const deltaY = e.clientY - resizeState.startY;
        // Altura mínima de 30px (15 minutos)
        const newHeight = Math.max(30, resizeState.startHeight + deltaY);
        setResizeState(prev => ({ ...prev, currentHeight: newHeight }));
    };

    const handleMouseUp = async () => {
        if (!resizeState) return;
        const newDurationInMinutes = Math.round(resizeState.currentHeight / 2);
        const snappedDuration = Math.round(newDurationInMinutes / 5) * 5;
        
        // Atualização otimista da UI
        setFiveDayAppointments(prev => prev.map(app => 
            app.id === resizeState.id ? { ...app, duration: snappedDuration } : app
        ));
        
        // Converte minutos para o formato HH:mm:ss para o backend
        const hours = Math.floor(snappedDuration / 60).toString().padStart(2, '0');
        const minutes = (snappedDuration % 60).toString().padStart(2, '0');
        const durationString = `${hours}:${minutes}:00`;

        try {
            await axios.put(`/api/agendamentos/${resizeState.id}`, {
                duracao_agendamento: durationString
            });
        } catch (error) {
            console.error("Erro ao atualizar a duração do agendamento:", error);
            showAlertModal('Erro', 'Não foi possível salvar a nova duração do agendamento.', 'danger');
            // A UI reverterá na próxima atualização de dados, o que é aceitável.
        }
        setResizeState(null);
    };

    if (resizeState) {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [resizeState]);

  // NOVO: Handlers para Drag and Drop
  const handleDragStart = (e, appointment) => {
      // Validação de segurança: Impede arrastar se o status não permitir
      if (['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status)) {
          e.preventDefault();
          addLocalToast('Ação Bloqueada', 'Este agendamento não pode ser movido.', 'warning');
          return;
      }

      setDraggedAppointment(appointment);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', appointment.id);
      // Reduz opacidade visualmente durante o arrasto
      e.target.style.opacity = '0.5';
  };

  const handleDragEnd = (e) => {
      e.target.style.opacity = '1';
      setDraggedAppointment(null);
  };

  const handleDragOver = (e) => {
      e.preventDefault(); // Necessário para permitir o drop
      e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = async (e, targetDate, targetTime) => {
      e.preventDefault();
      if (!draggedAppointment) return;

      // Validação de segurança no drop
      if (['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(draggedAppointment.status)) {
          setDraggedAppointment(null);
          return;
      }

      const newDateStr = targetDate.toISOString().split('T')[0];
      
      // Verifica se houve mudança
      if (draggedAppointment.data_agendamento === newDateStr && 
          draggedAppointment.hora_marcada.slice(0, 5) === targetTime) {
          return;
      }

      // Atualização Otimista
      const originalAppointments = [...fiveDayAppointments];
      setFiveDayAppointments(prev => prev.map(app => {
          if (app.id === draggedAppointment.id) {
              return { ...app, data_agendamento: newDateStr, hora_marcada: targetTime };
          }
          return app;
      }));

      try {
          await axios.put(`/api/agendamentos/${draggedAppointment.id}`, {
              data_agendamento: newDateStr,
              hora_marcada: targetTime,
          });
          
          if (onAppointmentStatusChange) onAppointmentStatusChange();
      } catch (error) {
          console.error("Falha ao reagendar", error);
          setFiveDayAppointments(originalAppointments); // Reverte em caso de erro
          showAlertModal('Erro', 'Falha ao reagendar o compromisso.', 'danger');
      }
  };

  // Helper to generate time slots
  const timeSlots = useMemo(() => {
      const slots = [];
      for (let h = startHour; h <= endHour; h++) {
          for (let m = 0; m < 60; m += slotInterval) {
              slots.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
          }
      }
      return slots;
  }, [startHour, endHour, slotInterval]);


  const styles = {
    container: { display: 'flex', height: 'calc(100vh - 200px)', overflow: 'hidden', flexDirection: 'column' },
    main: { flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: '#f8f9fa' },
    header: { display: 'flex', borderBottom: '1px solid #dee2e6', backgroundColor: '#fff' },
    headerCell: { flex: 1, padding: '10px', textAlign: 'center', borderRight: '1px solid #f0f0f0', fontWeight: 'bold' },
    body: { flexGrow: 1, overflowY: 'auto', position: 'relative', display: 'flex' },
    timeColumn: { width: '60px', minWidth: '60px', borderRight: '1px solid #dee2e6', backgroundColor: '#fff' },
    timeSlot: { height: `${slotInterval * 2}px`, borderBottom: '1px solid #dee2e6', padding: '5px', fontSize: `calc(12px * var(--font-scale))`, color: '#888', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    daySlot: { height: `${slotInterval * 2}px`, borderBottom: '1px solid #dee2e6', boxSizing: 'border-box', position: 'relative' },
    dayColumn: { flex: 1, borderRight: '1px solid #f0f0f0', position: 'relative', minWidth: isMobile ? '60px' : '150px' },
    monthCell: { flex: 1, minHeight: '100px', borderRight: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0', padding: '5px', cursor: 'pointer', backgroundColor: '#fff' },
    redLine: { position: 'absolute', height: '2px', backgroundColor: 'red', width: '100%', zIndex: 10, pointerEvents: 'none' },
    redDot: { position: 'absolute', left: '-5px', top: '-4px', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'red' },
    card: { position: 'absolute', width: '100%', left: '1%', zIndex: 5, fontSize: `calc(11px * var(--font-scale))`, boxShadow: '0 1px 2px rgba(0,0,0,0.1)', cursor: 'pointer', overflow: 'hidden', minHeight: '50px', borderRadius: 0 },
    fab: { position: 'fixed', bottom: '20px', right: '20px', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 6px rgba(0,0,0,0.3)', zIndex: 1050 },
    contextMenu: { position: 'fixed', zIndex: 9999, backgroundColor: '#fff', border: '1px solid rgba(0,0,0,.15)', borderRadius: '0.25rem', boxShadow: '0 0.5rem 1rem rgba(0,0,0,.175)', padding: '0.5rem 0', minWidth: '160px' }
};


  // Função para detectar conflitos de horário no dia
  const getConflicts = (appointments) => {
    const conflicts = new Set();
    const times = appointments.map(app => {
        const [h, m] = app.hora_marcada.split(':').map(Number);
        const start = h * 60 + m;
        // Se estiver redimensionando este agendamento, calcula a duração baseada na altura atual
        let duration = app.duration || 30;
        if (resizeState && resizeState.id === app.id) {
            duration = Math.round(resizeState.currentHeight / 2);
        }
        return { id: app.id, start, end: start + duration };
    });

    for (let i = 0; i < times.length; i++) {
        for (let j = i + 1; j < times.length; j++) {
            const t1 = times[i];
            const t2 = times[j];
            if (t1.start < t2.end && t2.start < t1.end) {
                conflicts.add(t1.id);
                conflicts.add(t2.id);
            }
        }
    }
    return conflicts;
  };

  // --- NOVO: Função para calcular o layout dos eventos (colunas e largura) ---
  const calculateEventLayout = useCallback((appointments) => {
    if (!appointments || appointments.length === 0) return {};

    // 1. Prepara eventos com início/fim em minutos
    const events = appointments.map(app => {
        const [h, m] = app.hora_marcada.split(':').map(Number);
        const start = h * 60 + m;
        let duration = app.duration || 30;
        // Considera o redimensionamento em tempo real
        if (resizeState && resizeState.id === app.id) {
            duration = Math.round(resizeState.currentHeight / 2);
        }
        return { ...app, start, end: start + duration };
    });

    // 2. Ordena por horário de início, depois por duração (maior primeiro)
    events.sort((a, b) => a.start - b.start || b.end - a.end);

    const columns = [];
    
    // 3. Empacota em colunas (First Fit)
    events.forEach(event => {
        let placed = false;
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];
            const lastEventInCol = col[col.length - 1];
            if (event.start >= lastEventInCol.end) {
                col.push(event);
                event.colIndex = i;
                placed = true;
                break;
            }
        }
        if (!placed) {
            columns.push([event]);
            event.colIndex = columns.length - 1;
        }
    });

    // 4. Agrupa eventos sobrepostos
    const eventToGroup = new Map();
    const groups = [];
    
    events.forEach(e => {
        if (eventToGroup.has(e.id)) return;
        
        const group = { events: [], cols: new Set() };
        const queue = [e];
        eventToGroup.set(e.id, group);
        group.events.push(e);
        group.cols.add(e.colIndex);
        
        let head = 0;
        while(head < queue.length) {
            const current = queue[head++];
            // Encontra eventos sobrepostos na lista completa
            events.forEach(other => {
                if (eventToGroup.has(other.id)) return;
                // Verifica sobreposição
                if (current.start < other.end && current.end > other.start) {
                    eventToGroup.set(other.id, group);
                    group.events.push(other);
                    group.cols.add(other.colIndex);
                    queue.push(other);
                }
            });
        }
        groups.push(group);
    });

    const layout = {};
    
    // 5. Calcula largura e posição esquerda para cada grupo
    groups.forEach(group => {
        const numCols = group.cols.size;
        const width = 100 / numCols;
        group.events.forEach(ev => {
            layout[ev.id] = {
                width: `${width}%`,
                left: `${ev.colIndex * width}%`,
                zIndex: ev.colIndex
            };
        });
    });
    
    return layout;
  }, [resizeState]);


  // Função auxiliar para renderizar os botões de ação
  const renderActionButtons = (appointment) => {
    const isDayView = viewMode === 'day';
    const btnStyle = { 
        fontSize: isDayView ? '0.9rem' : '0.7rem', 
        padding: isDayView ? '5px 10px' : '2px 5px',
        backgroundColor: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease'
    };

    return (
        <div className="d-flex gap-1 flex-wrap justify-content-end" style={{ pointerEvents: 'auto' }}>
            {/* Check-in */}
            {appointment.status === 'Agendada' && !appointment.hora_chegada && (
                <Button variant="outline-info" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleCheckIn(appointment.id); }} disabled={loadingCheckIn[appointment.id]} title="Fazer Check-in">
                    {loadingCheckIn[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faCheck} />}
                </Button>
            )}

            {/* Chamar Paciente */}
            {isCurrentUserCorpoClinico && appointment.medico_id === currentUser?.id && appointment.status === 'Agendada' && appointment.hora_chegada && (
                  <Button variant="outline-primary" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleChamarPaciente(appointment.id); }} disabled={loadingChamar[appointment.id]} title="Chamar Painel">
                    {loadingChamar[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faBullhorn} />}
                </Button>
            )}

            {/* Iniciar Consulta */}
            {isCurrentUserCorpoClinico && appointment.medico_id === currentUser?.id && appointment.status === 'Agendada' && (
                <Button variant={appointment.hora_chegada ? "outline-success" : "outline-secondary"} size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleIniciarConsulta(appointment.id); }} disabled={loadingIniciarConsulta[appointment.id] || !appointment.hora_chegada} title="Iniciar Consulta">
                    {loadingIniciarConsulta[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faStethoscope} />}
                </Button>
            )}

            {/* Pagamento */}
            {/* Show only in month view because in day/week view it is handled by the ribbon */}
            {viewMode === 'month' && (((appointment.status === 'Agendada' || appointment.status === 'Realizada') && appointment.payment_status === 'Aguardando Pagamento') ||
              ((appointment.payment_status === 'Pago' || appointment.payment_status === 'Aguardando Pagamento') && appointment.status === 'Aguardando Pagamento')) && (
                canShowPayButton && (
                    <Button variant="outline-danger" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleOpenPaymentModal(appointment); }} title="Receber Pagamento">
                        <FontAwesomeIcon icon={faDollarSign} />
                    </Button>
                )
            )}

             {/* Cancelar Pagamento */}
             {appointment.payment_status === 'Pago' && canShowCancelPayButton && 
                ((appointment.servicos?.length || 0) > 1 || !appointment.paciente_pacote_id || appointment.pagamento?.length > 0) && (
                <Button variant="outline-warning" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleOpenCancelPaymentModal(appointment); }} title="Cancelar Pagamento">
                    <FontAwesomeIcon icon={faBan} />
                </Button>
            )}
        </div>
    );
  };

  const renderEvent = (appointment, hasConflict, layoutStyle, dayDate) => {
    const [h, m] = appointment.hora_marcada.split(':').map(Number);
    const top      = ((h - startHour) * 120) + (m * 2);
    const colors   = getStatusColors(appointment.status);

    const isResizing = resizeState && resizeState.id === appointment.id;
    const duration   = appointment.duration || 30;
    const height     = isResizing ? resizeState.currentHeight : duration * 2;
    const isHovered  = hoveredAppointmentId === appointment.id;

    const hasPaymentStatus   = appointment.payment_status === 'Pago' || appointment.payment_status === 'Aguardando Pagamento';
    const canResize          = !['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status);
    const isOverlaying       = layoutStyle && layoutStyle.width !== '100%';
    const isCancelledOrMissed = ['Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status);
    const hasServices        = appointment.servicos && appointment.servicos.length > 0;
    const isPast             = ['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status);

    // ── Cor da borda esquerda (indicador de status) ──────────────────────
    const borderLeftColor = colors.bg;

    // ── Fundo do card: branco com leve tint do status ────────────────────
    const cardBg = isPast
        ? `${colors.bg}12`   // passado: tint muito suave
        : `${colors.bg}18`;  // futuro/ativo: tint um pouco mais visível

    return (
        <div
            key={appointment.id}
            style={{
                position: 'absolute',
                top:    `${top}px`,
                width:  isHovered ? '108%' : (layoutStyle ? layoutStyle.width  : '98%'),
                left:   isHovered ? '-4%'  : (layoutStyle ? layoutStyle.left   : '1%'),
                height: isHovered ? 'auto' : `${height}px`,
                minHeight: isHovered ? `${height}px` : '28px',
                zIndex: isResizing ? 60 : (isHovered ? 50 : (10 + (layoutStyle?.zIndex || 0))),

                // ── Visual principal ──────────────────────────────────────
                backgroundColor: isHovered ? '#fff' : cardBg,
                borderRadius: '6px',
                borderLeft: `3px solid ${borderLeftColor}`,
                border: hasConflict
                    ? `2px solid #ef4444`
                    : `1px solid ${colors.bg}30`,
                borderLeftWidth: '3px',
                borderLeftColor: borderLeftColor,

                boxShadow: isHovered
                    ? `0 4px 16px rgba(0,0,0,0.14), 0 0 0 1px ${colors.bg}40`
                    : `0 1px 3px rgba(0,0,0,0.06)`,

                cursor: 'pointer',
                overflow: isHovered ? 'visible' : 'hidden',
                paddingBottom: isHovered ? '36px' : '0',

                transition: isResizing
                    ? 'none'
                    : 'width 0.18s ease, left 0.18s ease, box-shadow 0.15s ease, background-color 0.15s ease',

                fontFamily: "'Inter','Segoe UI',sans-serif",
            }}
            draggable={!isResizing && canResize}
            onDragStart={(e) => handleDragStart(e, appointment)}
            onDragEnd={handleDragEnd}
            onDragOver={(e) => { if (isCancelledOrMissed) { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; } }}
            onDrop={(e) => { if (isCancelledOrMissed && dayDate) { e.preventDefault(); e.stopPropagation(); handleDrop(e, dayDate, appointment.hora_marcada.slice(0, 5)); } }}
            onClick={(e) => { e.stopPropagation(); handleRowClick(appointment); }}
            onContextMenu={(e) => handleContextMenu(e, appointment)}
            onMouseEnter={() => setHoveredAppointmentId(appointment.id)}
            onMouseLeave={() => setHoveredAppointmentId(null)}
        >
            {/* ── Indicador de status de pagamento (canto superior esquerdo) ── */}
            {hasPaymentStatus && (
                <div
                    style={{
                        position: 'absolute', top: 0, left: 0,
                        display: 'flex', alignItems: 'center', gap: '2px',
                        padding: '2px 8px 2px 4px',
                        background: 'rgba(255,255,255,0.92)',
                        clipPath: 'polygon(0 0, 100% 0, 82% 100%, 0% 100%)',
                        zIndex: 25, fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700',
                        cursor: (appointment.payment_status === 'Aguardando Pagamento' && canShowPayButton) ? 'pointer' : 'default',
                        backdropFilter: 'blur(2px)',
                    }}
                    onClick={(e) => {
                        if (appointment.payment_status === 'Aguardando Pagamento' && canShowPayButton) {
                            e.stopPropagation();
                            handleOpenPaymentModal(appointment);
                        }
                    }}
                >
                    {appointment.payment_status === 'Pago' && (
                        <FontAwesomeIcon icon={faDollarSign} style={{ color: '#16a34a', fontSize: `calc(10px * var(--font-scale))` }} title="Pago" />
                    )}
                    {appointment.payment_status === 'Aguardando Pagamento' && (
                        <>
                            <span style={{ color: '#dc2626', fontSize: '9px', fontWeight: '800' }}>R</span>
                            <FontAwesomeIcon icon={faDollarSign} style={{ color: '#dc2626', fontSize: '9px' }} title="Receber" />
                        </>
                    )}
                </div>
            )}

            {/* ── Corpo do card ── */}
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                height: '100%',
                padding: '4px 4px 4px 6px',
                overflow: isHovered ? 'visible' : 'hidden',
                paddingTop: isHovered ? '14px' : '4px',
                transition: 'padding-top 0.15s ease',
            }}>
                {/* Texto */}
                <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>

                    {/* Nome do paciente */}
                    <div style={{
                        fontSize: `calc(11px * var(--font-scale))`,
                        fontWeight: '700',
                        color: isPast ? '#6b7280' : '#111827',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        paddingLeft: hasPaymentStatus ? '22px' : '0',
                        lineHeight: '1.3',
                        textDecoration: ['Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status) ? 'line-through' : 'none',
                        textDecorationColor: '#9ca3af',
                    }}>
                        {appointment.paciente?.nome}
                    </div>

                    {/* Linha de info (hora + status) */}
                    {height > 28 && (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: '4px',
                            marginTop: '1px',
                        }}>
                            {/* Dot de status */}
                            <div style={{
                                width: '5px', height: '5px', borderRadius: '50%',
                                backgroundColor: colors.bg, flexShrink: 0,
                            }} />
                            <span style={{
                                fontSize: `calc(10px * var(--font-scale))`, color: '#6b7280',
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                fontVariantNumeric: 'tabular-nums',
                            }}>
                                {appointment.hora_marcada.slice(0, 5)}
                                {height > 44 && ` · ${appointment.status}`}
                                {height > 60 && ` · ${duration}min`}
                            </span>
                        </div>
                    )}

                    {/* Serviços (só no hover) */}
                    {isHovered && hasServices && (
                        <div style={{
                            marginTop: '4px', fontSize: `calc(10px * var(--font-scale))`, color: '#6b7280',
                            whiteSpace: 'normal', lineHeight: '1.3',
                            display: 'flex', alignItems: 'flex-start', gap: '4px',
                        }}>
                            <FontAwesomeIcon icon={faStethoscope} style={{ fontSize: '9px', marginTop: '1px', flexShrink: 0, opacity: 0.6 }} />
                            <span>{appointment.servicos.map(s => s.nome).join(', ')}</span>
                        </div>
                    )}
                </div>

                {/* Botões de ação (visíveis no hover ou sempre no day view) */}
                <div style={{
                    flexShrink: 0, marginLeft: '2px',
                    opacity: isHovered ? 1 : (viewMode === 'day' ? 0.7 : 0),
                    transition: 'opacity 0.15s',
                    pointerEvents: 'auto',
                }}>
                    {renderActionButtons(appointment)}
                </div>
            </div>

            {/* ── Indicador de expandir (quando sobreposto) ── */}
            {isOverlaying && !isHovered && !isResizing && (
                <div style={{
                    position: 'absolute', right: 0, top: 0, bottom: 0, width: '16px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: `linear-gradient(90deg, transparent, ${cardBg})`,
                    zIndex: 20,
                }}>
                    <FontAwesomeIcon icon={faExpand} style={{ color: colors.bg, fontSize: '8px', opacity: 0.7 }} />
                </div>
            )}

            {/* ── Handle de redimensionamento ── */}
            {canResize && (
                <div
                    style={{
                        position: 'absolute', bottom: 0, left: 0, right: 0, height: '5px',
                        cursor: 'ns-resize', zIndex: 10,
                        borderRadius: '0 0 6px 6px',
                        background: isResizing ? `${colors.bg}60` : 'transparent',
                        transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = `${colors.bg}40`; }}
                    onMouseLeave={e => { if (!isResizing) e.currentTarget.style.background = 'transparent'; }}
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setResizeState({ id: appointment.id, startY: e.clientY, startHeight: height, currentHeight: height });
                    }}
                />
            )}
        </div>
    );
};

  return (
    <> {/* Envolve o conteúdo em um React.Fragment para permitir múltiplos elementos no nível raiz */}
      {/* CSS Injetado para corrigir a altura das Tabs e permitir scroll interno */}
      <style>{`
        .full-height-tabs-wrapper .tab-content { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
        .full-height-tabs-wrapper .tab-pane.active { flex: 1; display: flex; flex-direction: column; overflow: hidden; height: 100%; }
        
        @keyframes pulse-blue {
          0% {
            box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(13, 110, 253, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
          }
        }
        .fab-pulse {
          animation: pulse-blue 2s infinite;
        }
        .action-btn-hover:hover {
            background-color: #e9ecef !important;
            border-color: #dee2e6 !important;
        }

        /* Indenta as abas no mobile para dar espaço ao botão de menu à esquerda */
        .mobile-tabs-with-toggle.nav-tabs,
        .mobile-tabs-with-toggle .nav-tabs {
            padding-left: 50px !important;
        }

        /* Reduz o padding vertical das abas no mobile para economizar espaço */
        .mobile-small-padding-tabs.nav-tabs {
            --bs-nav-link-padding-y: 0.1rem;
        }
      `}</style>

      {/* Gerenciador de toasts */}
      <LocalToastManager />
      

        {/* Main Content */}
<div style={{ ...styles.main, height: 'calc(100vh - 200px)' }}>

  <div className="d-flex flex-column h-100 full-height-tabs-wrapper" style={{ position: 'relative' }}>

    {/* ════════════════════════════════════════
        BARRA DE ABAS + CONTROLES
    ════════════════════════════════════════ */}
    <style>{`
      /* ── Tabs ── */
      .agc-tab-btn {
        height: 46px;
        padding: 0 18px;
        border: none;
        background: none;
        cursor: pointer;
        font-size: calc(13px * var(--font-scale))
        font-weight: 500;
        color: #6b7280;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
        display: inline-flex;
        align-items: center;
        gap: 7px;
        transition: color 0.15s, border-color 0.15s;
        white-space: nowrap;
        flex-shrink: 0;
        font-family: 'Inter','Segoe UI',sans-serif;
        letter-spacing: 0.1px;
      }
      .agc-tab-btn.active {
        color: #2563eb;
        border-bottom-color: #2563eb;
        font-weight: 600;
      }
      .agc-tab-btn:hover:not(.active) { color: #374151; }

      /* ── Day slot hover ── */
      .agc-day-slot-hover:hover {
        background: rgba(59,130,246,0.05) !important;
        cursor: pointer;
      }

      /* ── Header cell today ── */
      .agc-header-today {
        background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%) !important;
        color: #1d4ed8 !important;
      }

      /* ── Switch toggle ── */
      .agc-switch {
        width: 34px; height: 18px; border-radius: 999px;
        cursor: pointer; position: relative;
        transition: background 0.2s; flex-shrink: 0;
        border: none; outline: none;
      }
      .agc-switch-thumb {
        position: absolute; top: 2px;
        width: 14px; height: 14px; border-radius: 50%;
        background: #fff; transition: left 0.2s;
        box-shadow: 0 1px 3px rgba(0,0,0,0.25);
      }

      /* ── View mode buttons ── */
      .agc-view-btn {
        padding: 4px 11px; border: none;
        cursor: pointer; font-size: 12px; font-weight: 500;
        transition: all 0.15s; font-family: inherit;
        line-height: 1.5;
      }
      .agc-view-btn.active  { background: #2563eb; color: #fff; }
      .agc-view-btn.inactive { background: #fff; color: #6b7280; }
      .agc-view-btn.inactive:hover { background: #f3f4f6; color: #374151; }

      /* ── Grid header cell ── */
      .agc-grid-header-cell {
        flex: 1;
        padding: 10px 6px;
        text-align: center;
        border-right: 1px solid #f0f0f0;
        font-weight: 600;
        font-size: 12px;
        color: #374151;
        transition: background 0.1s;
      }

      /* ── Time label ── */
      .agc-time-lbl {
        font-size: 10px;
        color: #b0b7c3;
        font-weight: 500;
        font-variant-numeric: tabular-nums;
        letter-spacing: 0.2px;
        text-align: right;
        padding-right: 6px;
        padding-top: 4px;
        display: block;
      }

      /* ── Month cell ── */
      .agc-month-cell:hover { background: #f8fafc !important; }

      /* ── Empty state ── */
      .agc-empty {
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        padding: 60px 24px; gap: 10px;
        background: #fff; border-radius: 14px;
        border: 1px solid #e5e7eb;
        text-align: center;
      }
      .agc-empty-icon { font-size: 40px; opacity: 0.22; line-height: 1; }
      .agc-empty-title { font-size: 14px; font-weight: 600; color: #374151; margin: 0; }
      .agc-empty-sub   { font-size: 12px; color: #9ca3af; margin: 0; max-width: 260px; line-height: 1.5; }

      /* ── Status chip ── */
      .agc-chip {
        display: inline-flex; align-items: center; gap: 4px;
        padding: 2px 8px; border-radius: 999px;
        font-size: 10px; font-weight: 600; white-space: nowrap;
      }

      /* ── Ordem de chegada card ── */
      .agc-arrival-card {
        background: #fff; border-radius: 12px;
        border: 1px solid #e5e7eb; padding: 14px 16px;
        display: flex; align-items: center; gap: 14px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        transition: box-shadow 0.15s;
      }
      .agc-arrival-card:hover { box-shadow: 0 3px 10px rgba(0,0,0,0.08); }

      /* ── Todos médicos row ── */
      .agc-medico-row {
        display: flex; align-items: center; gap: 12px;
        padding: 10px 16px; transition: background 0.1s;
      }
      .agc-medico-row:hover { background: #f9fafb; }

      /* ── FAB ── */
      @keyframes pulse-fab {
        0%   { box-shadow: 0 4px 14px rgba(37,99,235,0.5), 0 0 0 0   rgba(37,99,235,0.4); }
        70%  { box-shadow: 0 4px 14px rgba(37,99,235,0.5), 0 0 0 14px rgba(37,99,235,0);   }
        100% { box-shadow: 0 4px 14px rgba(37,99,235,0.5), 0 0 0 0   rgba(37,99,235,0);    }
      }
      .fab-pulse { animation: pulse-fab 2s infinite; }

      /* ── Action btn ── */
      .action-btn-hover:hover {
        background-color: #f1f5f9 !important;
        border-color: #cbd5e1 !important;
      }
    `}</style>

{/* ── Barra de abas ── */}
<div style={{
  backgroundColor: '#fff',
  borderBottom: '1px solid #e5e7eb',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
}}>

  {/* ── Linha 1: abas + controles ── */}
  <div style={{
    display: 'flex',
    alignItems: 'stretch',
    minHeight: '46px',
  }}>

    {/* Abas */}
    <div style={{ display: 'flex', flex: 1, overflowX: 'auto', scrollbarWidth: 'none' }}>
      {[
        { key: 'agenda',      label: 'Agenda',                                    icon: faCalendarAlt },
        ...(isCurrentUserCorpoClinico
          ? [{ key: 'ordemChegada', label: isMobile ? 'Chegada' : 'Ordem de Chegada', icon: faUserMd }]
          : []),
        ...((currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal')
          ? [{ key: 'todos', label: isMobile ? 'Médicos' : 'Todos os Médicos',    icon: faStethoscope }]
          : []),
      ].map(tab => (
        <button
          key={tab.key}
          className={`agc-tab-btn ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.key)}
          style={{ padding: isMobile ? '0 12px' : '0 18px' }}
        >
          <FontAwesomeIcon icon={tab.icon} style={{ fontSize: `calc(11px * var(--font-scale))` }} />
          {tab.label}
        </button>
      ))}
    </div>

    {/* Controles desktop */}
    {activeTab === 'agenda' && isDesktop && (
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '0 14px', flexShrink: 0,
        borderLeft: '1px solid #f3f4f6',
      }}>
        {/* Switch pagamento pendente */}
        <label style={{
          display: 'flex', alignItems: 'center', gap: '7px',
          cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280',
          whiteSpace: 'nowrap', userSelect: 'none',
        }}>
          <button
            className="agc-switch"
            style={{ backgroundColor: showOnlyPendingPayment ? '#2563eb' : '#d1d5db' }}
            onClick={() => setShowOnlyPendingPayment(!showOnlyPendingPayment)}
          >
            <div className="agc-switch-thumb" style={{ left: showOnlyPendingPayment ? '18px' : '2px' }} />
          </button>
          Ag. Pagamento
        </label>

        <div style={{ width: '1px', height: '20px', backgroundColor: '#e5e7eb' }} />

        {/* Botão Hoje */}
        <button
          onClick={handleGoToToday}
          style={{
            padding: '5px 12px', borderRadius: '7px', cursor: 'pointer',
            fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
            border: '1px solid',
            backgroundColor: selectedDate.toDateString() !== new Date().toDateString() ? '#eff6ff' : '#f9fafb',
            borderColor:     selectedDate.toDateString() !== new Date().toDateString() ? '#bfdbfe' : '#e5e7eb',
            color:           selectedDate.toDateString() !== new Date().toDateString() ? '#2563eb' : '#6b7280',
            transition: 'all 0.15s',
          }}
        >
          Hoje
        </button>

        {/* Seletor de visualização */}
        <div style={{
          display: 'flex', borderRadius: '8px',
          border: '1px solid #e5e7eb', overflow: 'hidden',
        }}>
          {[
            { key: 'day',   label: 'Dia'    },
            { key: 'week',  label: 'Semana' },
            ...(isDesktop ? [{ key: 'month', label: 'Mês' }] : []),
          ].map((v, i, arr) => (
            <button
              key={v.key}
              className={`agc-view-btn ${viewMode === v.key ? 'active' : 'inactive'}`}
              onClick={() => setViewMode(v.key)}
              style={{ borderRight: i < arr.length - 1 ? '1px solid #e5e7eb' : 'none' }}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>

{/* ── Linha 2: calendário + busca de paciente + filtro de profissional ── */}
<div style={{
  borderTop: '1px solid #f3f4f6',
  padding: '6px 16px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  backgroundColor: '#fafafa',
}}>

  {/* ── Calendário (botão + popover) ── */}
  <div ref={calendarPopoverRef} style={{ position: 'relative', flexShrink: 0 }}>
    <button
      onClick={() => setShowCalendarPopover(!showCalendarPopover)}
      title={selectedDate.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}
      style={{
        display: 'flex', alignItems: 'center', gap: '6px',
        padding: '5px 10px', borderRadius: '20px', cursor: 'pointer',
        border: `1px solid ${showCalendarPopover ? '#2563eb' : '#e5e7eb'}`,
        backgroundColor: showCalendarPopover ? '#eff6ff' : '#fff',
        color: showCalendarPopover ? '#2563eb' : '#374151',
        fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
        transition: 'all 0.15s', whiteSpace: 'nowrap',
        boxShadow: showCalendarPopover ? '0 0 0 3px rgba(37,99,235,0.1)' : 'none',
      }}
    >
      <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: `calc(11px * var(--font-scale))`, color: showCalendarPopover ? '#2563eb' : '#9ca3af' }} />
      <span style={{ fontVariantNumeric: 'tabular-nums' }}>
        {selectedDate.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }).replace('.', '')}
      </span>
      {selectedDate.toDateString() === new Date().toDateString() && (
        <span style={{
          fontSize: '9px', fontWeight: '700', padding: '1px 5px', borderRadius: '999px',
          backgroundColor: '#2563eb', color: '#fff',
        }}>Hoje</span>
      )}
    </button>

    {/* ── Popover do calendário ── */}
    {showCalendarPopover && (
      <div style={{
        position: 'absolute', top: 'calc(100% + 8px)', left: 0,
        zIndex: 9999, backgroundColor: '#fff',
        borderRadius: '14px', border: '1px solid #e5e7eb',
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        padding: '14px', width: '300px',
        fontFamily: "'Inter','Segoe UI',sans-serif",
      }}>
        {/* CSS do calendário inline */}
        <style>{`
          .agc-cal-pop .react-calendar { width: 100% !important; border: none !important; background: transparent !important; font-family: 'Inter','Segoe UI',sans-serif !important; font-size: 12px !important; }
          .agc-cal-pop .react-calendar__navigation { margin-bottom: 6px !important; }
          .agc-cal-pop .react-calendar__navigation button { font-size: 12px !important; font-weight: 600 !important; color: #374151 !important; border-radius: 7px !important; min-width: 28px !important; padding: 4px !important; background: transparent !important; }
          .agc-cal-pop .react-calendar__navigation button:hover { background: #f3f4f6 !important; }
          .agc-cal-pop .react-calendar__navigation button:disabled { opacity: 0.4 !important; }
          .agc-cal-pop .react-calendar__month-view__weekdays__weekday abbr { text-decoration: none !important; font-size: 10px !important; font-weight: 700 !important; color: #9ca3af !important; text-transform: uppercase !important; letter-spacing: 0.4px !important; }
          .agc-cal-pop .react-calendar__tile { border-radius: 7px !important; font-size: 11px !important; padding: 7px 4px !important; color: #374151 !important; font-weight: 400 !important; transition: background 0.1s !important; border: none !important; background: transparent !important; }
          .agc-cal-pop .react-calendar__tile:hover:not(.react-calendar__tile--active):not(:disabled) { background: #f3f4f6 !important; }
          .agc-cal-pop .react-calendar__tile--now:not(.react-calendar__tile--active) { background: #eff6ff !important; color: #2563eb !important; font-weight: 700 !important; }
          .agc-cal-pop .react-calendar__tile--active { background: #2563eb !important; color: #fff !important; font-weight: 700 !important; box-shadow: 0 2px 6px rgba(37,99,235,0.35) !important; }
          .agc-cal-pop .react-calendar__tile--active:hover { background: #1d4ed8 !important; }
          .agc-cal-pop .react-calendar__tile:disabled { opacity: 0.35 !important; cursor: not-allowed !important; }
          .agc-cal-pop .react-calendar__month-view__days__day--neighboringMonth { color: #d1d5db !important; }
        `}</style>

        <div className="agc-cal-pop">
          <Calendar
            onChange={(date) => { handleDateChange(date); setShowCalendarPopover(false); }}
            value={selectedDate}
            activeStartDate={activeStartDate}
            tileClassName={({ date, view }) => getTileClass({ date, view, getFeriadoNome, availabilityData, nextAvailableDate, totalSlotsDisponiveis })}
            tileDisabled={isTileDisabled}
            onActiveStartDateChange={handleActiveStartDateChange}
          />
        </div>

        {/* Legenda compacta */}
        <div style={{
          marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f3f4f6',
          display: 'flex', flexWrap: 'wrap', gap: '8px',
        }}>
          {[
            { color: '#22c55e', label: 'Próx. Vaga' },
            { color: '#ef4444', label: 'Sem Vagas' },
            { color: '#f59e0b', label: 'Feriado' },
            { color: '#6b7280', label: 'Bloqueado' },
          ].map(item => (
            <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: item.color, flexShrink: 0 }} />
              <span style={{ fontSize: `calc(10px * var(--font-scale))`, color: '#6b7280' }}>{item.label}</span>
            </div>
          ))}
        </div>

        {/* Botão Hoje */}
        <button
          onClick={() => { handleGoToToday(); setShowCalendarPopover(false); }}
          style={{
            marginTop: '10px', width: '100%', padding: '6px',
            borderRadius: '8px', border: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb', color: '#374151',
            fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500', cursor: 'pointer',
            fontFamily: 'inherit', transition: 'background 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = '#eff6ff'}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
        >
          Ir para Hoje
        </button>
      </div>
    )}
  </div>

  {/* ── Divider ── */}
  <div style={{ width: '1px', height: '22px', backgroundColor: '#e5e7eb', flexShrink: 0 }} />

  {/* ── Campo busca paciente ── */}
  <div style={{ position: 'relative', flex: '1 1 0', minWidth: 0 }}>
    <span style={{
      position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
      color: pacienteFilterSearch ? '#2563eb' : '#d1d5db',
      fontSize: `calc(12px * var(--font-scale))`, pointerEvents: 'none', transition: 'color 0.15s',
    }}>
      🔍
    </span>
    <input
      type="text"
      value={pacienteFilterSearch}
      onChange={e => setPacienteFilterSearch(e.target.value)}
      placeholder="Buscar paciente..."
      style={{
        width: '100%',
        padding: '6px 32px 6px 30px',
        borderRadius: '20px',
        border: `1px solid ${pacienteFilterSearch ? '#2563eb' : '#e5e7eb'}`,
        fontSize: `calc(12px * var(--font-scale))`, color: '#374151', outline: 'none',
        backgroundColor: '#fff', fontFamily: 'inherit',
        transition: 'border-color 0.15s, box-shadow 0.15s',
        boxSizing: 'border-box',
        boxShadow: pacienteFilterSearch ? '0 0 0 3px rgba(37,99,235,0.1)' : 'none',
      }}
      onFocus={e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.1)'; }}
      onBlur={e => { if (!pacienteFilterSearch) { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; } }}
    />
    {pacienteFilterSearch && (
      <div style={{
        position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
        display: 'flex', alignItems: 'center', gap: '5px',
      }}>
        <span style={{
          fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#fff',
          backgroundColor: '#2563eb', padding: '1px 5px', borderRadius: '999px',
        }}>
          {pacienteFilteredAppointmentIds?.size ?? 0}
        </span>
        <button
          onClick={() => setPacienteFilterSearch('')}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#9ca3af', fontSize: `calc(11px * var(--font-scale))`, padding: '1px',
            display: 'flex', alignItems: 'center', transition: 'color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#374151'}
          onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
          title="Limpar"
        >✕</button>
      </div>
    )}
  </div>

  {/* ── Divider vertical ── */}
  {!isCurrentUserCorpoClinico && (
    <div style={{ width: '1px', height: '22px', backgroundColor: '#e5e7eb', flexShrink: 0 }} />
  )}

  {/* ── Select de Profissional ── */}
  {!isCurrentUserCorpoClinico && (
    <div style={{ flex: '1 1 0', minWidth: 0, maxWidth: '240px' }}>
      <Select
        options={(() => {
          const grupos = especialidades
            .map(esp => {
              const medicos = todosMedicos.filter(m => m.especialidade_id === esp.id);
              if (medicos.length === 0) return null;
              return {
                label: esp.nome,
                options: medicos.map(m => ({
                  value: m.id, label: m.nome,
                  especialidade_id: m.especialidade_id,
                  especialidade_nome: esp.nome,
                })),
              };
            })
            .filter(Boolean);
          const semEsp = todosMedicos.filter(m => !especialidades.some(e => e.id === m.especialidade_id));
          if (semEsp.length > 0) {
            grupos.push({
              label: 'Sem especialidade',
              options: semEsp.map(m => ({ value: m.id, label: m.nome, especialidade_id: null, especialidade_nome: null })),
            });
          }
          return grupos;
        })()}
        value={
          selectedMedico
            ? (() => {
                const m = todosMedicos.find(m => m.id === parseInt(selectedMedico));
                if (!m) return null;
                const esp = especialidades.find(e => e.id === m.especialidade_id);
                return { value: m.id, label: m.nome, especialidade_nome: esp?.nome };
              })()
            : null
        }
        onChange={handleProfissionalUnificadoChange}
        placeholder="Todos os profissionais"
        isClearable
        classNamePrefix="react-select"
        formatGroupLabel={group => (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '5px',
            fontSize: `calc(10px * var(--font-scale))`, fontWeight: '800', color: '#6b7280',
            textTransform: 'uppercase', letterSpacing: '0.4px', padding: '3px 0',
          }}>
            <FontAwesomeIcon icon={faStethoscope} style={{ fontSize: '9px', color: '#9ca3af' }} />
            {group.label}
            <span style={{
              marginLeft: 'auto', fontSize: `calc(10px * var(--font-scale))`, fontWeight: '600',
              padding: '0 5px', borderRadius: '999px',
              backgroundColor: '#f3f4f6', color: '#9ca3af',
            }}>
              {group.options.length}
            </span>
          </div>
        )}
        formatOptionLabel={opt => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <div style={{
              width: '22px', height: '22px', borderRadius: '50%', flexShrink: 0,
              background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '9px', fontWeight: '700', color: '#fff',
            }}>
              {opt.label.charAt(0).toUpperCase()}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {opt.label}
              </div>
              {opt.especialidade_nome && (
                <div style={{ fontSize: `calc(10px * var(--font-scale))`, color: '#9ca3af', lineHeight: 1.2 }}>
                  {opt.especialidade_nome}
                </div>
              )}
            </div>
          </div>
        )}
        styles={{
          control: (base, state) => ({
            ...base,
            fontSize: `calc(12px * var(--font-scale))`, minHeight: '32px', height: '32px',
            borderColor: state.isFocused ? '#2563eb' : (selectedMedico ? '#2563eb' : '#e5e7eb'),
            borderRadius: '20px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(37,99,235,0.1)' : 'none',
            backgroundColor: selectedMedico ? '#eff6ff' : '#fff',
            transition: 'border-color 0.15s, box-shadow 0.15s',
            cursor: 'pointer',
            '&:hover': { borderColor: '#d1d5db' },
          }),
          valueContainer: (base) => ({ ...base, padding: '0 8px', flexWrap: 'nowrap' }),
          indicatorsContainer: (base) => ({ ...base, height: '32px' }),
          groupHeading: (base) => ({ ...base, padding: '5px 10px 2px', borderTop: '1px solid #f3f4f6', marginTop: '3px' }),
          option: (base, state) => ({
            ...base, fontSize: `calc(12px * var(--font-scale))`, padding: '5px 10px',
            backgroundColor: state.isSelected ? '#eff6ff' : state.isFocused ? '#f8fafc' : '#fff',
            color: '#374151',
          }),
          placeholder: (base) => ({
            ...base, color: '#9ca3af', fontSize: `calc(12px * var(--font-scale))`,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }),
          singleValue: (base) => ({
            ...base, fontSize: `calc(12px * var(--font-scale))`, color: '#2563eb', fontWeight: '600',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }),
          clearIndicator: (base) => ({ ...base, padding: '3px' }),
          dropdownIndicator: (base) => ({ ...base, padding: '3px' }),
          menu: (base) => ({
            ...base, borderRadius: '10px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
            border: '1px solid #e5e7eb', zIndex: 9999,
          }),
          menuList: (base) => ({ ...base, padding: '4px' }),
        }}
      />
    </div>
  )}
</div>



</div>


    {/* Controles mobile */}
    {activeTab === 'agenda' && !isDesktop && (
      <div style={{
        backgroundColor: '#fff', borderBottom: '1px solid #e5e7eb',
        padding: '7px 12px', display: 'flex',
        alignItems: 'center', justifyContent: 'space-between', gap: '8px',
      }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: `calc(11px * var(--font-scale))`, color: '#6b7280', userSelect: 'none' }}>
          <button
            className="agc-switch"
            style={{ backgroundColor: showOnlyPendingPayment ? '#2563eb' : '#d1d5db' }}
            onClick={() => setShowOnlyPendingPayment(!showOnlyPendingPayment)}
          >
            <div className="agc-switch-thumb" style={{ left: showOnlyPendingPayment ? '18px' : '2px' }} />
          </button>
          {isMobile ? 'Ag. Pg.' : 'Ag. Pagamento'}
        </label>

        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <button
            onClick={handleGoToToday}
            style={{ padding: '4px 10px', borderRadius: '7px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb', color: '#6b7280', cursor: 'pointer', fontSize: `calc(11px * var(--font-scale))`, fontFamily: 'inherit' }}
          >
            Hoje
          </button>
          <div style={{ display: 'flex', borderRadius: '7px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
            {[{ key: 'day', label: 'D' }, { key: 'week', label: 'S' }].map((v, i) => (
              <button
                key={v.key}
                className={`agc-view-btn ${viewMode === v.key ? 'active' : 'inactive'}`}
                onClick={() => setViewMode(v.key)}
                style={{ padding: '4px 9px', borderRight: i === 0 ? '1px solid #e5e7eb' : 'none' }}
              >
                {v.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    )}

    {/* ════════════════════════════════════════
        ABA: AGENDA (grid de horários)
    ════════════════════════════════════════ */}
    {activeTab === 'agenda' && (
      <div className="d-flex flex-column h-100">

        {/* ── Header do grid (dias) ── */}
        <div style={{
          display: 'flex',
          borderBottom: '2px solid #e5e7eb',
          backgroundColor: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          flexShrink: 0,
        }}>
          {viewMode !== 'month' && (
            <div style={{
              width: '56px', minWidth: '56px',
              borderRight: '1px solid #e5e7eb',
              backgroundColor: '#fafafa',
              display: 'flex', alignItems: 'flex-end',
              justifyContent: 'center', paddingBottom: '8px',
            }}>
              <span style={{ fontSize: '9px', color: '#c4c9d4', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                {Intl.DateTimeFormat().resolvedOptions().timeZone?.split('/')[1]?.replace('_', ' ') || 'Hora'}
              </span>
            </div>
          )}

          {viewMode === 'month'
            ? ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(d => (
                <div key={d} className="agc-grid-header-cell" style={{ fontSize: `calc(10px * var(--font-scale))`, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '700', padding: '10px 4px' }}>
                  {d}
                </div>
              ))
            : getVisibleDays().map((day, index) => {
                const isToday = day.toDateString() === new Date().toDateString();
                return (
                  <div
                    key={index}
                    className={`agc-grid-header-cell ${isToday ? 'agc-header-today' : ''}`}
                    style={{ borderRadius: 0 }}
                  >
                    {isMobile ? (
                      <div style={{ lineHeight: '1.3' }}>
                        <div style={{ fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px', color: isToday ? '#1d4ed8' : '#9ca3af', fontWeight: '700' }}>
                          {day.toLocaleDateString('pt-BR', { weekday: 'narrow' })}
                        </div>
                        <div style={{ fontSize: '16px', fontWeight: isToday ? '800' : '500', color: isToday ? '#1d4ed8' : '#374151', marginTop: '1px' }}>
                          {day.getDate()}
                        </div>
                      </div>
                    ) : isTablet ? (
                      <div style={{ fontSize: `calc(12px * var(--font-scale))` }}>
                        <span style={{ textTransform: 'capitalize', color: isToday ? '#1d4ed8' : '#6b7280', fontWeight: '600' }}>
                          {day.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '')}
                        </span>
                        {' '}
                        <span style={{ fontWeight: isToday ? '800' : '600', color: isToday ? '#1d4ed8' : '#374151' }}>
                          {day.getDate()}
                        </span>
                      </div>
                    ) : (
                      <div>
                        <div style={{ fontSize: `calc(10px * var(--font-scale))`, color: isToday ? '#1d4ed8' : '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '700', marginBottom: '3px' }}>
                          {day.toLocaleDateString('pt-BR', { weekday: 'long' }).split('-')[0]}
                        </div>
                        <div style={{ fontSize: '22px', fontWeight: isToday ? '800' : '300', color: isToday ? '#1d4ed8' : '#374151', lineHeight: 1 }}>
                          {day.getDate()}
                        </div>
                        {isToday && (
                          <div style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#2563eb', margin: '4px auto 0', boxShadow: '0 0 0 3px rgba(37,99,235,0.2)' }} />
                        )}
                      </div>
                    )}
                  </div>
                );
              })
          }
        </div>

        {/* ── Body do grid ── */}
        <div style={{ ...styles.body, backgroundColor: '#f8fafc' }} ref={scrollRef}>
          {viewMode === 'month' ? (
            <div className="d-flex flex-wrap w-100">
              {getVisibleDays().map((day, index) => {
                const dayStr = day.toISOString().split('T')[0];
                const dayAppointments = fiveDayAppointments.filter(app => {
                    if (app.data_agendamento !== dayStr) return false;
                    if (showOnlyPendingPayment && app.payment_status !== 'Aguardando Pagamento' && app.status !== 'Aguardando Pagamento') return false;
                    // ── NOVO: filtro por nome do paciente ──
                    if (pacienteFilteredAppointmentIds !== null && !pacienteFilteredAppointmentIds.has(app.id)) return false;
                    return true;
                });
                const isCurrentMonth = day.getMonth() === selectedDate.getMonth();
                const isToday = day.toDateString() === new Date().toDateString();

                return (
                  <div
                    key={index}
                    className="agc-month-cell"
                    style={{
                      ...styles.monthCell,
                      width: '14.28%',
                      backgroundColor: isCurrentMonth ? '#fff' : '#fafafa',
                      borderTop: isToday ? '2px solid #2563eb' : '1px solid #f0f0f0',
                    }}
                    onClick={() => { setSelectedDate(day); setViewMode('day'); }}
                  >
                    <div style={{
                      fontSize: `calc(12px * var(--font-scale))`, fontWeight: isToday ? '800' : '400',
                      color: isToday ? '#2563eb' : isCurrentMonth ? '#374151' : '#d1d5db',
                      textAlign: 'right', marginBottom: '4px',
                    }}>
                      {day.getDate()}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      {dayAppointments.map(app => {
                        const colors = getStatusColors(app.status);
                        const popover = (
                          <Popover id={`popover-${app.id}`}>
                            <Popover.Header as="h3">{app.paciente?.nome}</Popover.Header>
                            <Popover.Body>
                              <p className="mb-2"><strong>Horário:</strong> {app.hora_marcada.slice(0, 5)}</p>
                              <p className="mb-2"><strong>Status:</strong> {app.status}</p>
                              {renderActionButtons(app)}
                            </Popover.Body>
                          </Popover>
                        );
                        return (
                          <OverlayTrigger trigger="click" rootClose placement="auto" overlay={popover} key={app.id}>
                            <div
                              style={{
                                padding: '2px 5px', borderRadius: '4px',
                                backgroundColor: colors.bg + '18',
                                borderLeft: `3px solid ${colors.bg}`,
                                cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px',
                              }}
                              onClick={(e) => { e.stopPropagation(); handleRowClick(app); }}
                            >
                              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, fontSize: `calc(10px * var(--font-scale))`, fontWeight: '500', color: '#374151' }}>
                                {app.hora_marcada.slice(0, 5)} {app.paciente?.nome}
                              </span>
                              {app.payment_status === 'Pago' && (
                                <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: '9px', color: '#16a34a', flexShrink: 0 }} />
                              )}
                              {app.payment_status === 'Aguardando Pagamento' && (
                                <FontAwesomeIcon icon={faDollarSign} style={{ fontSize: '9px', color: '#dc2626', flexShrink: 0 }} />
                              )}
                            </div>
                          </OverlayTrigger>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              {/* Coluna de horas */}
              <div style={{
                width: '56px', minWidth: '56px',
                borderRight: '1px solid #e5e7eb',
                backgroundColor: '#fafafa',
              }}>
                {timeSlots.map((time, index) => (
                  <div
                    key={index}
                    style={{
                      height: `${slotInterval * 2}px`,
                      borderBottom: '1px solid #f0f0f0',
                      display: 'flex', alignItems: 'flex-start',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <span className="agc-time-lbl">{time}</span>
                  </div>
                ))}
              </div>

              {/* Colunas de dias */}
              {getVisibleDays().map((day, dayIndex) => {
                const isToday = day.toDateString() === new Date().toDateString();
                const dayStr = day.toISOString().split('T')[0];
                const dayAppointments = fiveDayAppointments.filter(app => {
                    if (app.data_agendamento !== dayStr) return false;
                    if (showOnlyPendingPayment && app.payment_status !== 'Aguardando Pagamento' && app.status !== 'Aguardando Pagamento') return false;
                    // ── NOVO: filtro por nome do paciente ──
                    if (pacienteFilteredAppointmentIds !== null && !pacienteFilteredAppointmentIds.has(app.id)) return false;
                    return true;
                });
                dayAppointments.sort((a, b) => a.hora_marcada.localeCompare(b.hora_marcada));
                const conflicts = getConflicts(dayAppointments);
                const layout = calculateEventLayout(dayAppointments);

                return (
                  <div
                    key={dayIndex}
                    style={{
                      ...styles.dayColumn,
                      backgroundColor: isToday ? 'rgba(239,246,255,0.5)' : '#fff',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    {/* Linha vermelha do horário atual */}
                    {isToday && redLineTop >= 0 && (
                      <div style={{
                        position: 'absolute',
                        top: `${redLineTop}px`,
                        height: '2px',
                        background: 'linear-gradient(90deg, #ef4444, #f87171)',
                        width: '100%',
                        zIndex: 10,
                        pointerEvents: 'none',
                      }}>
                        <div style={{
                          position: 'absolute', left: '-5px', top: '-4px',
                          width: '10px', height: '10px', borderRadius: '50%',
                          backgroundColor: '#ef4444',
                          boxShadow: '0 0 0 3px rgba(239,68,68,0.2)',
                        }} />
                      </div>
                    )}

                    {/* Slots de horário */}
                    {timeSlots.map((time, timeIndex) => (
                      <div
                        key={timeIndex}
                        className="agc-day-slot-hover"
                        style={{
                          height: `${slotInterval * 2}px`,
                          borderBottom: timeIndex % (60 / slotInterval) === (60 / slotInterval) - 1
                            ? '1px solid #e5e7eb'
                            : '1px solid #f5f5f5',
                          boxSizing: 'border-box',
                          position: 'relative',
                        }}
                        onClick={() => handleTimeSlotClick(time, day)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, day, time)}
                      />
                    ))}

                    {/* Eventos */}
                    {dayAppointments.map(app => renderEvent(app, conflicts.has(app.id), layout[app.id], day))}
                  </div>
                );
              })}
            </>
          )}
        </div>

        {/* FAB */}
        <Button
          variant="primary"
          style={{
            position: 'fixed', bottom: '24px', right: '24px',
            width: '52px', height: '52px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(37,99,235,0.45)',
            zIndex: 1050,
            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
            border: 'none',
            transition: 'transform 0.15s, box-shadow 0.15s',
          }}
          className={!loadingFiveDays && fiveDayAppointments.length === 0 ? 'fab-pulse' : ''}
          onClick={handleFabClick}
          title="Novo Agendamento"
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
          <FontAwesomeIcon icon={faPlus} size="lg" />
        </Button>
      </div>
    )}

    {/* ABA: Ordem de Chegada */}
    {activeTab === 'ordemChegada' && isCurrentUserCorpoClinico && (
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px', backgroundColor: '#f8fafc' }}>
            {isLoadingOrdemDeChegada ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px', gap: '12px' }}>
                    <Spinner animation="border" variant="primary" style={{ width: '24px', height: '24px', borderWidth: '2px' }} />
                    <span style={{ color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}>Carregando...</span>
                </div>
            ) : ordemDeChegada.length === 0 ? (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', padding: '60px 24px', gap: '10px',
                    backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: '40px', opacity: 0.22, lineHeight: 1 }}>🪑</div>
                    <p style={{ margin: 0, fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#374151' }}>
                        Nenhum paciente aguardando
                    </p>
                    <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af', maxWidth: '260px', lineHeight: 1.5 }}>
                        Os pacientes que fizeram check-in aparecerão aqui em ordem de chegada
                    </p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {ordemDeChegada.filter(app => {
                        if (showOnlyPendingPayment) return app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento';
                        return true;
                    }).map((app, index) => (
                        <div
                            key={app.id}
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                border: '1px solid #e5e7eb',
                                borderLeft: index === 0 ? '3px solid #2563eb' : '3px solid transparent',
                                padding: '14px 16px',
                                display: 'flex', alignItems: 'center', gap: '14px',
                                boxShadow: index === 0
                                    ? '0 2px 10px rgba(37,99,235,0.1)'
                                    : '0 1px 3px rgba(0,0,0,0.04)',
                                transition: 'box-shadow 0.15s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 3px 12px rgba(0,0,0,0.09)'}
                            onMouseLeave={e => e.currentTarget.style.boxShadow = index === 0 ? '0 2px 10px rgba(37,99,235,0.1)' : '0 1px 3px rgba(0,0,0,0.04)'}
                        >
                            {/* Número de ordem */}
                            <div style={{
                                width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                                background: index === 0
                                    ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
                                    : '#f3f4f6',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700',
                                color: index === 0 ? '#fff' : '#6b7280',
                                boxShadow: index === 0 ? '0 2px 6px rgba(37,99,235,0.3)' : 'none',
                            }}>
                                {index + 1}º
                            </div>

                            {/* Info do paciente */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{
                                    fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#111827',
                                    marginBottom: '3px', overflow: 'hidden',
                                    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                }}>
                                    {app.paciente?.nome || '-'}
                                </div>
                                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                    <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <FontAwesomeIcon icon={faClock} style={{ fontSize: '9px' }} />
                                        Chegou: {new Date(app.hora_chegada).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                    </span>
                                    <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '9px' }} />
                                        Agendado: {app.hora_marcada.slice(0, 5)}
                                    </span>
                                </div>
                            </div>

                            {/* Badge pagamento */}
                            <span style={{
                                fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', padding: '3px 10px',
                                borderRadius: '999px', flexShrink: 0,
                                backgroundColor: app.payment_status === 'Pago' ? '#dcfce7' : '#fef9c3',
                                color: app.payment_status === 'Pago' ? '#16a34a' : '#854d0e',
                                border: `1px solid ${app.payment_status === 'Pago' ? '#bbf7d0' : '#fde68a'}`,
                            }}>
                                {app.payment_status || 'Pendente'}
                            </span>

                            {/* Botão Iniciar */}
                            <button
                                onClick={() => handleIniciarConsulta(app.id)}
                                disabled={loadingIniciarConsulta[app.id] || app.payment_status !== 'Pago'}
                                style={{
                                    padding: '7px 14px', borderRadius: '8px', flexShrink: 0,
                                    background: app.payment_status === 'Pago'
                                        ? 'linear-gradient(135deg, #22c55e, #16a34a)'
                                        : '#e5e7eb',
                                    color: app.payment_status === 'Pago' ? '#fff' : '#9ca3af',
                                    border: 'none',
                                    cursor: app.payment_status === 'Pago' ? 'pointer' : 'not-allowed',
                                    fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
                                    display: 'flex', alignItems: 'center', gap: '6px',
                                    transition: 'opacity 0.15s',
                                    fontFamily: 'inherit',
                                    boxShadow: app.payment_status === 'Pago'
                                        ? '0 2px 6px rgba(34,197,94,0.3)'
                                        : 'none',
                                }}
                                onMouseEnter={e => { if (app.payment_status === 'Pago') e.currentTarget.style.opacity = '0.88'; }}
                                onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
                            >
                                {loadingIniciarConsulta[app.id]
                                    ? <Spinner as="span" size="sm" animation="border" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
                                    : <FontAwesomeIcon icon={faStethoscope} style={{ fontSize: `calc(11px * var(--font-scale))` }} />
                                }
                                {!isMobile && 'Iniciar'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )}

    {/* ABA: Todos os Médicos */}
    {activeTab === 'todos' && (currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && (
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px', backgroundColor: '#f8fafc' }}>
            {isLoadingAllAppointments ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px', gap: '12px' }}>
                    <Spinner animation="border" variant="primary" style={{ width: '24px', height: '24px', borderWidth: '2px' }} />
                    <span style={{ color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}>Carregando...</span>
                </div>
            ) : allAppointmentsError ? (
                <div style={{ padding: '12px 16px', backgroundColor: '#fef2f2', borderRadius: '10px', border: '1px solid #fecaca', color: '#dc2626', fontSize: `calc(13px * var(--font-scale))` }}>
                    {allAppointmentsError}
                </div>
            ) : Object.keys(appointmentsByMedico).length === 0 ? (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', padding: '60px 24px', gap: '10px',
                    backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: '40px', opacity: 0.22, lineHeight: 1 }}>📋</div>
                    <p style={{ margin: 0, fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#374151' }}>
                        Nenhum agendamento
                    </p>
                    <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af', maxWidth: '260px', lineHeight: 1.5 }}>
                        Não há agendamentos para o dia selecionado
                    </p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {Object.keys(appointmentsByMedico).map(medicoId => {
                        const medico = todosMedicos.find(m => m.id === parseInt(medicoId, 10));
                        const filtered = appointmentsByMedico[medicoId].filter(app =>
                            showOnlyPendingPayment
                                ? app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento'
                                : true
                        );
                        if (filtered.length === 0) return null;

                        return (
                            <div key={medicoId} style={{
                                backgroundColor: '#fff', borderRadius: '14px',
                                border: '1px solid #e5e7eb', overflow: 'hidden',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                            }}>
                                {/* Header do médico */}
                                <div style={{
                                    padding: '12px 16px', backgroundColor: '#f9fafb',
                                    borderBottom: '1px solid #e5e7eb',
                                    display: 'flex', alignItems: 'center', gap: '10px',
                                }}>
                                    {/* Avatar */}
                                    <div style={{
                                        width: '34px', height: '34px', borderRadius: '50%', flexShrink: 0,
                                        background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#fff',
                                        boxShadow: '0 2px 6px rgba(59,130,246,0.3)',
                                    }}>
                                        {medico?.nome?.charAt(0)?.toUpperCase() || 'M'}
                                    </div>

                                    {/* Nome + contagem */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{
                                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#111827',
                                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                        }}>
                                            Dr(a). {medico?.nome || 'Não Identificado'}
                                        </div>
                                        <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '1px' }}>
                                            {filtered.length} agendamento{filtered.length !== 1 ? 's' : ''}
                                        </div>
                                    </div>

                                    {/* Mini-badges de status */}
                                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                        {['Agendada', 'Em andamento', 'Realizada'].map(s => {
                                            const count = filtered.filter(a => a.status === s).length;
                                            if (!count) return null;
                                            const colors = getStatusColors(s);
                                            return (
                                                <span key={s} style={{
                                                    fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700',
                                                    padding: '2px 7px', borderRadius: '999px',
                                                    backgroundColor: colors.bg + '22',
                                                    color: colors.bg,
                                                    border: `1px solid ${colors.bg}33`,
                                                }}>
                                                    {count}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Lista de agendamentos */}
                                <div>
                                    {filtered.map((app, idx, arr) => {
                                        const colors = getStatusColors(app.status);
                                        return (
                                            <div
                                                key={app.id}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '12px',
                                                    padding: '10px 16px',
                                                    borderBottom: idx < arr.length - 1 ? '1px solid #f3f4f6' : 'none',
                                                    borderLeft: `3px solid ${colors.bg}`,
                                                    transition: 'background 0.1s',
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                            >
                                                {/* Hora */}
                                                <span style={{
                                                    fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#374151',
                                                    minWidth: '42px', flexShrink: 0,
                                                    fontVariantNumeric: 'tabular-nums',
                                                }}>
                                                    {app.hora_marcada.slice(0, 5)}
                                                </span>

                                                {/* Paciente */}
                                                <span style={{
                                                    flex: 1, fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', color: '#374151',
                                                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                                }}>
                                                    {app.paciente?.nome || '-'}
                                                </span>

                                                {/* Tipo */}
                                                {!isMobile && (
                                                    <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', flexShrink: 0 }}>
                                                        {app.tipo}
                                                    </span>
                                                )}

                                                {/* Status */}
                                                <span style={{
                                                    fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                                                    padding: '2px 8px', borderRadius: '999px', flexShrink: 0,
                                                    backgroundColor: colors.bg + '20',
                                                    color: colors.bg,
                                                    border: `1px solid ${colors.bg}40`,
                                                }}>
                                                    {app.status}
                                                </span>

                                                {/* Pagamento */}
                                                <span style={{
                                                    fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                                                    padding: '2px 8px', borderRadius: '999px', flexShrink: 0,
                                                    backgroundColor: app.payment_status === 'Pago' ? '#dcfce7' : '#fee2e2',
                                                    color: app.payment_status === 'Pago' ? '#16a34a' : '#dc2626',
                                                    border: `1px solid ${app.payment_status === 'Pago' ? '#bbf7d0' : '#fecaca'}`,
                                                }}>
                                                    {app.payment_status || 'Pendente'}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )}
    </div>
</div>


    {/* ══════════════════════════════════════════════════════════
    DRAWER DE DETALHES DO AGENDAMENTO (abre da esquerda → direita)
══════════════════════════════════════════════════════════ */}

{/* CSS do Drawer */}
<style>{`
    @keyframes drawerSlideIn {
        from { transform: translateX(-100%); opacity: 0; }
        to   { transform: translateX(0);     opacity: 1; }
    }
    @keyframes drawerSlideOut {
        from { transform: translateX(0);     opacity: 1; }
        to   { transform: translateX(-100%); opacity: 0; }
    }
    .appointment-drawer {
        animation: drawerSlideIn 0.28s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
`}</style>

{/* Backdrop */}
{isDrawerOpen && (
    <div
        onClick={() => { setIsDrawerOpen(false); setSelectedSidebarAppointment(null); }}
        style={{
            position: 'fixed', inset: 0,
            backgroundColor: 'rgba(0,0,0,0.35)',
            zIndex: 1049,
            backdropFilter: 'blur(2px)',
            transition: 'opacity 0.28s ease',
        }}
    />
)}

{/* Drawer Panel */}
{isDrawerOpen && selectedSidebarAppointment && (() => {
    // ── Effects (dentro de IIFE para manter hooks fora do JSX) ──
    // Nota: os efeitos reais ficam fora — aqui apenas renderizamos o painel
    return (
        <div
            className="appointment-drawer"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: 'min(520px, 50vw)',
                height: '100vh',
                backgroundColor: '#fff',
                zIndex: 1050,
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '4px 0 32px rgba(0,0,0,0.18)',
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
                overflowY: 'hidden',
            }}
        >
            {/* ── Header do Drawer ── */}
            <div style={{
                padding: '16px 20px',
                borderBottom: '1px solid #f3f4f6',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                flexShrink: 0,
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {/* Avatar */}
                    <div style={{
                        width: '42px', height: '42px', borderRadius: '50%', flexShrink: 0,
                        backgroundColor: 'rgba(255,255,255,0.25)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '18px', fontWeight: '700', color: '#fff',
                        border: '2px solid rgba(255,255,255,0.4)',
                    }}>
                        {selectedSidebarAppointment.paciente?.nome?.charAt(0)?.toUpperCase() || '?'}
                    </div>
                    <div>
                        <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff', marginBottom: '3px' }}>
                            {selectedSidebarAppointment.paciente?.nome}
                        </div>
                        {(() => {
                            const colors = getStatusColors(selectedSidebarAppointment.status);
                            return (
                                <span style={{
                                    fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', padding: '2px 8px', borderRadius: '999px',
                                    backgroundColor: 'rgba(255,255,255,0.25)', color: '#fff',
                                    border: '1px solid rgba(255,255,255,0.4)',
                                }}>
                                    {selectedSidebarAppointment.status}
                                </span>
                            );
                        })()}
                    </div>
                </div>
                {/* Botão fechar */}
                <button
                    onClick={() => { setIsDrawerOpen(false); setSelectedSidebarAppointment(null); }}
                    style={{
                        width: '32px', height: '32px', borderRadius: '50%',
                        backgroundColor: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)',
                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: `calc(14px * var(--font-scale))`, transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.35)'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)'}
                >
                    ✕
                </button>
            </div>

            {/* ── Conteúdo Scrollável ── */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>

                {/* Contatos */}
                <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {selectedSidebarAppointment.paciente?.cpf && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>
                            <FontAwesomeIcon icon={faIdCard} style={{ width: '16px', color: '#9ca3af' }} />
                            {selectedSidebarAppointment.paciente.cpf}
                        </div>
                    )}
                    {selectedSidebarAppointment.paciente?.celular && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>
                            <FontAwesomeIcon icon={faPhone} style={{ width: '16px', color: '#9ca3af' }} />
                            {selectedSidebarAppointment.paciente.dddcelular}{selectedSidebarAppointment.paciente.celular}
                        </div>
                    )}
                    {selectedSidebarAppointment.paciente?.email && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', overflow: 'hidden' }}>
                            <FontAwesomeIcon icon={faEnvelope} style={{ width: '16px', color: '#9ca3af', flexShrink: 0 }} />
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {selectedSidebarAppointment.paciente.email}
                            </span>
                        </div>
                    )}
                    <button
                        onClick={handleOpenPackageHistory}
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, color: '#3b82f6', padding: '4px 0',
                            display: 'flex', alignItems: 'center', gap: '6px',
                        }}
                    >
                        <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: `calc(12px * var(--font-scale))` }} />
                        Ver Histórico de Pacotes
                    </button>
                </div>

                {/* Detalhes do Agendamento */}
                <div style={{
                    backgroundColor: '#f9fafb', borderRadius: '12px',
                    padding: '14px 16px', marginBottom: '20px',
                    border: '1px solid #f3f4f6',
                }}>
                    <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>
                        Detalhes do Agendamento
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        {[
                            { icon: faClock, label: 'Horário', value: selectedSidebarAppointment.hora_marcada.slice(0, 5) },
                            { icon: faCalendarAlt, label: 'Data', value: new Date(selectedSidebarAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR') },
                            { icon: faStethoscope, label: 'Tipo', value: selectedSidebarAppointment.tipo },
                            ...(selectedSidebarAppointment.medico ? [{ icon: faUserMd, label: 'Profissional', value: selectedSidebarAppointment.medico.nome }] : []),
                        ].map(item => (
                            <div key={item.label} style={{
                                padding: '10px 12px', borderRadius: '8px',
                                backgroundColor: '#fff', border: '1px solid #e5e7eb',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                    <FontAwesomeIcon icon={item.icon} style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }} />
                                    <span style={{ fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        {item.label}
                                    </span>
                                </div>
                                <div style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>{item.value}</div>
                            </div>
                        ))}
                        {/* Pagamento */}
                        <div style={{
                            padding: '10px 12px', borderRadius: '8px',
                            backgroundColor: selectedSidebarAppointment.payment_status === 'Pago' ? '#f0fdf4' : '#fffbeb',
                            border: `1px solid ${selectedSidebarAppointment.payment_status === 'Pago' ? '#bbf7d0' : '#fde68a'}`,
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                <FontAwesomeIcon icon={faDollarSign} style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }} />
                                <span style={{ fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Pagamento
                                </span>
                            </div>
                            <div style={{
                                fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                                color: selectedSidebarAppointment.payment_status === 'Pago' ? '#16a34a' : '#854d0e',
                            }}>
                                {selectedSidebarAppointment.payment_status || 'Pendente'}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Serviços */}
                {sidebarDetails.loading ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', gap: '8px' }}>
                        <Spinner animation="border" size="sm" variant="primary" />
                        <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af' }}>Calculando valores...</span>
                    </div>
                ) : sidebarDetails.services.length > 0 && (
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
                            Serviços
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {sidebarDetails.services.map((servico, idx) => (
                                <div key={`${servico.id}-${idx}`} style={{
                                    padding: '10px 12px', borderRadius: '10px',
                                    backgroundColor: '#f9fafb', border: '1px solid #f3f4f6',
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontWeight: '500', flex: 1, minWidth: 0 }}>
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                                {servico.nome}
                                                {servico.quantidade > 1 && <span style={{ color: '#9ca3af', marginLeft: '4px' }}>x{servico.quantidade}</span>}
                                            </span>
                                            {servico.isPacote && (
                                                <span style={{ fontSize: `calc(10px * var(--font-scale))`, fontWeight: '600', padding: '1px 6px', borderRadius: '999px', backgroundColor: '#dbeafe', color: '#1d4ed8', marginTop: '2px', display: 'inline-block' }}>
                                                    Pacote
                                                </span>
                                            )}
                                        </div>
                                        <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: servico.valor === 0 ? '#9ca3af' : '#111827', marginLeft: '12px', flexShrink: 0, textDecoration: servico.valor === 0 ? 'line-through' : 'none' }}>
                                            {formatCurrency(servico.valor)}
                                        </span>
                                    </div>
                                    {servico.comissionado == 1 && (
                                        <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#16a34a', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FontAwesomeIcon icon={faMoneyBillWave} />
                                            {servico.tipo_comissao === 'indicacao' ? 'Indicação gerada' : 'Comissão gerada'}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Totais */}
                        <div style={{ marginTop: '10px', padding: '12px 14px', borderRadius: '10px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                            {sidebarDetails.valorAdicional > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', marginBottom: '6px' }}>
                                    <span>Adicional:</span>
                                    <span>{formatCurrency(sidebarDetails.valorAdicional)}</span>
                                </div>
                            )}
                            {sidebarDetails.valorJaPago > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(13px * var(--font-scale))`, color: '#16a34a', marginBottom: '6px' }}>
                                    <span>Valor Pago:</span>
                                    <span>- {formatCurrency(sidebarDetails.valorJaPago)}</span>
                                </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#111827', borderTop: '1px solid #bbf7d0', paddingTop: '8px', marginTop: '4px' }}>
                                <span>Total:</span>
                                <span>{formatCurrency(sidebarDetails.total)}</span>
                            </div>
                            {sidebarDetails.valorJaPago > 0 && selectedSidebarAppointment.payment_status !== 'Pago' && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#ef4444', marginTop: '6px' }}>
                                    <span>A Pagar:</span>
                                    <span>{formatCurrency(Math.max(0, sidebarDetails.total - sidebarDetails.valorJaPago))}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Observações */}
                {selectedSidebarAppointment.observacoes && (
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
                            Observações
                        </div>
                        <div style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', padding: '12px 14px', backgroundColor: '#fffbeb', borderRadius: '10px', border: '1px solid #fde68a', lineHeight: '1.6' }}>
                            {selectedSidebarAppointment.observacoes}
                        </div>
                    </div>
                )}

                {/* Botão Prontuário */}
                {selectedSidebarAppointment.status === 'Em andamento' && (
                    <button
                        onClick={() => { handleGoToProntuario(selectedSidebarAppointment); setIsDrawerOpen(false); }}
                        style={{
                            width: '100%', padding: '12px', borderRadius: '10px',
                            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                            color: '#fff', border: 'none', cursor: 'pointer',
                            fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', marginBottom: '16px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                            boxShadow: '0 2px 8px rgba(59,130,246,0.35)',
                            transition: 'opacity 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    >
                        <FontAwesomeIcon icon={faStethoscope} />
                        Ir para Prontuário
                    </button>
                )}

                {/* Ações */}
                <div>
                    <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
                        Ações
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

                        {/* Check-in */}
                        {selectedSidebarAppointment.status === 'Agendada' && !selectedSidebarAppointment.hora_chegada && (
                            <SidebarActionButton
                                onClick={() => handleCheckIn(selectedSidebarAppointment.id)}
                                disabled={loadingCheckIn[selectedSidebarAppointment.id]}
                                loading={loadingCheckIn[selectedSidebarAppointment.id]}
                                icon={faCheck}
                                label="Fazer Check-in"
                                color="#0ea5e9" bg="#f0f9ff" border="#bae6fd"
                            />
                        )}

                        {/* Iniciar Consulta */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id && selectedSidebarAppointment.status === 'Agendada' && (
                            <SidebarActionButton
                                onClick={() => handleIniciarConsulta(selectedSidebarAppointment.id)}
                                disabled={loadingIniciarConsulta[selectedSidebarAppointment.id] || !selectedSidebarAppointment.hora_chegada}
                                loading={loadingIniciarConsulta[selectedSidebarAppointment.id]}
                                icon={faStethoscope}
                                label="Iniciar Consulta"
                                color={selectedSidebarAppointment.hora_chegada ? '#16a34a' : '#9ca3af'}
                                bg={selectedSidebarAppointment.hora_chegada ? '#f0fdf4' : '#f9fafb'}
                                border={selectedSidebarAppointment.hora_chegada ? '#bbf7d0' : '#e5e7eb'}
                            />
                        )}

                        {/* Chamar Painel */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id && selectedSidebarAppointment.status === 'Agendada' && selectedSidebarAppointment.hora_chegada && (
                            <SidebarActionButton
                                onClick={() => handleChamarPaciente(selectedSidebarAppointment.id)}
                                disabled={loadingChamar[selectedSidebarAppointment.id]}
                                loading={loadingChamar[selectedSidebarAppointment.id]}
                                icon={faBullhorn}
                                label="Chamar Painel"
                                color="#8b5cf6" bg="#f5f3ff" border="#ddd6fe"
                            />
                        )}

                        {/* Receber Pagamento */}
                        {(((selectedSidebarAppointment.status === 'Agendada' || selectedSidebarAppointment.status === 'Realizada') && selectedSidebarAppointment.payment_status === 'Aguardando Pagamento') ||
                          ((selectedSidebarAppointment.payment_status === 'Pago' || selectedSidebarAppointment.payment_status === 'Aguardando Pagamento') && selectedSidebarAppointment.status === 'Aguardando Pagamento')) && canShowPayButton && (
                            <SidebarActionButton
                                onClick={() => handleOpenPaymentModal(selectedSidebarAppointment)}
                                icon={faDollarSign}
                                label="Receber Pagamento"
                                color="#ef4444" bg="#fef2f2" border="#fecaca"
                            />
                        )}

                        {/* Detalhes do Pagamento */}
                        {selectedSidebarAppointment.payment_status === 'Pago' && (currentUserRole === 'Representante Legal' || !!currentUser?.is_gerente) && (
                            <SidebarActionButton
                                onClick={() => handleOpenPaymentDetailsModal(selectedSidebarAppointment)}
                                icon={faMoneyBillWave}
                                label="Detalhes do Pagamento"
                                color="#0ea5e9" bg="#f0f9ff" border="#bae6fd"
                            />
                        )}

                        {/* Cancelar Pagamento */}
                        {selectedSidebarAppointment.payment_status === 'Pago' && canShowCancelPayButton &&
                            ((selectedSidebarAppointment.servicos?.length || 0) > 1 || !selectedSidebarAppointment.paciente_pacote_id || selectedSidebarAppointment.pagamento?.length > 0) && (
                            <SidebarActionButton
                                onClick={() => handleOpenCancelPaymentModal(selectedSidebarAppointment)}
                                icon={faBan}
                                label="Cancelar Pagamento"
                                color="#f59e0b" bg="#fffbeb" border="#fde68a"
                            />
                        )}

                        {/* Reagendar */}
                        {selectedSidebarAppointment.status === 'Agendada' && !selectedSidebarAppointment.hora_chegada && (
                            <SidebarActionButton
                                onClick={() => handleOpenRescheduleModal(selectedSidebarAppointment)}
                                icon={faCalendarAlt}
                                label="Reagendar"
                                color="#6b7280" bg="#f9fafb" border="#e5e7eb"
                            />
                        )}

                        {/* Alterar Profissional */}
                        {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && selectedSidebarAppointment.status === 'Agendada' && (
                            <SidebarActionButton
                                onClick={() => {
                                    setAppointmentToChangeProf(selectedSidebarAppointment);
                                    setAvailableDoctors([]);
                                    setChangeProfError(null);
                                    setNewProfessionalId('');
                                    setShowChangeProfModal(true);
                                }}
                                icon={faUserMd}
                                label="Alterar Profissional"
                                color="#374151" bg="#f9fafb" border="#e5e7eb"
                            />
                        )}

                        {/* Reutilizar Horário */}
                        {['Cancelada', 'Faltou', 'Desmarcada'].includes(selectedSidebarAppointment.status) && (
                            <SidebarActionButton
                                onClick={() => {
                                    const date = new Date(selectedSidebarAppointment.data_agendamento + 'T00:00:00');
                                    const time = selectedSidebarAppointment.hora_marcada.slice(0, 5);
                                    handleTimeSlotClick(time, date, null, null, true);
                                    setIsDrawerOpen(false);
                                }}
                                icon={faPlus}
                                label="Reutilizar Horário"
                                color="#16a34a" bg="#f0fdf4" border="#bbf7d0"
                            />
                        )}

                        {/* Retomar Atendimento */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id &&
                            (selectedSidebarAppointment.status === 'Realizada' || selectedSidebarAppointment.status === 'Aguardando Pagamento') &&
                            selectedSidebarAppointment.payment_status !== 'Pago' && (
                            <SidebarActionButton
                                onClick={() => handleRetomarAtendimento(selectedSidebarAppointment.id)}
                                disabled={loadingStatusChanges[selectedSidebarAppointment.id]}
                                loading={loadingStatusChanges[selectedSidebarAppointment.id]}
                                icon={faStethoscope}
                                label="Rever Atendimento"
                                color="#3b82f6" bg="#eff6ff" border="#bfdbfe"
                            />
                        )}

                        {/* Cancelar / Faltou */}
                        {['Agendada', 'Aguardando Pagamento', 'Confirmada'].includes(selectedSidebarAppointment.status) && (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                <SidebarActionButton
                                    onClick={() => handleStatusChange(selectedSidebarAppointment.id, 'Cancelada')}
                                    disabled={loadingStatusChanges[selectedSidebarAppointment.id]}
                                    loading={loadingStatusChanges[selectedSidebarAppointment.id]}
                                    icon={faBan}
                                    label="Cancelar"
                                    color="#ef4444" bg="#fef2f2" border="#fecaca"
                                />
                                <SidebarActionButton
                                    onClick={() => handleStatusChange(selectedSidebarAppointment.id, 'Faltou')}
                                    disabled={loadingStatusChanges[selectedSidebarAppointment.id]}
                                    loading={loadingStatusChanges[selectedSidebarAppointment.id]}
                                    icon={faUserMd}
                                    label="Faltou"
                                    color="#6b7280" bg="#f9fafb" border="#e5e7eb"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
})()}

{/* Effects do Drawer (fora do JSX, dentro do componente) */}
{React.useEffect(() => {
    if (selectedSidebarAppointment) {
        const updatedAppointment = fiveDayAppointments.find(app => app.id === selectedSidebarAppointment.id);
        if (updatedAppointment) {
            if (updatedAppointment !== selectedSidebarAppointment) {
                setSelectedSidebarAppointment(updatedAppointment);
            }
        } else {
            setSelectedSidebarAppointment(null);
            setIsDrawerOpen(false);
        }
    }
}, [fiveDayAppointments, selectedSidebarAppointment])}

{React.useEffect(() => {
    let isMounted = true;
    const fetchDetails = async () => {
        if (!selectedSidebarAppointment) {
            if (isMounted) setSidebarDetails({ services: [], total: 0, loading: false, valorAdicional: 0, valorDesconto: 0, valorJaPago: 0 });
            return;
        }
        if (isMounted) setSidebarDetails(prev => ({ ...prev, loading: true }));
        try {
            let services = [];
            let total = 0;
            let valorAdicional = 0;
            let valorDesconto = 0;
            let valorJaPago = 0;
            let appointmentData = selectedSidebarAppointment;
            if (appointmentData.status === 'Aguardando Pagamento' && appointmentData.paciente_pacote_id && !appointmentData.paciente_pacote) {
                try {
                    const res = await axios.get(`/api/agendamentos/${appointmentData.id}`);
                    if (res.data) appointmentData = { ...res.data, pagamento: res.data.pagamento || appointmentData.pagamento };
                } catch (e) { console.error("Erro ao buscar detalhes do pacote:", e); }
            }
            if (appointmentData.pagamento && appointmentData.pagamento.length > 0) {
                valorJaPago = appointmentData.pagamento.reduce((acc, p) => p.status_pagamento === 'Confirmado' ? acc + parseFloat(p.valor_total_pago || 0) : acc, 0);
            }
            if (appointmentData.payment_status === 'Pago') {
                let pagamentos = appointmentData.pagamento;
                if (!pagamentos || pagamentos.length === 0) {
                    const res = await axios.get(`/api/agendamentos/${appointmentData.id}`);
                    pagamentos = res.data.agendamento?.pagamento || [];
                }
                if (pagamentos && pagamentos.length > 0) {
                    const allServicesMap = new Map();
                    pagamentos.forEach(p => {
                        total += parseFloat(p.valor_total_pago || 0);
                        valorAdicional += parseFloat(p.valor_adicional || 0);
                        p.servicos.forEach(s => {
                            const val = parseFloat(s.pivot.valor_servico_no_momento_pagamento || 0);
                            const qtd = s.pivot.quantidade ? parseInt(s.pivot.quantidade, 10) : 1;
                            if (allServicesMap.has(s.id)) {
                                const existing = allServicesMap.get(s.id);
                                existing.quantidade += qtd;
                                existing.valor += val;
                            } else {
                                allServicesMap.set(s.id, { id: s.id, nome: s.nome, valor: val, isPacote: false, quantidade: qtd, comissionado: s.pivot.comissionado, valor_comissao: s.pivot.valor_comissao, tipo_comissao: s.pivot.tipo_comissao, funcionario_id: s.pivot.funcionario_id });
                            }
                        });
                    });
                    services = Array.from(allServicesMap.values());
                }
            } else if (appointmentData.status === 'Realizada' || appointmentData.status === 'Aguardando Pagamento') {
                const response = await axios.get(`/api/consultas/agendamento/${appointmentData.id}`);
                const consulta = response.data.consulta;
                if (consulta) {
                    const procedimentosInfo = JSON.parse(consulta.procedimentos || '[]');
                    const baseServices = consulta.servicos || appointmentData.servicos || [];
                    services = baseServices.map(s => {
                        const proc = procedimentosInfo.find(p => p.nome === s.nome);
                        const qtd = proc ? (parseInt(proc.quantidade, 10) || 1) : 1;
                        const isPacote = s.numero_sessoes > 1 || s.has_active_package;
                        let totalItem = 0;
                        if (s.has_active_package) { totalItem = 0; }
                        else if (s.pivot && s.pivot.valor_servico !== undefined) { totalItem = parseFloat(s.pivot.valor_servico) * qtd; }
                        else { let unitValue = parseFloat(s.valor || 0); if (proc && proc.valor_unitario !== undefined) unitValue = parseFloat(proc.valor_unitario); totalItem = unitValue * qtd; }
                        total += totalItem;
                        return { id: s.id, nome: s.nome, valor: totalItem, quantidade: qtd, isPacote };
                    });
                }
            }
            if (services.length === 0 && appointmentData.servicos) {
                const fallbackMap = new Map();
                appointmentData.servicos.forEach(s => {
                    const isPacote = s.numero_sessoes > 1 || s.has_active_package;
                    let val = parseFloat(s.valor || 0);
                    if (s.has_active_package) { val = 0; }
                    else if (s.pivot && s.pivot.valor_servico !== undefined) { val = parseFloat(s.pivot.valor_servico); }
                    total += val;
                    if (fallbackMap.has(s.id)) { const existing = fallbackMap.get(s.id); existing.quantidade += 1; existing.valor += val; }
                    else { fallbackMap.set(s.id, { id: s.id, nome: s.nome, valor: val, quantidade: 1, isPacote }); }
                });
                services = Array.from(fallbackMap.values());
            }
            if (isMounted) setSidebarDetails({ services, total, valorAdicional, valorDesconto, valorJaPago, loading: false });
        } catch (error) {
            console.error("Erro ao calcular detalhes da sidebar:", error);
            if (isMounted) setSidebarDetails(prev => ({ ...prev, loading: false }));
        }
    };
    fetchDetails();
    return () => { isMounted = false; };
}, [selectedSidebarAppointment])}
   

      {/* Modal de Agendamento */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <div>
                      <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                          Novo Agendamento
                      </Modal.Title>
                      {newAppointment.data_agendamento && (
                          <div style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', marginTop: '1px' }}>
                              {new Date(newAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' })}
                              {newAppointment.hora_marcada && ` às ${newAppointment.hora_marcada}`}
                          </div>
                      )}
                  </div>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              <Form>
                  {/* Seletor de Médico/Especialidade */}
                  {(currentUserRole !== 'Médico' || isReusingSlot) && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                          <div>
                              <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                  Especialidade *
                              </label>
                              <Form.Control
                                  as="select"
                                  name="especialidade_id"
                                  value={newAppointment.especialidade_id}
                                  onChange={handleModalFormChange}
                                  required
                                  style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }}
                              >
                                  <option value="">Selecione...</option>
                                  {especialidades.map(esp => <option key={esp.id} value={esp.id}>{esp.nome}</option>)}
                              </Form.Control>
                          </div>
                          <div>
                              <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                  Médico *
                              </label>
                              <Form.Control
                                  as="select"
                                  name="medico_id"
                                  value={newAppointment.medico_id}
                                  onChange={handleModalFormChange}
                                  required
                                  disabled={!newAppointment.especialidade_id}
                                  style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }}
                              >
                                  <option value="">Selecione a especialidade</option>
                                  {todosMedicos
                                      .filter(m => m.especialidade_id === parseInt(newAppointment.especialidade_id))
                                      .map(med => <option key={med.id} value={med.id}>{med.nome}</option>)}
                              </Form.Control>
                          </div>
                      </div>
                  )}

                  {/* Info do profissional (médico logado) */}
                  {currentUserRole === 'Médico' && !isReusingSlot && (
                      <div style={{
                          padding: '10px 14px', borderRadius: '8px', marginBottom: '16px',
                          backgroundColor: '#eff6ff', border: '1px solid #bfdbfe',
                          display: 'flex', alignItems: 'center', gap: '8px',
                      }}>
                          <FontAwesomeIcon icon={faUserMd} style={{ color: '#3b82f6', fontSize: `calc(13px * var(--font-scale))` }} />
                          <div>
                              <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#3b82f6', textTransform: 'uppercase' }}>Profissional</div>
                              <div style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#1e40af' }}>
                                  {todosMedicos.find(m => m.id === parseInt(newAppointment.medico_id))?.nome || '—'}
                                  <span style={{ margin: '0 6px', color: '#93c5fd' }}>|</span>
                                  {especialidades.find(e => e.id === parseInt(newAppointment.especialidade_id))?.nome || '—'}
                              </div>
                          </div>
                      </div>
                  )}

                  {/* Paciente */}
                  <div style={{ marginBottom: '16px' }}>
                      <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                          Paciente *
                      </label>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                          <div ref={pacienteDropdownRef} style={{ position: 'relative', flex: 1 }}>
                              <Form.Control
                                  type="text"
                                  placeholder="Digite para buscar um paciente..."
                                  value={pacienteSearch}
                                  onChange={(e) => {
                                      setPacienteSearch(e.target.value);
                                      setShowPacientesDropdown(true);
                                      if (newAppointment.paciente_id) {
                                          setNewAppointment({ ...newAppointment, paciente_id: '' });
                                          setSelectedPackageId(null);
                                          setSelectedServicos([]);
                                      }
                                  }}
                                  onFocus={() => setShowPacientesDropdown(true)}
                                  required={!newAppointment.paciente_id}
                                  autoComplete="off"
                                  style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: newAppointment.paciente_id ? '#22c55e' : '#e5e7eb', borderRadius: '8px' }}
                              />
                              {newAppointment.paciente_id && (
                                  <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                      <FontAwesomeIcon icon={faCheck} style={{ color: '#22c55e', fontSize: `calc(12px * var(--font-scale))` }} />
                                  </div>
                              )}
                              {showPacientesDropdown && (
                                  <ListGroup style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000, maxHeight: '200px', overflowY: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                      {filteredPacientes.length > 0 ? (
                                          filteredPacientes.slice(0, 6).map(patient => (
                                              <ListGroup.Item
                                                  key={patient.id}
                                                  action
                                                  style={{ fontSize: `calc(13px * var(--font-scale))`, cursor: 'pointer', padding: '8px 12px' }}
                                                  onClick={() => {
                                                      setNewAppointment({ ...newAppointment, paciente_id: patient.id });
                                                      setPacienteSearch(patient.nome);
                                                      setShowPacientesDropdown(false);
                                                  }}
                                              >
                                                  {patient.nome}
                                              </ListGroup.Item>
                                          ))
                                      ) : (
                                          <ListGroup.Item disabled style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af' }}>
                                              Nenhum paciente encontrado.
                                          </ListGroup.Item>
                                      )}
                                  </ListGroup>
                              )}
                          </div>
                          <button
                              type="button"
                              onClick={handleOpenCreatePatientModal}
                              title="Cadastrar novo paciente"
                              style={{
                                  width: '38px', height: '38px', borderRadius: '8px', flexShrink: 0,
                                  backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0',
                                  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              }}
                          >
                              <img src={addPatientIcon} alt="Novo paciente" style={{ width: '22px', height: '22px', borderRadius: '4px' }} />
                          </button>
                      </div>
                  </div>

                  {/* Tipo + Data/Hora */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                              Tipo
                          </label>
                          <Form.Control
                              as="select"
                              name="tipo"
                              value={newAppointment.tipo || 'Consulta'}
                              onChange={(e) => setNewAppointment({ ...newAppointment, tipo: e.target.value })}
                              style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }}
                          >
                              <option value="Consulta">Consulta</option>
                              <option value="Retorno">Retorno</option>
                              <option value="Procedimento">Procedimento</option>
                          </Form.Control>
                      </div>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                              Data
                          </label>
                          <div style={{ padding: '7px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151' }}>
                              {newAppointment.data_agendamento ? new Date(newAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR') : '—'}
                          </div>
                      </div>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                              Horário
                          </label>
                          <div style={{ padding: '7px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontWeight: '600' }}>
                              {newAppointment.hora_marcada || '—'}
                          </div>
                      </div>
                  </div>

                  {/* Serviços */}
                  <div style={{ marginBottom: '16px' }}>
                      <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                          Serviços
                      </label>
                      <Select
                          isMulti
                          options={(servicos || []).filter(servico => {
                              if (servico.ativo) return true;
                              return pacientePacotesAtivos.some(p => p.servico_id === servico.id);
                          }).map(servico => {
                              const pacoteAtivo = pacientePacotesAtivos.find(p => p.servico_id === servico.id);
                              const label = `${servico.nome}${pacoteAtivo ? ` (Pacote - ${pacoteAtivo.sessoes_restantes} restantes)` : ''}`;
                              return {
                                  value: servico.id, label,
                                  pacoteId: pacoteAtivo ? pacoteAtivo.id : null,
                                  isDisabled: !pacoteAtivo && selectedPackageId !== null
                              };
                          })}
                          value={servicos.filter(s => selectedServicos.includes(s.id)).map(s => ({ value: s.id, label: s.nome }))}
                          onChange={(selectedOptions) => {
                              const lastSelected = selectedOptions[selectedOptions.length - 1];
                              handleServicoChange(lastSelected?.value, lastSelected?.pacoteId);
                          }}
                          placeholder="Buscar serviços..."
                          noOptionsMessage={() => 'Nenhum serviço encontrado'}
                          styles={{
                              control: (base) => ({ ...base, fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }),
                              option: (base) => ({ ...base, fontSize: `calc(13px * var(--font-scale))` }),
                          }}
                      />
                  </div>

                  {/* Interesses */}
                  {newAppointment.paciente_id && filteredInteresseOptions.length > 0 && (
                      <div style={{ marginBottom: '16px' }}>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                              Adicionar Interesses <span style={{ fontWeight: '400', textTransform: 'none', fontSize: `calc(11px * var(--font-scale))` }}>(opcional)</span>
                          </label>
                          <Select
                              isMulti
                              options={filteredInteresseOptions}
                              placeholder="Selecione para adicionar..."
                              noOptionsMessage={() => 'Nenhuma nova tag disponível'}
                              value={newAppointment.interesses}
                              onChange={(selectedOptions) => setNewAppointment({ ...newAppointment, interesses: selectedOptions || [] })}
                              styles={{
                                  control: (base) => ({ ...base, fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }),
                                  option: (base) => ({ ...base, fontSize: `calc(13px * var(--font-scale))` }),
                              }}
                          />
                          <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                              Mostrando apenas interesses que o paciente ainda não possui.
                          </p>
                      </div>
                  )}
              </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px' }}>
              <button
                  onClick={handleCloseModal}
                  style={{
                      padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
                      backgroundColor: '#fff', color: '#374151', cursor: 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500',
                  }}
              >
                  Cancelar
              </button>
              <button
                  onClick={handleCreateAppointment}
                  disabled={isLoadingCreate}
                  style={{
                      padding: '8px 20px', borderRadius: '8px', border: 'none',
                      background: isLoadingCreate ? '#93c5fd' : 'linear-gradient(135deg, #3b82f6, #2563eb)',
                      color: '#fff', cursor: isLoadingCreate ? 'not-allowed' : 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                      display: 'flex', alignItems: 'center', gap: '8px',
                  }}
              >
                  {isLoadingCreate && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                  {isLoadingCreate ? 'Agendando...' : 'Confirmar Agendamento'}
              </button>
          </Modal.Footer>
      </Modal>


      {/* Modal de Cadastro de Paciente */}
      <Modal show={showCreatePatientModal} onHide={handleCloseCreatePatientModal} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faUserMd} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Cadastrar Novo Paciente
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  {/* Nome */}
                  <div>
                      <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Nome *</label>
                      <Form.Control type="text" name="nome" value={newPatient.nome} onChange={handleNewPatientInputChange} required placeholder="Nome completo" style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />
                  </div>

                  {/* CPF + Data Nascimento */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>CPF *</label>
                          <InputMask mask="999.999.999-99" value={newPatient.cpf} onChange={handleNewPatientInputChange} name="cpf">
                              {(inputProps) => <Form.Control {...inputProps} type="text" required placeholder="000.000.000-00" style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />}
                          </InputMask>
                      </div>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Nascimento *</label>
                          <Form.Control type="date" name="data_nascimento" value={newPatient.data_nascimento} onChange={handleNewPatientInputChange} required style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />
                      </div>
                  </div>

                  {/* Sexo + Telefone */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Sexo *</label>
                          <Form.Control as="select" name="sexo" value={newPatient.sexo} onChange={handleNewPatientInputChange} required style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }}>
                              <option value="N">Selecione...</option>
                              <option value="M">Masculino</option>
                              <option value="F">Feminino</option>
                              <option value="O">Outro</option>
                          </Form.Control>
                      </div>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Telefone *</label>
                          <InputMask mask="(99) 99999-9999" value={`${newPatient.dddcelular}${newPatient.celular}`} onChange={handleNewPatientPhoneChange} name="telefone">
                              {(inputProps) => <Form.Control {...inputProps} type="tel" required placeholder="(00) 00000-0000" style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />}
                          </InputMask>
                      </div>
                  </div>

                  {/* Email */}
                  <div>
                      <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Email *</label>
                      <Form.Control type="email" name="email" value={newPatient.email} onChange={handleNewPatientInputChange} required placeholder="email@exemplo.com" style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />
                  </div>

                  {/* Endereço + Convênio */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Endereço</label>
                          <Form.Control type="text" name="endereco" value={newPatient.endereco} onChange={handleNewPatientInputChange} placeholder="Rua, número..." style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />
                      </div>
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>Convênio</label>
                          <Form.Control type="text" name="op_convenio" value={newPatient.op_convenio} onChange={handleNewPatientInputChange} placeholder="Opcional" style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }} />
                      </div>
                  </div>
              </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px' }}>
              <button
                  onClick={handleCloseCreatePatientModal}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Cancelar
              </button>
              <button
                  onClick={handleCreatePatient}
                  disabled={isCreatingPatient}
                  style={{
                      padding: '8px 20px', borderRadius: '8px', border: 'none',
                      background: isCreatingPatient ? '#86efac' : 'linear-gradient(135deg, #22c55e, #16a34a)',
                      color: '#fff', cursor: isCreatingPatient ? 'not-allowed' : 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                      display: 'flex', alignItems: 'center', gap: '8px',
                  }}
              >
                  {isCreatingPatient && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                  {isCreatingPatient ? 'Cadastrando...' : 'Cadastrar Paciente'}
              </button>
          </Modal.Footer>
      </Modal>

     
      {/* Outros Modais */}
      <PaymentModal
        show={showPaymentModal}
        handleClose={handleClosePaymentModal}
        appointment={selectedAppointmentForPayment}
        // --- CORREÇÃO: Passa para o modal de pagamento apenas os serviços ativos ---
        allServices={(servicos || []).filter(s => s.ativo)}
        allFuncionarios={allFuncionarios} // Passa a lista completa de funcionários
        onPaymentConfirm={handlePaymentConfirmation}
        />

      {/* 2. Renderizar o novo componente */}
      <CommunicationModal
        show={showCommunicationModal}
        onHide={() => setShowCommunicationModal(false)}
        appointments={calendarAppointments}
        pacientesList={pacientesList}
        todosMedicos={todosMedicos}
        especialidades={especialidades}
        currentEntidade={currentEntidade}
        currentUser={currentUser}
        onSendComplete={onAppointmentStatusChange} // Notifica o pai para re-buscar os dados
      />

      {/* Modal de Reagendamento */}
      <Modal show={showRescheduleModal} onHide={handleCloseRescheduleModal} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Reagendar Consulta
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              {appointmentToReschedule && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      {/* Info atual */}
                      <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #e5e7eb' }}>
                          <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
                              Agendamento Atual
                          </div>
                          <div style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                              {appointmentToReschedule.paciente?.nome}
                          </div>
                          <div style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: `calc(11px * var(--font-scale))` }} />
                              {new Date(appointmentToReschedule.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')} às {appointmentToReschedule.hora_marcada.slice(0, 5)}
                          </div>
                      </div>

                      {/* Nova data */}
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>
                              Nova Data
                          </label>
                          <DatePicker
                              selected={newScheduleDate}
                              onChange={(date) => setNewScheduleDate(date)}
                              dateFormat="dd/MM/yyyy"
                              locale="pt-BR"
                              className="form-control"
                              minDate={new Date()}
                              filterDate={filterRescheduleDates}
                              wrapperClassName="w-100"
                          />
                      </div>

                      {/* Horários disponíveis */}
                      <div>
                          <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>
                              Horários Disponíveis
                          </label>
                          {isLoadingSlots ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))` }}>
                                  <Spinner animation="border" size="sm" variant="primary" />
                                  Buscando horários...
                              </div>
                          ) : newAvailableSlots.length > 0 ? (
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                  {newAvailableSlots.map(slot => (
                                      <button
                                          key={slot}
                                          onClick={() => setSelectedNewTime(slot)}
                                          style={{
                                              padding: '6px 14px', borderRadius: '8px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500',
                                              border: selectedNewTime === slot ? 'none' : '1px solid #e5e7eb',
                                              backgroundColor: selectedNewTime === slot ? '#3b82f6' : '#fff',
                                              color: selectedNewTime === slot ? '#fff' : '#374151',
                                              cursor: 'pointer', transition: 'all 0.15s',
                                          }}
                                      >
                                          {slot}
                                      </button>
                                  ))}
                              </div>
                          ) : (
                              <div style={{ padding: '12px 14px', borderRadius: '8px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', fontSize: `calc(13px * var(--font-scale))`, color: '#92400e' }}>
                                  Não há horários disponíveis para esta data.
                              </div>
                          )}
                      </div>
                  </div>
              )}
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px' }}>
              <button
                  onClick={handleCloseRescheduleModal}
                  disabled={isLoadingReschedule}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Cancelar
              </button>
              <button
                  onClick={handleConfirmReschedule}
                  disabled={!selectedNewTime || isLoadingReschedule}
                  style={{
                      padding: '8px 20px', borderRadius: '8px', border: 'none',
                      background: (!selectedNewTime || isLoadingReschedule) ? '#d1d5db' : 'linear-gradient(135deg, #f59e0b, #d97706)',
                      color: '#fff', cursor: (!selectedNewTime || isLoadingReschedule) ? 'not-allowed' : 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                      display: 'flex', alignItems: 'center', gap: '8px',
                  }}
              >
                  {isLoadingReschedule && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                  {isLoadingReschedule ? 'Reagendando...' : 'Confirmar Reagendamento'}
              </button>
          </Modal.Footer>
      </Modal>


      {/* Modal do Calendário */}
      <Modal show={showCalendarModal} onHide={() => setShowCalendarModal(false)} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Selecione uma Data
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                  <Calendar
                      onChange={(date) => {
                          handleDateChange(date);
                          setShowCalendarModal(false);
                      }}
                      value={selectedDate}
                      activeStartDate={activeStartDate}
                      tileClassName={({ date, view }) => getTileClass({ date, view, getFeriadoNome, availabilityData, nextAvailableDate, totalSlotsDisponiveis })}
                      tileDisabled={isTileDisabled}
                      onActiveStartDateChange={handleActiveStartDateChange}
                  />
              </div>

              {/* Legenda */}
              <div style={{
                  display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center',
                  padding: '12px 14px', borderRadius: '10px',
                  backgroundColor: '#fff', border: '1px solid #e5e7eb',
              }}>
                  {[
                      { color: '#22c55e', label: 'Próx. Vaga' },
                      { color: '#ef4444', label: 'Sem Vagas' },
                      { color: '#f59e0b', label: 'Feriado' },
                      { color: '#6b7280', label: 'Bloqueado' },
                  ].map(item => (
                      <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: item.color, flexShrink: 0 }} />
                          <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#6b7280' }}>{item.label}</span>
                      </div>
                  ))}
              </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <button
                  onClick={() => setShowCalendarModal(false)}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Fechar
              </button>
          </Modal.Footer>
      </Modal>

      {/* Modal Alterar Profissional */}
      <Modal show={showChangeProfModal} onHide={() => setShowChangeProfModal(false)} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faUserMd} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Alterar Profissional
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              {changeProfError && (
                  <div style={{ padding: '10px 14px', borderRadius: '8px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '16px' }}>
                      {changeProfError}
                  </div>
              )}
              <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Paciente</div>
                  <div style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>{appointmentToChangeProf?.paciente?.nome}</div>
              </div>
              <div>
                  <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                      Novo Profissional
                  </label>
                  <Form.Select
                      value={newProfessionalId}
                      onChange={(e) => setNewProfessionalId(e.target.value)}
                      isInvalid={!!changeProfError}
                      style={{ fontSize: `calc(13px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '8px' }}
                  >
                      <option value="">Selecione um profissional...</option>
                      {(availableDoctors.length > 0 ? availableDoctors : todosMedicos).map(medico => (
                          <option key={medico.id} value={medico.id}>{medico.nome}</option>
                      ))}
                  </Form.Select>
              </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px' }}>
              <button
                  onClick={() => setShowChangeProfModal(false)}
                  disabled={isUpdatingProfessional}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Cancelar
              </button>
              <button
                  disabled={!newProfessionalId || isUpdatingProfessional}
                  onClick={async () => {
                      if (!appointmentToChangeProf) return;
                      setIsUpdatingProfessional(true);
                      setChangeProfError(null);
                      setAvailableDoctors([]);
                      try {
                          const response = await axios.put(`/api/agendamentos/${appointmentToChangeProf.id}/change-professional`, { medico_id: newProfessionalId });
                          onAppointmentStatusChange(response.data.agendamento);
                          showAlertModal('Sucesso', 'Profissional alterado com sucesso!', 'success');
                          setShowChangeProfModal(false);
                      } catch (error) {
                          if (error.response && error.response.status === 409) {
                              setChangeProfError(error.response.data.message);
                              setAvailableDoctors(error.response.data.available_doctors || []);
                          } else {
                              showAlertModal('Erro', `Falha ao alterar profissional: ${error.response?.data?.message || 'Tente novamente.'}`, 'danger');
                          }
                      } finally {
                          setIsUpdatingProfessional(false);
                      }
                  }}
                  style={{
                      padding: '8px 20px', borderRadius: '8px', border: 'none',
                      background: (!newProfessionalId || isUpdatingProfessional) ? '#d1d5db' : 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                      color: '#fff', cursor: (!newProfessionalId || isUpdatingProfessional) ? 'not-allowed' : 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                      display: 'flex', alignItems: 'center', gap: '8px',
                  }}
              >
                  {isUpdatingProfessional && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                  {isUpdatingProfessional ? 'Alterando...' : 'Confirmar Alteração'}
              </button>
          </Modal.Footer>
      </Modal>

      {/* Modal Cancelar Pagamento */}
      <Modal show={showCancelPaymentModal} onHide={() => setShowCancelPaymentModal(false)} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faBan} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Cancelar Pagamento
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Paciente</div>
                  <div style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>{appointmentToCancelPayment?.paciente?.nome}</div>
              </div>
              <div style={{ padding: '12px 14px', borderRadius: '8px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', fontSize: `calc(13px * var(--font-scale))`, color: '#92400e', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                  <FontAwesomeIcon icon={faBan} style={{ color: '#f59e0b', marginTop: '1px', flexShrink: 0 }} />
                  <div>
                      <strong>Atenção:</strong> Esta ação irá reverter o status do agendamento para "Aguardando Pagamento" e devolverá os materiais utilizados ao estoque.
                  </div>
              </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px' }}>
              <button
                  onClick={() => setShowCancelPaymentModal(false)}
                  disabled={isCancelingPayment}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Não, Manter
              </button>
              <button
                  onClick={handleConfirmCancelPayment}
                  disabled={isCancelingPayment}
                  style={{
                      padding: '8px 20px', borderRadius: '8px', border: 'none',
                      background: isCancelingPayment ? '#fca5a5' : 'linear-gradient(135deg, #ef4444, #dc2626)',
                      color: '#fff', cursor: isCancelingPayment ? 'not-allowed' : 'pointer',
                      fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                      display: 'flex', alignItems: 'center', gap: '8px',
                  }}
              >
                  {isCancelingPayment && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                  {isCancelingPayment ? 'Cancelando...' : 'Sim, Cancelar Pagamento'}
              </button>
          </Modal.Footer>
      </Modal>

      {/* Modal de Detalhes do Pagamento */}
      <Modal show={showPaymentDetailsModal} onHide={handleClosePaymentDetailsModal} centered size="lg">
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #10b981, #059669)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faMoneyBillWave} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Detalhes do Pagamento
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              {selectedPaymentDetails && selectedPaymentDetails.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {selectedPaymentDetails.map((payment, index) => (
                          <div key={payment.id} style={{
                              backgroundColor: '#fff', borderRadius: '12px',
                              border: '1px solid #e5e7eb', overflow: 'hidden',
                          }}>
                              {/* Header do pagamento */}
                              <div style={{
                                  padding: '12px 16px', backgroundColor: '#f0fdf4',
                                  borderBottom: '1px solid #bbf7d0',
                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                              }}>
                                  <div>
                                      <div style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>
                                          Pagamento #{payment.id}
                                      </div>
                                      <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#6b7280', marginTop: '2px' }}>
                                          {new Date(payment.created_at).toLocaleString('pt-BR')}
                                      </div>
                                  </div>
                                  <div style={{ textAlign: 'right' }}>
                                      <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#16a34a' }}>
                                          {formatCurrency(payment.valor_total_pago)}
                                      </div>
                                      <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#6b7280' }}>
                                          {payment.forma_pagamento}
                                      </div>
                                  </div>
                              </div>

                              {/* Serviços */}
                              <div style={{ padding: '12px 16px' }}>
                                  <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
                                      Serviços
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                      {payment.servicos && payment.servicos.map(servico => {
                                          const funcionarioComissao = servico.pivot.funcionario_id && allFuncionarios
                                              ? allFuncionarios.find(f => f.id === servico.pivot.funcionario_id)
                                              : null;
                                          const originalService = selectedAppointmentForDetails?.servicos?.find(s => s.id === servico.id);
                                          const origin = originalService?.origin;

                                          return (
                                              <div key={servico.id} style={{
                                                  padding: '10px 12px', borderRadius: '8px',
                                                  backgroundColor: '#f9fafb', border: '1px solid #f3f4f6',
                                              }}>
                                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: servico.pivot.comissionado == 1 ? '6px' : '0' }}>
                                                      <div style={{ flex: 1 }}>
                                                          <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontWeight: '500' }}>
                                                              {servico.nome}
                                                          </span>
                                                          {origin && (
                                                              <span style={{
                                                                  marginLeft: '6px', fontSize: `calc(10px * var(--font-scale))`, fontWeight: '600',
                                                                  padding: '1px 6px', borderRadius: '999px',
                                                                  backgroundColor: origin === 'agendamento' ? '#dbeafe' : '#f3f4f6',
                                                                  color: origin === 'agendamento' ? '#1d4ed8' : '#6b7280',
                                                              }}>
                                                                  {origin === 'agendamento' ? 'Original' : 'Adicional'}
                                                              </span>
                                                          )}
                                                      </div>
                                                      <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#111827', marginLeft: '8px', flexShrink: 0 }}>
                                                          {formatCurrency(servico.pivot.valor_servico_no_momento_pagamento)}
                                                      </span>
                                                  </div>

                                                  {/* Comissão */}
                                                  {servico.pivot.comissionado == 1 && (
                                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: `calc(11px * var(--font-scale))`, color: '#16a34a' }}>
                                                          <FontAwesomeIcon icon={faMoneyBillWave} style={{ fontSize: `calc(10px * var(--font-scale))` }} />
                                                          <span>
                                                              {servico.pivot.tipo_comissao === 'indicacao' ? 'Indicação: ' : 'Comissão: '}
                                                              <strong>{formatCurrency(servico.pivot.valor_comissao)}</strong>
                                                              {servico.pivot.percentual_comissao_pago > 0 && (
                                                                  <span style={{ color: '#9ca3af', marginLeft: '3px' }}>
                                                                      ({parseFloat(servico.pivot.percentual_comissao_pago).toFixed(2)}%)
                                                                  </span>
                                                              )}
                                                              {funcionarioComissao && <span style={{ color: '#6b7280' }}> → {funcionarioComissao.nome}</span>}
                                                              {!funcionarioComissao && servico.pivot.funcionario_id && (
                                                                  <span style={{ color: '#ef4444' }}> (Profissional não encontrado)</span>
                                                              )}
                                                          </span>
                                                      </div>
                                                  )}

                                                  {/* Adicionar Comissão */}
                                                  {servico.pivot.comissionado == 0 && (currentUserRole === 'Representante Legal' || currentUser?.is_gerente) && (
                                                      <div style={{ marginTop: '8px' }}>
                                                          {editingCommission.paymentId === payment.id && editingCommission.serviceId === servico.id ? (
                                                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                                                  <Form.Select
                                                                      size="sm"
                                                                      value={selectedProfessionalForCommission}
                                                                      onChange={(e) => setSelectedProfessionalForCommission(e.target.value)}
                                                                      style={{ maxWidth: '180px', fontSize: `calc(12px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '6px' }}
                                                                  >
                                                                      <option value="">Selecione...</option>
                                                                      {commissionableEmployees.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                                                  </Form.Select>
                                                                  <Form.Control
                                                                      type="number"
                                                                      size="sm"
                                                                      style={{ maxWidth: '60px', fontSize: `calc(12px * var(--font-scale))`, borderColor: '#e5e7eb', borderRadius: '6px' }}
                                                                      value={commissionPercentage}
                                                                      onChange={(e) => setCommissionPercentage(e.target.value)}
                                                                      placeholder="%"
                                                                      min="0"
                                                                      max="100"
                                                                  />
                                                                  <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>%</span>
                                                                  <button
                                                                      onClick={() => handleSaveCommission(payment.id, servico.id)}
                                                                      disabled={isAddingCommission}
                                                                      style={{
                                                                          padding: '4px 10px', borderRadius: '6px', border: 'none',
                                                                          backgroundColor: '#22c55e', color: '#fff',
                                                                          fontSize: `calc(11px * var(--font-scale))`, cursor: 'pointer',
                                                                          display: 'flex', alignItems: 'center', gap: '4px',
                                                                      }}
                                                                  >
                                                                      {isAddingCommission ? <Spinner size="sm" style={{ width: '10px', height: '10px' }} /> : <FontAwesomeIcon icon={faCheck} />}
                                                                  </button>
                                                                  <button
                                                                      onClick={handleCancelAddCommission}
                                                                      disabled={isAddingCommission}
                                                                      style={{
                                                                          padding: '4px 8px', borderRadius: '6px',
                                                                          border: '1px solid #e5e7eb', backgroundColor: '#fff',
                                                                          fontSize: `calc(11px * var(--font-scale))`, cursor: 'pointer', color: '#6b7280',
                                                                      }}
                                                                  >
                                                                      <FontAwesomeIcon icon={faArrowLeft} />
                                                                  </button>
                                                              </div>
                                                          ) : (
                                                              <button
                                                                  onClick={() => handleStartAddCommission(payment.id, servico.id)}
                                                                  style={{
                                                                      background: 'none', border: 'none', cursor: 'pointer',
                                                                      fontSize: `calc(11px * var(--font-scale))`, color: '#3b82f6', padding: 0,
                                                                      display: 'flex', alignItems: 'center', gap: '4px',
                                                                  }}
                                                              >
                                                                  <FontAwesomeIcon icon={faPlus} style={{ fontSize: `calc(10px * var(--font-scale))` }} />
                                                                  Adicionar Comissão
                                                              </button>
                                                          )}
                                                      </div>
                                                  )}
                                              </div>
                                          );
                                      })}
                                  </div>

                                  {/* Totais do pagamento */}
                                  {(payment.valor_adicional > 0 || payment.valor_desconto > 0) && (
                                      <div style={{ marginTop: '10px', padding: '10px 12px', borderRadius: '8px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                                          {payment.valor_adicional > 0 && (
                                              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', marginBottom: '4px' }}>
                                                  <span>Adicional{payment.descricao_valor_adicional ? ` (${payment.descricao_valor_adicional})` : ''}:</span>
                                                  <span>{formatCurrency(payment.valor_adicional)}</span>
                                              </div>
                                          )}
                                          {payment.valor_desconto > 0 && (
                                              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: `calc(12px * var(--font-scale))`, color: '#ef4444', marginBottom: '4px' }}>
                                                  <span>Desconto:</span>
                                                  <span>- {formatCurrency(payment.valor_desconto)}</span>
                                              </div>
                                          )}
                                      </div>
                                  )}
                              </div>
                          </div>
                      ))}
                  </div>
              ) : (
                  <div style={{ textAlign: 'center', padding: '40px 24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                      <FontAwesomeIcon icon={faMoneyBillWave} style={{ fontSize: '36px', color: '#d1d5db', marginBottom: '12px', display: 'block' }} />
                      <p style={{ margin: 0, fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af' }}>Nenhum detalhe de pagamento encontrado.</p>
                  </div>
              )}
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <button
                  onClick={handleClosePaymentDetailsModal}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Fechar
              </button>
          </Modal.Footer>
      </Modal>

      {/* Modal de Ações do Agendamento */}
      <Modal show={showActionsModal} onHide={() => setShowActionsModal(false)} centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #6b7280, #4b5563)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                      Ações do Agendamento
                  </Modal.Title>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              {selectedAppointmentForActions && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      {/* Info do paciente */}
                      <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #e5e7eb' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                              <div style={{
                                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                                  background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff',
                              }}>
                                  {selectedAppointmentForActions.paciente?.nome?.charAt(0)?.toUpperCase() || '?'}
                              </div>
                              <div>
                                  <div style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>
                                      {selectedAppointmentForActions.paciente?.nome}
                                  </div>
                                  {(() => {
                                      const colors = getStatusColors(selectedAppointmentForActions.status);
                                      return (
                                          <span style={{
                                              fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', padding: '1px 8px', borderRadius: '999px',
                                              backgroundColor: colors.bg + '22', color: colors.bg,
                                              border: `1px solid ${colors.bg}44`,
                                          }}>
                                              {selectedAppointmentForActions.status}
                                          </span>
                                      );
                                  })()}
                              </div>
                          </div>
                          <div style={{ display: 'flex', gap: '12px', fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280' }}>
                              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <FontAwesomeIcon icon={faClock} style={{ fontSize: `calc(10px * var(--font-scale))` }} />
                                  {selectedAppointmentForActions.hora_marcada.slice(0, 5)}
                              </span>
                              {selectedAppointmentForActions.hora_chegada && (
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#16a34a' }}>
                                      <FontAwesomeIcon icon={faCheck} style={{ fontSize: `calc(10px * var(--font-scale))` }} />
                                      Chegou às {new Date(selectedAppointmentForActions.hora_chegada).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                  </span>
                              )}
                          </div>
                      </div>

                      {/* Botões de ação */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {/* Check-in */}
                          {selectedAppointmentForActions.status === 'Agendada' && !selectedAppointmentForActions.hora_chegada && (
                              <SidebarActionButton
                                  onClick={() => { handleCheckIn(selectedAppointmentForActions.id); setShowActionsModal(false); }}
                                  disabled={loadingCheckIn[selectedAppointmentForActions.id]}
                                  loading={loadingCheckIn[selectedAppointmentForActions.id]}
                                  icon={faCheck}
                                  label="Fazer Check-in"
                                  color="#0ea5e9"
                                  bg="#f0f9ff"
                                  border="#bae6fd"
                              />
                          )}

                          {/* Chamar Paciente */}
                          {isCurrentUserCorpoClinico && selectedAppointmentForActions.medico_id === currentUser?.id && selectedAppointmentForActions.status === 'Agendada' && selectedAppointmentForActions.hora_chegada && (
                              <SidebarActionButton
                                  onClick={() => { handleChamarPaciente(selectedAppointmentForActions.id); }}
                                  disabled={loadingChamar[selectedAppointmentForActions.id]}
                                  loading={loadingChamar[selectedAppointmentForActions.id]}
                                  icon={faBullhorn}
                                  label="Chamar Painel"
                                  color="#8b5cf6"
                                  bg="#f5f3ff"
                                  border="#ddd6fe"
                              />
                          )}

                          {/* Iniciar Consulta */}
                          {isCurrentUserCorpoClinico && selectedAppointmentForActions.medico_id === currentUser?.id && selectedAppointmentForActions.status === 'Agendada' && (
                              <SidebarActionButton
                                  onClick={() => { handleIniciarConsulta(selectedAppointmentForActions.id); setShowActionsModal(false); }}
                                  disabled={loadingIniciarConsulta[selectedAppointmentForActions.id] || !selectedAppointmentForActions.hora_chegada}
                                  loading={loadingIniciarConsulta[selectedAppointmentForActions.id]}
                                  icon={faStethoscope}
                                  label="Iniciar Consulta"
                                  color={selectedAppointmentForActions.hora_chegada ? '#16a34a' : '#9ca3af'}
                                  bg={selectedAppointmentForActions.hora_chegada ? '#f0fdf4' : '#f9fafb'}
                                  border={selectedAppointmentForActions.hora_chegada ? '#bbf7d0' : '#e5e7eb'}
                              />
                          )}

                          {/* Pagamento */}
                          {(((selectedAppointmentForActions.status === 'Agendada' || selectedAppointmentForActions.status === 'Realizada') && selectedAppointmentForActions.payment_status === 'Aguardando Pagamento') ||
                            ((selectedAppointmentForActions.payment_status === 'Pago' || selectedAppointmentForActions.payment_status === 'Aguardando Pagamento') && selectedAppointmentForActions.status === 'Aguardando Pagamento')) ? (
                              canShowPayButton && (
                                  <SidebarActionButton
                                      onClick={() => { handleOpenPaymentModal(selectedAppointmentForActions); setShowActionsModal(false); }}
                                      icon={faDollarSign}
                                      label="Receber Pagamento"
                                      color="#ef4444"
                                      bg="#fef2f2"
                                      border="#fecaca"
                                  />
                              )
                          ) : (
                              (currentUserRole === 'Representante Legal' || currentUser?.is_gerente) && (
                                  <SidebarActionButton
                                      onClick={() => { handleOpenPaymentDetailsModal(selectedAppointmentForActions); setShowActionsModal(false); }}
                                      icon={faMoneyBillWave}
                                      label="Ver Detalhes do Pagamento"
                                      color="#0ea5e9"
                                      bg="#f0f9ff"
                                      border="#bae6fd"
                                  />
                              )
                          )}

                          {/* Reagendar */}
                          {selectedAppointmentForActions.status === 'Agendada' && !selectedAppointmentForActions.hora_chegada && (
                              <SidebarActionButton
                                  onClick={() => { handleOpenRescheduleModal(selectedAppointmentForActions); setShowActionsModal(false); }}
                                  icon={faCalendarAlt}
                                  label="Reagendar"
                                  color="#6b7280"
                                  bg="#f9fafb"
                                  border="#e5e7eb"
                              />
                          )}

                          {/* Alterar Profissional */}
                          {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && selectedAppointmentForActions.status === 'Agendada' && (
                              <SidebarActionButton
                                  onClick={() => {
                                      setAppointmentToChangeProf(selectedAppointmentForActions);
                                      setAvailableDoctors([]);
                                      setChangeProfError(null);
                                      setNewProfessionalId('');
                                      setShowChangeProfModal(true);
                                      setShowActionsModal(false);
                                  }}
                                  icon={faUserMd}
                                  label="Alterar Profissional"
                                  color="#374151"
                                  bg="#f9fafb"
                                  border="#e5e7eb"
                              />
                          )}

                          {/* Cancelar Pagamento */}
                          {selectedAppointmentForActions.payment_status === 'Pago' && canShowCancelPayButton &&
                              ((selectedAppointmentForActions.servicos?.length || 0) > 1 || !selectedAppointmentForActions.paciente_pacote_id || selectedAppointmentForActions.pagamento?.length > 0) && (
                              <SidebarActionButton
                                  onClick={() => { handleOpenCancelPaymentModal(selectedAppointmentForActions); setShowActionsModal(false); }}
                                  icon={faBan}
                                  label="Cancelar Pagamento"
                                  color="#f59e0b"
                                  bg="#fffbeb"
                                  border="#fde68a"
                              />
                          )}

                          {/* Cancelar / Faltou / Desmarcada */}
                          {selectedAppointmentForActions.status === 'Agendada' && (
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                                  <SidebarActionButton
                                      onClick={() => { handleStatusChange(selectedAppointmentForActions.id, 'Cancelada'); setShowActionsModal(false); }}
                                      disabled={loadingStatusChanges[selectedAppointmentForActions.id]}
                                      loading={loadingStatusChanges[selectedAppointmentForActions.id]}
                                      icon={faBan}
                                      label="Cancelar"
                                      color="#ef4444"
                                      bg="#fef2f2"
                                      border="#fecaca"
                                  />
                                  <SidebarActionButton
                                      onClick={() => { handleStatusChange(selectedAppointmentForActions.id, 'Faltou'); setShowActionsModal(false); }}
                                      disabled={loadingStatusChanges[selectedAppointmentForActions.id]}
                                      loading={loadingStatusChanges[selectedAppointmentForActions.id]}
                                      icon={faUserMd}
                                      label="Faltou"
                                      color="#6b7280"
                                      bg="#f9fafb"
                                      border="#e5e7eb"
                                  />
                              </div>
                          )}
                      </div>
                  </div>
              )}
          </Modal.Body>
      </Modal>


      {/* Context Menu */}
      {contextMenu && (
          <div style={{
              ...styles.contextMenu,
              top: contextMenu.y,
              left: contextMenu.x,
              borderRadius: '10px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
              padding: '6px',
              minWidth: '180px',
              fontFamily: "'Inter', 'Segoe UI', sans-serif",
          }}>
              {[
                  {
                      icon: faStethoscope,
                      label: 'Ver Prontuário',
                      color: '#374151',
                      onClick: () => {
                          setPatientForModal(contextMenu.appointment.paciente);
                          setShowProntuarioModal(true);
                          setContextMenu(null);
                      }
                  },
                  ...(((currentUserRole === 'Representante Legal' || currentUser?.is_gerente) &&
                    (contextMenu.appointment.payment_status === 'Pago' || contextMenu.appointment.payment_status === 'Parcial')) ? [{
                      icon: faMoneyBillWave,
                      label: 'Ver Detalhes Pagamento',
                      color: '#374151',
                      onClick: () => {
                          handleOpenPaymentDetailsModal(contextMenu.appointment);
                          setContextMenu(null);
                      }
                  }] : []),
                  ...(contextMenu.appointment.status === 'Agendada' && !contextMenu.appointment.hora_chegada ? [{
                      icon: faCalendarAlt,
                      label: 'Reagendar',
                      color: '#374151',
                      onClick: () => {
                          handleOpenRescheduleModal(contextMenu.appointment);
                          setContextMenu(null);
                      }
                  }] : []),
                  ...((currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && contextMenu.appointment.status === 'Agendada' ? [{
                      icon: faUserMd,
                      label: 'Alterar Profissional',
                      color: '#374151',
                      onClick: () => {
                          setAppointmentToChangeProf(contextMenu.appointment);
                          setAvailableDoctors([]);
                          setChangeProfError(null);
                          setNewProfessionalId('');
                          setShowChangeProfModal(true);
                          setContextMenu(null);
                      }
                  }] : []),
              ].map((item, idx) => (
                  <button
                      key={idx}
                      onClick={item.onClick}
                      style={{
                          width: '100%', padding: '8px 10px', borderRadius: '6px',
                          border: 'none', backgroundColor: 'transparent',
                          cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500',
                          color: item.color, display: 'flex', alignItems: 'center', gap: '8px',
                          textAlign: 'left', transition: 'background 0.1s',
                      }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                      <FontAwesomeIcon icon={item.icon} style={{ width: '14px', fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }} />
                      {item.label}
                  </button>
              ))}

              {/* Divider */}
              <div style={{ height: '1px', backgroundColor: '#f3f4f6', margin: '4px 0' }} />

              {/* Cancelar */}
              <button
                  onClick={() => { handleStatusChange(contextMenu.appointment.id, 'Cancelada'); setContextMenu(null); }}
                  style={{
                      width: '100%', padding: '8px 10px', borderRadius: '6px',
                      border: 'none', backgroundColor: 'transparent',
                      cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500',
                      color: '#ef4444', display: 'flex', alignItems: 'center', gap: '8px',
                      textAlign: 'left', transition: 'background 0.1s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#fef2f2'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                  <FontAwesomeIcon icon={faBan} style={{ width: '14px', fontSize: `calc(11px * var(--font-scale))`, color: '#ef4444' }} />
                  Cancelar
              </button>

              {/* Faltou */}
              <button
                  onClick={() => { handleStatusChange(contextMenu.appointment.id, 'Faltou'); setContextMenu(null); }}
                  style={{
                      width: '100%', padding: '8px 10px', borderRadius: '6px',
                      border: 'none', backgroundColor: 'transparent',
                      cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '500',
                      color: '#6b7280', display: 'flex', alignItems: 'center', gap: '8px',
                      textAlign: 'left', transition: 'background 0.1s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                  <FontAwesomeIcon icon={faUserMd} style={{ width: '14px', fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }} />
                  Faltou
              </button>
          </div>
      )}


      <ProntuarioVisualizacaoModal 
          show={showProntuarioModal}
          onHide={() => setShowProntuarioModal(false)}
          paciente={patientForModal}
      />

      {/* Modal Histórico de Pacotes */}
      <Modal show={showPackageHistoryModal} onHide={() => setShowPackageHistoryModal(false)} size="lg" centered>
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                      width: '32px', height: '32px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#fff', fontSize: `calc(14px * var(--font-scale))` }} />
                  </div>
                  <div>
                      <Modal.Title style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#111827', margin: 0 }}>
                          Histórico de Pacotes
                      </Modal.Title>
                      {selectedSidebarAppointment?.paciente?.nome && (
                          <div style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', marginTop: '1px' }}>
                              {selectedSidebarAppointment.paciente.nome}
                          </div>
                      )}
                  </div>
              </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
              {isLoadingPackageHistory ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px', gap: '12px' }}>
                      <Spinner animation="border" variant="primary" size="sm" />
                      <span style={{ color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))` }}>Carregando histórico...</span>
                  </div>
              ) : packageHistoryData.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {packageHistoryData.map((pacote, index) => (
                          <div key={pacote.id} style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                              {/* Header do pacote */}
                              <div style={{ padding: '12px 16px', backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <div style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>{pacote.servico.nome}</div>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{
                                          fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', padding: '2px 8px', borderRadius: '999px',
                                          backgroundColor: pacote.status === 'Ativo' ? '#dcfce7' : '#f3f4f6',
                                          color: pacote.status === 'Ativo' ? '#16a34a' : '#6b7280',
                                      }}>
                                          {pacote.status}
                                      </span>
                                      <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>
                                          {pacote.sessoes_utilizadas} / {pacote.sessoes_contratadas} sessões
                                      </span>
                                  </div>
                              </div>
                              {/* Progresso */}
                              <div style={{ padding: '8px 16px', borderBottom: '1px solid #f3f4f6' }}>
                                  <div style={{ height: '6px', backgroundColor: '#f3f4f6', borderRadius: '999px', overflow: 'hidden' }}>
                                      <div style={{
                                          height: '100%', borderRadius: '999px',
                                          width: `${(pacote.sessoes_utilizadas / pacote.sessoes_contratadas) * 100}%`,
                                          backgroundColor: pacote.status === 'Ativo' ? '#3b82f6' : '#9ca3af',
                                          transition: 'width 0.3s ease',
                                      }} />
                                  </div>
                              </div>
                              {/* Sessões utilizadas */}
                              {pacote.agendamentos_utilizados && pacote.agendamentos_utilizados.length > 0 ? (
                                  <div>
                                      {pacote.agendamentos_utilizados.map((ag, idx, arr) => (
                                          <div key={ag.id} style={{
                                              display: 'flex', alignItems: 'center', gap: '12px',
                                              padding: '8px 16px',
                                              borderBottom: idx < arr.length - 1 ? '1px solid #f3f4f6' : 'none',
                                          }}>
                                              <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#374151', fontWeight: '500', minWidth: '80px' }}>
                                                  {new Date(ag.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')}
                                              </span>
                                              <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', minWidth: '40px' }}>
                                                  {ag.hora_marcada.slice(0, 5)}
                                              </span>
                                              <span style={{
                                                  fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', padding: '2px 8px', borderRadius: '999px',
                                                  backgroundColor: getStatusColors(ag.status).bg + '22',
                                                  color: getStatusColors(ag.status).bg,
                                              }}>
                                                  {ag.status}
                                              </span>
                                          </div>
                                      ))}
                                  </div>
                              ) : (
                                  <div style={{ padding: '12px 16px', fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af' }}>
                                      Nenhuma sessão utilizada registrada.
                                  </div>
                              )}
                          </div>
                      ))}
                  </div>
              ) : (
                  <div style={{ textAlign: 'center', padding: '40px 24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '36px', color: '#d1d5db', marginBottom: '12px', display: 'block' }} />
                      <p style={{ margin: 0, fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af' }}>Nenhum histórico de pacotes encontrado.</p>
                  </div>
              )}
          </Modal.Body>
          <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <button
                  onClick={() => setShowPackageHistoryModal(false)}
                  style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500' }}
              >
                  Fechar
              </button>
          </Modal.Footer>
      </Modal>

    </>
  );
};

export default AgendasCardTab;
